var cc = Object.defineProperty, lc = (e, t, r) => t in e ? cc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, mt = (e, t, r) => lc(e, typeof t != "symbol" ? t + "" : t, r), pc = (e, t, r) => new Promise((n, i) => {
  var o = (c) => {
    try {
      u(r.next(c));
    } catch (s) {
      i(s);
    }
  }, a = (c) => {
    try {
      u(r.throw(c));
    } catch (s) {
      i(s);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(o, a);
  u((r = r.apply(e, t)).next());
});
const uo = /* @__PURE__ */ Object.create(null), Rt = (e, t, ...r) => {
  const n = `[@launchdarkly plugins]: (${e}): `;
  console[t].apply(console, [n, ...r]), fc(n, ...r);
}, gt = (e, t, r, ...n) => {
  uo[`${e}-${t}`] || (uo[`${e}-${t}`] = !0, Rt(e, r, ...n));
}, fc = (e, ...t) => pc(void 0, null, function* () {
  try {
    const { LDObserve: r } = yield Promise.resolve().then(() => Ip);
    r.recordLog(`${e}${t}`, "warn");
  } catch {
  }
});
class hc {
  constructor(t, r) {
    mt(this, "debug"), mt(this, "name"), this.debug = t, this.name = r;
  }
  log(...t) {
    if (this.debug) {
      let r = `[${Date.now()}]`;
      this.name && (r += ` - ${this.name}`), console.log.apply(console, [r, ...t]);
    }
  }
  warn(...t) {
    let r = `[${Date.now()}]`;
    this.name && (r += ` - ${this.name}`), console.warn.apply(console, [r, ...t]);
  }
}
let Qa = class {
  constructor() {
    mt(this, "_sdk"), mt(this, "_isLoaded", !1), mt(this, "_callBuffer", []), mt(this, "_capacity", 1e5), mt(this, "_droppedEvents", 0), mt(this, "_exceededCapacity", !1), mt(this, "_logger", new hc());
  }
  _bufferCall(t, r) {
    if (this._isLoaded)
      try {
        return this._sdk[t](...r);
      } catch (n) {
        Rt(
          `Error executing buffered call to ${t}:`,
          "error",
          n
        );
      }
    else {
      this._enqueue({ method: t, args: r });
      return;
    }
  }
  _enqueue(t) {
    this._callBuffer.length < this._capacity ? (this._callBuffer.push(t), this._exceededCapacity = !1) : (this._exceededCapacity || (this._exceededCapacity = !0, Rt(
      "Exceeded event queue capacity. Increase capacity to avoid dropping events.",
      "warn"
    )), this._droppedEvents += 1);
  }
  load(t) {
    this._sdk = t, this._isLoaded = !0;
    for (const { method: r, args: n } of this._callBuffer)
      try {
        this._sdk[r](...n);
      } catch (i) {
        Rt(
          `Error executing buffered call to ${r}:`,
          "error",
          i
        );
      }
    this._callBuffer = [];
  }
};
var dc = Object.defineProperty, vc = Object.defineProperties, mc = Object.getOwnPropertyDescriptors, br = Object.getOwnPropertySymbols, Za = Object.prototype.hasOwnProperty, ts = Object.prototype.propertyIsEnumerable, Wn = (e, t, r) => t in e ? dc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, L = (e, t) => {
  for (var r in t || (t = {}))
    Za.call(t, r) && Wn(e, r, t[r]);
  if (br)
    for (var r of br(t))
      ts.call(t, r) && Wn(e, r, t[r]);
  return e;
}, oe = (e, t) => vc(e, mc(t)), Re = (e, t) => {
  var r = {};
  for (var n in e)
    Za.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && br)
    for (var n of br(e))
      t.indexOf(n) < 0 && ts.call(e, n) && (r[n] = e[n]);
  return r;
}, Me = (e, t, r) => Wn(e, typeof t != "symbol" ? t + "" : t, r), le = (e, t, r) => new Promise((n, i) => {
  var o = (c) => {
    try {
      u(r.next(c));
    } catch (s) {
      i(s);
    }
  }, a = (c) => {
    try {
      u(r.throw(c));
    } catch (s) {
      i(s);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(o, a);
  u((r = r.apply(e, t)).next());
});
function yc(e, t) {
  for (var r = 0; r < t.length; r++) {
    const n = t[r];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const i in n)
        if (i !== "default" && !(i in e)) {
          const o = Object.getOwnPropertyDescriptor(n, i);
          o && Object.defineProperty(e, i, o.get ? o : {
            enumerable: !0,
            get: () => n[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
function fr(e, t) {
  throw new Error(t);
}
function _c(e) {
  return typeof e == "object" && e !== null;
}
function gc(e, t) {
  throw new Error(
    "Unexpected invariant triggered."
  );
}
const Ec = /\r\n|[\n\r]/g;
function Yn(e, t) {
  let r = 0, n = 1;
  for (const i of e.body.matchAll(Ec)) {
    if (typeof i.index == "number" || gc(), i.index >= t)
      break;
    r = i.index + i[0].length, n += 1;
  }
  return {
    line: n,
    column: t + 1 - r
  };
}
function Tc(e) {
  return es(
    e.source,
    Yn(e.source, e.start)
  );
}
function es(e, t) {
  const r = e.locationOffset.column - 1, n = "".padStart(r) + e.body, i = t.line - 1, o = e.locationOffset.line - 1, a = t.line + o, u = t.line === 1 ? r : 0, c = t.column + u, s = `${e.name}:${a}:${c}
`, l = n.split(/\r\n|[\n\r]/g), p = l[i];
  if (p.length > 120) {
    const f = Math.floor(c / 80), m = c % 80, v = [];
    for (let y = 0; y < p.length; y += 80)
      v.push(p.slice(y, y + 80));
    return s + co([
      [`${a} |`, v[0]],
      ...v.slice(1, f + 1).map((y) => ["|", y]),
      ["|", "^".padStart(m)],
      ["|", v[f + 1]]
    ]);
  }
  return s + co([
    // Lines specified like this: ["prefix", "string"],
    [`${a - 1} |`, l[i - 1]],
    [`${a} |`, p],
    ["|", "^".padStart(c)],
    [`${a + 1} |`, l[i + 1]]
  ]);
}
function co(e) {
  const t = e.filter(([n, i]) => i !== void 0), r = Math.max(...t.map(([n]) => n.length));
  return t.map(([n, i]) => n.padStart(r) + (i ? " " + i : "")).join(`
`);
}
function bc(e) {
  const t = e[0];
  return t == null || "kind" in t || "length" in t ? {
    nodes: t,
    source: e[1],
    positions: e[2],
    path: e[3],
    originalError: e[4],
    extensions: e[5]
  } : t;
}
let Oc = class rs extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(t, ...r) {
    var n, i, o;
    const { nodes: a, source: u, positions: c, path: s, originalError: l, extensions: p } = bc(r);
    super(t), this.name = "GraphQLError", this.path = s ?? void 0, this.originalError = l ?? void 0, this.nodes = lo(
      Array.isArray(a) ? a : a ? [a] : void 0
    );
    const f = lo(
      (n = this.nodes) === null || n === void 0 ? void 0 : n.map((v) => v.loc).filter((v) => v != null)
    );
    this.source = u ?? (f == null || (i = f[0]) === null || i === void 0 ? void 0 : i.source), this.positions = c ?? f?.map((v) => v.start), this.locations = c && u ? c.map((v) => Yn(u, v)) : f?.map((v) => Yn(v.source, v.start));
    const m = _c(
      l?.extensions
    ) ? l?.extensions : void 0;
    this.extensions = (o = p ?? m) !== null && o !== void 0 ? o : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), l != null && l.stack ? Object.defineProperty(this, "stack", {
      value: l.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, rs) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let t = this.message;
    if (this.nodes)
      for (const r of this.nodes)
        r.loc && (t += `

` + Tc(r.loc));
    else if (this.source && this.locations)
      for (const r of this.locations)
        t += `

` + es(this.source, r);
    return t;
  }
  toJSON() {
    const t = {
      message: this.message
    };
    return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
  }
};
function lo(e) {
  return e === void 0 || e.length === 0 ? void 0 : e;
}
function G(e, t, r) {
  return new Oc(`Syntax Error: ${r}`, {
    source: e,
    positions: [t]
  });
}
let Sc = class {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(t, r, n) {
    this.start = t.start, this.end = r.end, this.startToken = t, this.endToken = r, this.source = n;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
};
class ns {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(t, r, n, i, o, a) {
    this.kind = t, this.start = r, this.end = n, this.line = i, this.column = o, this.value = a, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const is = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, wc = new Set(Object.keys(is));
function po(e) {
  const t = e?.kind;
  return typeof t == "string" && wc.has(t);
}
var re;
(function(e) {
  e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
})(re || (re = {}));
var Jn;
(function(e) {
  e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(Jn || (Jn = {}));
var O;
(function(e) {
  e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(O || (O = {}));
function Qn(e) {
  return e === 9 || e === 32;
}
function ke(e) {
  return e >= 48 && e <= 57;
}
function os(e) {
  return e >= 97 && e <= 122 || // A-Z
  e >= 65 && e <= 90;
}
function as(e) {
  return os(e) || e === 95;
}
function Ac(e) {
  return os(e) || ke(e) || e === 95;
}
function Lc(e) {
  var t;
  let r = Number.MAX_SAFE_INTEGER, n = null, i = -1;
  for (let a = 0; a < e.length; ++a) {
    var o;
    const u = e[a], c = Rc(u);
    c !== u.length && (n = (o = n) !== null && o !== void 0 ? o : a, i = a, a !== 0 && c < r && (r = c));
  }
  return e.map((a, u) => u === 0 ? a : a.slice(r)).slice(
    (t = n) !== null && t !== void 0 ? t : 0,
    i + 1
  );
}
function Rc(e) {
  let t = 0;
  for (; t < e.length && Qn(e.charCodeAt(t)); )
    ++t;
  return t;
}
function Cc(e, t) {
  const r = e.replace(/"""/g, '\\"""'), n = r.split(/\r\n|[\n\r]/g), i = n.length === 1, o = n.length > 1 && n.slice(1).every((m) => m.length === 0 || Qn(m.charCodeAt(0))), a = r.endsWith('\\"""'), u = e.endsWith('"') && !a, c = e.endsWith("\\"), s = u || c, l = (
    // add leading and trailing new lines only if it improves readability
    !i || e.length > 70 || s || o || a
  );
  let p = "";
  const f = i && Qn(e.charCodeAt(0));
  return (l && !f || o) && (p += `
`), p += r, (l || s) && (p += `
`), '"""' + p + '"""';
}
var d;
(function(e) {
  e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
})(d || (d = {}));
let Nc = class {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(t) {
    const r = new ns(d.SOF, 0, 0, 0, 0);
    this.source = t, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let t = this.token;
    if (t.kind !== d.EOF)
      do
        if (t.next)
          t = t.next;
        else {
          const r = Pc(this, t.end);
          t.next = r, r.prev = t, t = r;
        }
      while (t.kind === d.COMMENT);
    return t;
  }
};
function xc(e) {
  return e === d.BANG || e === d.DOLLAR || e === d.AMP || e === d.PAREN_L || e === d.PAREN_R || e === d.SPREAD || e === d.COLON || e === d.EQUALS || e === d.AT || e === d.BRACKET_L || e === d.BRACKET_R || e === d.BRACE_L || e === d.PIPE || e === d.BRACE_R;
}
function de(e) {
  return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
}
function Br(e, t) {
  return ss(e.charCodeAt(t)) && us(e.charCodeAt(t + 1));
}
function ss(e) {
  return e >= 55296 && e <= 56319;
}
function us(e) {
  return e >= 56320 && e <= 57343;
}
function $t(e, t) {
  const r = e.source.body.codePointAt(t);
  if (r === void 0)
    return d.EOF;
  if (r >= 32 && r <= 126) {
    const n = String.fromCodePoint(r);
    return n === '"' ? `'"'` : `"${n}"`;
  }
  return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
}
function B(e, t, r, n, i) {
  const o = e.line, a = 1 + r - e.lineStart;
  return new ns(t, r, n, o, a, i);
}
function Pc(e, t) {
  const r = e.source.body, n = r.length;
  let i = t;
  for (; i < n; ) {
    const o = r.charCodeAt(i);
    switch (o) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++i;
        continue;
      case 10:
        ++i, ++e.line, e.lineStart = i;
        continue;
      case 13:
        r.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
        continue;
      case 35:
        return Ic(e, i);
      case 33:
        return B(e, d.BANG, i, i + 1);
      case 36:
        return B(e, d.DOLLAR, i, i + 1);
      case 38:
        return B(e, d.AMP, i, i + 1);
      case 40:
        return B(e, d.PAREN_L, i, i + 1);
      case 41:
        return B(e, d.PAREN_R, i, i + 1);
      case 46:
        if (r.charCodeAt(i + 1) === 46 && r.charCodeAt(i + 2) === 46)
          return B(e, d.SPREAD, i, i + 3);
        break;
      case 58:
        return B(e, d.COLON, i, i + 1);
      case 61:
        return B(e, d.EQUALS, i, i + 1);
      case 64:
        return B(e, d.AT, i, i + 1);
      case 91:
        return B(e, d.BRACKET_L, i, i + 1);
      case 93:
        return B(e, d.BRACKET_R, i, i + 1);
      case 123:
        return B(e, d.BRACE_L, i, i + 1);
      case 124:
        return B(e, d.PIPE, i, i + 1);
      case 125:
        return B(e, d.BRACE_R, i, i + 1);
      case 34:
        return r.charCodeAt(i + 1) === 34 && r.charCodeAt(i + 2) === 34 ? $c(e, i) : kc(e, i);
    }
    if (ke(o) || o === 45)
      return Mc(e, i, o);
    if (as(o))
      return Bc(e, i);
    throw G(
      e.source,
      i,
      o === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : de(o) || Br(r, i) ? `Unexpected character: ${$t(e, i)}.` : `Invalid character: ${$t(e, i)}.`
    );
  }
  return B(e, d.EOF, n, n);
}
function Ic(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const o = r.charCodeAt(i);
    if (o === 10 || o === 13)
      break;
    if (de(o))
      ++i;
    else if (Br(r, i))
      i += 2;
    else
      break;
  }
  return B(
    e,
    d.COMMENT,
    t,
    i,
    r.slice(t + 1, i)
  );
}
function Mc(e, t, r) {
  const n = e.source.body;
  let i = t, o = r, a = !1;
  if (o === 45 && (o = n.charCodeAt(++i)), o === 48) {
    if (o = n.charCodeAt(++i), ke(o))
      throw G(
        e.source,
        i,
        `Invalid number, unexpected digit after 0: ${$t(
          e,
          i
        )}.`
      );
  } else
    i = Qr(e, i, o), o = n.charCodeAt(i);
  if (o === 46 && (a = !0, o = n.charCodeAt(++i), i = Qr(e, i, o), o = n.charCodeAt(i)), (o === 69 || o === 101) && (a = !0, o = n.charCodeAt(++i), (o === 43 || o === 45) && (o = n.charCodeAt(++i)), i = Qr(e, i, o), o = n.charCodeAt(i)), o === 46 || as(o))
    throw G(
      e.source,
      i,
      `Invalid number, expected digit but got: ${$t(
        e,
        i
      )}.`
    );
  return B(
    e,
    a ? d.FLOAT : d.INT,
    t,
    i,
    n.slice(t, i)
  );
}
function Qr(e, t, r) {
  if (!ke(r))
    throw G(
      e.source,
      t,
      `Invalid number, expected digit but got: ${$t(
        e,
        t
      )}.`
    );
  const n = e.source.body;
  let i = t + 1;
  for (; ke(n.charCodeAt(i)); )
    ++i;
  return i;
}
function kc(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1, o = i, a = "";
  for (; i < n; ) {
    const u = r.charCodeAt(i);
    if (u === 34)
      return a += r.slice(o, i), B(e, d.STRING, t, i + 1, a);
    if (u === 92) {
      a += r.slice(o, i);
      const c = r.charCodeAt(i + 1) === 117 ? r.charCodeAt(i + 2) === 123 ? Dc(e, i) : Uc(e, i) : jc(e, i);
      a += c.value, i += c.size, o = i;
      continue;
    }
    if (u === 10 || u === 13)
      break;
    if (de(u))
      ++i;
    else if (Br(r, i))
      i += 2;
    else
      throw G(
        e.source,
        i,
        `Invalid character within String: ${$t(
          e,
          i
        )}.`
      );
  }
  throw G(e.source, i, "Unterminated string.");
}
function Dc(e, t) {
  const r = e.source.body;
  let n = 0, i = 3;
  for (; i < 12; ) {
    const o = r.charCodeAt(t + i++);
    if (o === 125) {
      if (i < 5 || !de(n))
        break;
      return {
        value: String.fromCodePoint(n),
        size: i
      };
    }
    if (n = n << 4 | Ae(o), n < 0)
      break;
  }
  throw G(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(
      t,
      t + i
    )}".`
  );
}
function Uc(e, t) {
  const r = e.source.body, n = fo(r, t + 2);
  if (de(n))
    return {
      value: String.fromCodePoint(n),
      size: 6
    };
  if (ss(n) && r.charCodeAt(t + 6) === 92 && r.charCodeAt(t + 7) === 117) {
    const i = fo(r, t + 8);
    if (us(i))
      return {
        value: String.fromCodePoint(n, i),
        size: 12
      };
  }
  throw G(
    e.source,
    t,
    `Invalid Unicode escape sequence: "${r.slice(t, t + 6)}".`
  );
}
function fo(e, t) {
  return Ae(e.charCodeAt(t)) << 12 | Ae(e.charCodeAt(t + 1)) << 8 | Ae(e.charCodeAt(t + 2)) << 4 | Ae(e.charCodeAt(t + 3));
}
function Ae(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
}
function jc(e, t) {
  const r = e.source.body;
  switch (r.charCodeAt(t + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw G(
    e.source,
    t,
    `Invalid character escape sequence: "${r.slice(
      t,
      t + 2
    )}".`
  );
}
function $c(e, t) {
  const r = e.source.body, n = r.length;
  let i = e.lineStart, o = t + 3, a = o, u = "";
  const c = [];
  for (; o < n; ) {
    const s = r.charCodeAt(o);
    if (s === 34 && r.charCodeAt(o + 1) === 34 && r.charCodeAt(o + 2) === 34) {
      u += r.slice(a, o), c.push(u);
      const l = B(
        e,
        d.BLOCK_STRING,
        t,
        o + 3,
        // Return a string of the lines joined with U+000A.
        Lc(c).join(`
`)
      );
      return e.line += c.length - 1, e.lineStart = i, l;
    }
    if (s === 92 && r.charCodeAt(o + 1) === 34 && r.charCodeAt(o + 2) === 34 && r.charCodeAt(o + 3) === 34) {
      u += r.slice(a, o), a = o + 1, o += 4;
      continue;
    }
    if (s === 10 || s === 13) {
      u += r.slice(a, o), c.push(u), s === 13 && r.charCodeAt(o + 1) === 10 ? o += 2 : ++o, u = "", a = o, i = o;
      continue;
    }
    if (de(s))
      ++o;
    else if (Br(r, o))
      o += 2;
    else
      throw G(
        e.source,
        o,
        `Invalid character within String: ${$t(
          e,
          o
        )}.`
      );
  }
  throw G(e.source, o, "Unterminated string.");
}
function Bc(e, t) {
  const r = e.source.body, n = r.length;
  let i = t + 1;
  for (; i < n; ) {
    const o = r.charCodeAt(i);
    if (Ac(o))
      ++i;
    else
      break;
  }
  return B(
    e,
    d.NAME,
    t,
    i,
    r.slice(t, i)
  );
}
const Fc = 10, cs = 2;
function Ui(e) {
  return Fr(e, []);
}
function Fr(e, t) {
  switch (typeof e) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? `[function ${e.name}]` : "[function]";
    case "object":
      return Vc(e, t);
    default:
      return String(e);
  }
}
function Vc(e, t) {
  if (e === null)
    return "null";
  if (t.includes(e))
    return "[Circular]";
  const r = [...t, e];
  if (Gc(e)) {
    const n = e.toJSON();
    if (n !== e)
      return typeof n == "string" ? n : Fr(n, r);
  } else if (Array.isArray(e))
    return zc(e, r);
  return Hc(e, r);
}
function Gc(e) {
  return typeof e.toJSON == "function";
}
function Hc(e, t) {
  const r = Object.entries(e);
  return r.length === 0 ? "{}" : t.length > cs ? "[" + Xc(e) + "]" : "{ " + r.map(
    ([n, i]) => n + ": " + Fr(i, t)
  ).join(", ") + " }";
}
function zc(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > cs)
    return "[Array]";
  const r = Math.min(Fc, e.length), n = e.length - r, i = [];
  for (let o = 0; o < r; ++o)
    i.push(Fr(e[o], t));
  return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
}
function Xc(e) {
  const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    const r = e.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return t;
}
const qc = globalThis.process && // eslint-disable-next-line no-undef
process.env.NODE_ENV === "production", Kc = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  qc ? function(e, t) {
    return e instanceof t;
  } : function(e, t) {
    if (e instanceof t)
      return !0;
    if (typeof e == "object" && e !== null) {
      var r;
      const n = t.prototype[Symbol.toStringTag], i = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in e ? e[Symbol.toStringTag] : (r = e.constructor) === null || r === void 0 ? void 0 : r.name
      );
      if (n === i) {
        const o = Ui(e);
        throw new Error(`Cannot use ${n} "${o}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
let ls = class {
  constructor(t, r = "GraphQL request", n = {
    line: 1,
    column: 1
  }) {
    typeof t == "string" || fr(!1, `Body must be a string. Received: ${Ui(t)}.`), this.body = t, this.name = r, this.locationOffset = n, this.locationOffset.line > 0 || fr(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || fr(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
};
function Wc(e) {
  return Kc(e, ls);
}
function ji(e, t) {
  const r = new Yc(e, t), n = r.parseDocument();
  return Object.defineProperty(n, "tokenCount", {
    enumerable: !1,
    value: r.tokenCount
  }), n;
}
let Yc = class {
  constructor(t, r = {}) {
    const n = Wc(t) ? t : new ls(t);
    this._lexer = new Nc(n), this._options = r, this._tokenCounter = 0;
  }
  get tokenCount() {
    return this._tokenCounter;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const t = this.expectToken(d.NAME);
    return this.node(t, {
      kind: O.NAME,
      value: t.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: O.DOCUMENT,
      definitions: this.many(
        d.SOF,
        this.parseDefinition,
        d.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(d.BRACE_L))
      return this.parseOperationDefinition();
    const t = this.peekDescription(), r = t ? this._lexer.lookahead() : this._lexer.token;
    if (r.kind === d.NAME) {
      switch (r.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (t)
        throw G(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (r.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(r);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const t = this._lexer.token;
    if (this.peek(d.BRACE_L))
      return this.node(t, {
        kind: O.OPERATION_DEFINITION,
        operation: re.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const r = this.parseOperationType();
    let n;
    return this.peek(d.NAME) && (n = this.parseName()), this.node(t, {
      kind: O.OPERATION_DEFINITION,
      operation: r,
      name: n,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const t = this.expectToken(d.NAME);
    switch (t.value) {
      case "query":
        return re.QUERY;
      case "mutation":
        return re.MUTATION;
      case "subscription":
        return re.SUBSCRIPTION;
    }
    throw this.unexpected(t);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      d.PAREN_L,
      this.parseVariableDefinition,
      d.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: O.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(d.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(d.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const t = this._lexer.token;
    return this.expectToken(d.DOLLAR), this.node(t, {
      kind: O.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: O.SELECTION_SET,
      selections: this.many(
        d.BRACE_L,
        this.parseSelection,
        d.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(d.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const t = this._lexer.token, r = this.parseName();
    let n, i;
    return this.expectOptionalToken(d.COLON) ? (n = r, i = this.parseName()) : i = r, this.node(t, {
      kind: O.FIELD,
      alias: n,
      name: i,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(d.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(t) {
    const r = t ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(d.PAREN_L, r, d.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(t = !1) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(d.COLON), this.node(r, {
      kind: O.ARGUMENT,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const t = this._lexer.token;
    this.expectToken(d.SPREAD);
    const r = this.expectOptionalKeyword("on");
    return !r && this.peek(d.NAME) ? this.node(t, {
      kind: O.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(t, {
      kind: O.INLINE_FRAGMENT,
      typeCondition: r ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const t = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
      kind: O.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(t, {
      kind: O.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(t) {
    const r = this._lexer.token;
    switch (r.kind) {
      case d.BRACKET_L:
        return this.parseList(t);
      case d.BRACE_L:
        return this.parseObject(t);
      case d.INT:
        return this.advanceLexer(), this.node(r, {
          kind: O.INT,
          value: r.value
        });
      case d.FLOAT:
        return this.advanceLexer(), this.node(r, {
          kind: O.FLOAT,
          value: r.value
        });
      case d.STRING:
      case d.BLOCK_STRING:
        return this.parseStringLiteral();
      case d.NAME:
        switch (this.advanceLexer(), r.value) {
          case "true":
            return this.node(r, {
              kind: O.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(r, {
              kind: O.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(r, {
              kind: O.NULL
            });
          default:
            return this.node(r, {
              kind: O.ENUM,
              value: r.value
            });
        }
      case d.DOLLAR:
        if (t)
          if (this.expectToken(d.DOLLAR), this._lexer.token.kind === d.NAME) {
            const n = this._lexer.token.value;
            throw G(
              this._lexer.source,
              r.start,
              `Unexpected variable "$${n}" in constant value.`
            );
          } else
            throw this.unexpected(r);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const t = this._lexer.token;
    return this.advanceLexer(), this.node(t, {
      kind: O.STRING,
      value: t.value,
      block: t.kind === d.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(t) {
    const r = () => this.parseValueLiteral(t);
    return this.node(this._lexer.token, {
      kind: O.LIST,
      values: this.any(d.BRACKET_L, r, d.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(t) {
    const r = () => this.parseObjectField(t);
    return this.node(this._lexer.token, {
      kind: O.OBJECT,
      fields: this.any(d.BRACE_L, r, d.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(t) {
    const r = this._lexer.token, n = this.parseName();
    return this.expectToken(d.COLON), this.node(r, {
      kind: O.OBJECT_FIELD,
      name: n,
      value: this.parseValueLiteral(t)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(t) {
    const r = [];
    for (; this.peek(d.AT); )
      r.push(this.parseDirective(t));
    return r;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(t) {
    const r = this._lexer.token;
    return this.expectToken(d.AT), this.node(r, {
      kind: O.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(t)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const t = this._lexer.token;
    let r;
    if (this.expectOptionalToken(d.BRACKET_L)) {
      const n = this.parseTypeReference();
      this.expectToken(d.BRACKET_R), r = this.node(t, {
        kind: O.LIST_TYPE,
        type: n
      });
    } else
      r = this.parseNamedType();
    return this.expectOptionalToken(d.BANG) ? this.node(t, {
      kind: O.NON_NULL_TYPE,
      type: r
    }) : r;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: O.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(d.STRING) || this.peek(d.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("schema");
    const n = this.parseConstDirectives(), i = this.many(
      d.BRACE_L,
      this.parseOperationTypeDefinition,
      d.BRACE_R
    );
    return this.node(t, {
      kind: O.SCHEMA_DEFINITION,
      description: r,
      directives: n,
      operationTypes: i
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const t = this._lexer.token, r = this.parseOperationType();
    this.expectToken(d.COLON);
    const n = this.parseNamedType();
    return this.node(t, {
      kind: O.OPERATION_TYPE_DEFINITION,
      operation: r,
      type: n
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("scalar");
    const n = this.parseName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: O.SCALAR_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("type");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(t, {
      kind: O.OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: o,
      fields: a
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(d.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      d.BRACE_L,
      this.parseFieldDefinition,
      d.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
    this.expectToken(d.COLON);
    const o = this.parseTypeReference(), a = this.parseConstDirectives();
    return this.node(t, {
      kind: O.FIELD_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      type: o,
      directives: a
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      d.PAREN_L,
      this.parseInputValueDef,
      d.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseName();
    this.expectToken(d.COLON);
    const i = this.parseTypeReference();
    let o;
    this.expectOptionalToken(d.EQUALS) && (o = this.parseConstValueLiteral());
    const a = this.parseConstDirectives();
    return this.node(t, {
      kind: O.INPUT_VALUE_DEFINITION,
      description: r,
      name: n,
      type: i,
      defaultValue: o,
      directives: a
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("interface");
    const n = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    return this.node(t, {
      kind: O.INTERFACE_TYPE_DEFINITION,
      description: r,
      name: n,
      interfaces: i,
      directives: o,
      fields: a
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("union");
    const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseUnionMemberTypes();
    return this.node(t, {
      kind: O.UNION_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      types: o
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(d.EQUALS) ? this.delimitedMany(d.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("enum");
    const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseEnumValuesDefinition();
    return this.node(t, {
      kind: O.ENUM_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      values: o
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      d.BRACE_L,
      this.parseEnumValueDefinition,
      d.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const t = this._lexer.token, r = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
    return this.node(t, {
      kind: O.ENUM_VALUE_DEFINITION,
      description: r,
      name: n,
      directives: i
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw G(
        this._lexer.source,
        this._lexer.token.start,
        `${Ze(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("input");
    const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseInputFieldsDefinition();
    return this.node(t, {
      kind: O.INPUT_OBJECT_TYPE_DEFINITION,
      description: r,
      name: n,
      directives: i,
      fields: o
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      d.BRACE_L,
      this.parseInputValueDef,
      d.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const t = this._lexer.lookahead();
    if (t.kind === d.NAME)
      switch (t.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(t);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const r = this.parseConstDirectives(), n = this.optionalMany(
      d.BRACE_L,
      this.parseOperationTypeDefinition,
      d.BRACE_R
    );
    if (r.length === 0 && n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: O.SCHEMA_EXTENSION,
      directives: r,
      operationTypes: n
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const r = this.parseName(), n = this.parseConstDirectives();
    if (n.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: O.SCALAR_TYPE_EXTENSION,
      name: r,
      directives: n
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: O.OBJECT_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: o
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
    if (n.length === 0 && i.length === 0 && o.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: O.INTERFACE_TYPE_EXTENSION,
      name: r,
      interfaces: n,
      directives: i,
      fields: o
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: O.UNION_TYPE_EXTENSION,
      name: r,
      directives: n,
      types: i
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: O.ENUM_TYPE_EXTENSION,
      name: r,
      directives: n,
      values: i
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const t = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
    if (n.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(t, {
      kind: O.INPUT_OBJECT_TYPE_EXTENSION,
      name: r,
      directives: n,
      fields: i
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const t = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(d.AT);
    const n = this.parseName(), i = this.parseArgumentDefs(), o = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const a = this.parseDirectiveLocations();
    return this.node(t, {
      kind: O.DIRECTIVE_DEFINITION,
      description: r,
      name: n,
      arguments: i,
      repeatable: o,
      locations: a
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(d.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const t = this._lexer.token, r = this.parseName();
    if (Object.prototype.hasOwnProperty.call(Jn, r.value))
      return r;
    throw this.unexpected(t);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(t, r) {
    return this._options.noLocation !== !0 && (r.loc = new Sc(
      t,
      this._lexer.lastToken,
      this._lexer.source
    )), r;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(t) {
    return this._lexer.token.kind === t;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(t) {
    const r = this._lexer.token;
    if (r.kind === t)
      return this.advanceLexer(), r;
    throw G(
      this._lexer.source,
      r.start,
      `Expected ${ps(t)}, found ${Ze(r)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(t) {
    return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(t) {
    const r = this._lexer.token;
    if (r.kind === d.NAME && r.value === t)
      this.advanceLexer();
    else
      throw G(
        this._lexer.source,
        r.start,
        `Expected "${t}", found ${Ze(r)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(t) {
    const r = this._lexer.token;
    return r.kind === d.NAME && r.value === t ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(t) {
    const r = t ?? this._lexer.token;
    return G(
      this._lexer.source,
      r.start,
      `Unexpected ${Ze(r)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(t, r, n) {
    this.expectToken(t);
    const i = [];
    for (; !this.expectOptionalToken(n); )
      i.push(r.call(this));
    return i;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(t, r, n) {
    if (this.expectOptionalToken(t)) {
      const i = [];
      do
        i.push(r.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(t, r, n) {
    this.expectToken(t);
    const i = [];
    do
      i.push(r.call(this));
    while (!this.expectOptionalToken(n));
    return i;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(t, r) {
    this.expectOptionalToken(t);
    const n = [];
    do
      n.push(r.call(this));
    while (this.expectOptionalToken(t));
    return n;
  }
  advanceLexer() {
    const { maxTokens: t } = this._options, r = this._lexer.advance();
    if (r.kind !== d.EOF && (++this._tokenCounter, t !== void 0 && this._tokenCounter > t))
      throw G(
        this._lexer.source,
        r.start,
        `Document contains more that ${t} tokens. Parsing aborted.`
      );
  }
};
function Ze(e) {
  const t = e.value;
  return ps(e.kind) + (t != null ? ` "${t}"` : "");
}
function ps(e) {
  return xc(e) ? `"${e}"` : e;
}
function Jc(e) {
  return `"${e.replace(Qc, Zc)}"`;
}
const Qc = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function Zc(e) {
  return tl[e.charCodeAt(0)];
}
const tl = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], el = Object.freeze({});
function rl(e, t, r = is) {
  const n = /* @__PURE__ */ new Map();
  for (const E of Object.values(O))
    n.set(E, nl(t, E));
  let i, o = Array.isArray(e), a = [e], u = -1, c = [], s = e, l, p;
  const f = [], m = [];
  do {
    u++;
    const E = u === a.length, N = E && c.length !== 0;
    if (E) {
      if (l = m.length === 0 ? void 0 : f[f.length - 1], s = p, p = m.pop(), N)
        if (o) {
          s = s.slice();
          let U = 0;
          for (const [F, D] of c) {
            const H = F - U;
            D === null ? (s.splice(H, 1), U++) : s[H] = D;
          }
        } else {
          s = L({}, s);
          for (const [U, F] of c)
            s[U] = F;
        }
      u = i.index, a = i.keys, c = i.edits, o = i.inArray, i = i.prev;
    } else if (p) {
      if (l = o ? u : a[u], s = p[l], s == null)
        continue;
      f.push(l);
    }
    let j;
    if (!Array.isArray(s)) {
      var v, y;
      po(s) || fr(!1, `Invalid AST Node: ${Ui(s)}.`);
      const U = E ? (v = n.get(s.kind)) === null || v === void 0 ? void 0 : v.leave : (y = n.get(s.kind)) === null || y === void 0 ? void 0 : y.enter;
      if (j = U?.call(t, s, l, p, f, m), j === el)
        break;
      if (j === !1) {
        if (!E) {
          f.pop();
          continue;
        }
      } else if (j !== void 0 && (c.push([l, j]), !E))
        if (po(j))
          s = j;
        else {
          f.pop();
          continue;
        }
    }
    if (j === void 0 && N && c.push([l, s]), E)
      f.pop();
    else {
      var g;
      i = {
        inArray: o,
        index: u,
        keys: a,
        edits: c,
        prev: i
      }, o = Array.isArray(s), a = o ? s : (g = r[s.kind]) !== null && g !== void 0 ? g : [], u = -1, c = [], p && m.push(p), p = s;
    }
  } while (i !== void 0);
  return c.length !== 0 ? c[c.length - 1][1] : e;
}
function nl(e, t) {
  const r = e[t];
  return typeof r == "object" ? r : typeof r == "function" ? {
    enter: r,
    leave: void 0
  } : {
    enter: e.enter,
    leave: e.leave
  };
}
function il(e) {
  return rl(e, al);
}
const ol = 80, al = {
  Name: {
    leave: (e) => e.value
  },
  Variable: {
    leave: (e) => "$" + e.name
  },
  // Document
  Document: {
    leave: (e) => b(e.definitions, `

`)
  },
  OperationDefinition: {
    leave(e) {
      const t = R("(", b(e.variableDefinitions, ", "), ")"), r = b(
        [
          e.operation,
          b([e.name, t]),
          b(e.directives, " ")
        ],
        " "
      );
      return (r === "query" ? "" : r + " ") + e.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: e, type: t, defaultValue: r, directives: n }) => e + ": " + t + R(" = ", r) + R(" ", b(n, " "))
  },
  SelectionSet: {
    leave: ({ selections: e }) => st(e)
  },
  Field: {
    leave({ alias: e, name: t, arguments: r, directives: n, selectionSet: i }) {
      const o = R("", e, ": ") + t;
      let a = o + R("(", b(r, ", "), ")");
      return a.length > ol && (a = o + R(`(
`, hr(b(r, `
`)), `
)`)), b([a, b(n, " "), i], " ");
    }
  },
  Argument: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: e, directives: t }) => "..." + e + R(" ", b(t, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: e, directives: t, selectionSet: r }) => b(
      [
        "...",
        R("on ", e),
        b(t, " "),
        r
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: e, typeCondition: t, variableDefinitions: r, directives: n, selectionSet: i }) => (
      // or removed in the future.
      `fragment ${e}${R("(", b(r, ", "), ")")} on ${t} ${R("", b(n, " "), " ")}` + i
    )
  },
  // Value
  IntValue: {
    leave: ({ value: e }) => e
  },
  FloatValue: {
    leave: ({ value: e }) => e
  },
  StringValue: {
    leave: ({ value: e, block: t }) => t ? Cc(e) : Jc(e)
  },
  BooleanValue: {
    leave: ({ value: e }) => e ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: e }) => e
  },
  ListValue: {
    leave: ({ values: e }) => "[" + b(e, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: e }) => "{" + b(e, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: e, value: t }) => e + ": " + t
  },
  // Directive
  Directive: {
    leave: ({ name: e, arguments: t }) => "@" + e + R("(", b(t, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: e }) => e
  },
  ListType: {
    leave: ({ type: e }) => "[" + e + "]"
  },
  NonNullType: {
    leave: ({ type: e }) => e + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: e, directives: t, operationTypes: r }) => R("", e, `
`) + b(["schema", b(t, " "), st(r)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: e, type: t }) => e + ": " + t
  },
  ScalarTypeDefinition: {
    leave: ({ description: e, name: t, directives: r }) => R("", e, `
`) + b(["scalar", t, b(r, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => R("", e, `
`) + b(
      [
        "type",
        t,
        R("implements ", b(r, " & ")),
        b(n, " "),
        st(i)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: e, name: t, arguments: r, type: n, directives: i }) => R("", e, `
`) + t + (ho(r) ? R(`(
`, hr(b(r, `
`)), `
)`) : R("(", b(r, ", "), ")")) + ": " + n + R(" ", b(i, " "))
  },
  InputValueDefinition: {
    leave: ({ description: e, name: t, type: r, defaultValue: n, directives: i }) => R("", e, `
`) + b(
      [t + ": " + r, R("= ", n), b(i, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => R("", e, `
`) + b(
      [
        "interface",
        t,
        R("implements ", b(r, " & ")),
        b(n, " "),
        st(i)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, types: n }) => R("", e, `
`) + b(
      ["union", t, b(r, " "), R("= ", b(n, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, values: n }) => R("", e, `
`) + b(["enum", t, b(r, " "), st(n)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: e, name: t, directives: r }) => R("", e, `
`) + b([t, b(r, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: e, name: t, directives: r, fields: n }) => R("", e, `
`) + b(["input", t, b(r, " "), st(n)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: e, name: t, arguments: r, repeatable: n, locations: i }) => R("", e, `
`) + "directive @" + t + (ho(r) ? R(`(
`, hr(b(r, `
`)), `
)`) : R("(", b(r, ", "), ")")) + (n ? " repeatable" : "") + " on " + b(i, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: e, operationTypes: t }) => b(
      ["extend schema", b(e, " "), st(t)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: e, directives: t }) => b(["extend scalar", e, b(t, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => b(
      [
        "extend type",
        e,
        R("implements ", b(t, " & ")),
        b(r, " "),
        st(n)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: e, interfaces: t, directives: r, fields: n }) => b(
      [
        "extend interface",
        e,
        R("implements ", b(t, " & ")),
        b(r, " "),
        st(n)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: e, directives: t, types: r }) => b(
      [
        "extend union",
        e,
        b(t, " "),
        R("= ", b(r, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: e, directives: t, values: r }) => b(["extend enum", e, b(t, " "), st(r)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: e, directives: t, fields: r }) => b(["extend input", e, b(t, " "), st(r)], " ")
  }
};
function b(e, t = "") {
  var r;
  return (r = e?.filter((n) => n).join(t)) !== null && r !== void 0 ? r : "";
}
function st(e) {
  return R(`{
`, hr(b(e, `
`)), `
}`);
}
function R(e, t, r = "") {
  return t != null && t !== "" ? e + t + r : "";
}
function hr(e) {
  return R("  ", e.replace(/\n/g, `
  `));
}
function ho(e) {
  var t;
  return (t = e?.some((r) => r.includes(`
`))) !== null && t !== void 0 ? t : !1;
}
const $i = JSON, sl = (e) => e.toUpperCase(), ul = (e) => {
  const t = {};
  return e.forEach((r, n) => {
    t[n] = r;
  }), t;
}, cl = (e, t, r) => e.document ? e : {
  document: e,
  variables: t,
  requestHeaders: r,
  signal: void 0
}, ll = (e, t, r) => e.query ? e : {
  query: e,
  variables: t,
  requestHeaders: r,
  signal: void 0
}, pl = (e, t) => e.documents ? e : {
  documents: e,
  requestHeaders: t,
  signal: void 0
}, vo = (e) => {
  var t, r;
  let n;
  const i = e.definitions.filter((o) => o.kind === "OperationDefinition");
  return i.length === 1 && (n = (r = (t = i[0]) == null ? void 0 : t.name) == null ? void 0 : r.value), n;
}, Zr = (e) => {
  if (typeof e == "string") {
    let r;
    try {
      const n = ji(e);
      r = vo(n);
    } catch {
    }
    return { query: e, operationName: r };
  }
  const t = vo(e);
  return { query: il(e), operationName: t };
};
let fs = class dr extends Error {
  constructor(t, r) {
    const n = `${dr.extractMessage(t)}: ${JSON.stringify({
      response: t,
      request: r
    })}`;
    super(n), Object.setPrototypeOf(this, dr.prototype), this.response = t, this.request = r, typeof Error.captureStackTrace == "function" && Error.captureStackTrace(this, dr);
  }
  static extractMessage(t) {
    var r, n, i;
    return (i = (n = (r = t.errors) == null ? void 0 : r[0]) == null ? void 0 : n.message) != null ? i : `GraphQL Error (Code: ${t.status})`;
  }
};
var Bi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Vr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Zn = { exports: {} };
(function(e, t) {
  var r = typeof self < "u" ? self : Bi, n = function() {
    function o() {
      this.fetch = !1, this.DOMException = r.DOMException;
    }
    return o.prototype = r, new o();
  }();
  (function(o) {
    (function(a) {
      var u = {
        searchParams: "URLSearchParams" in o,
        iterable: "Symbol" in o && "iterator" in Symbol,
        blob: "FileReader" in o && "Blob" in o && function() {
          try {
            return new Blob(), !0;
          } catch {
            return !1;
          }
        }(),
        formData: "FormData" in o,
        arrayBuffer: "ArrayBuffer" in o
      };
      function c(h) {
        return h && DataView.prototype.isPrototypeOf(h);
      }
      if (u.arrayBuffer)
        var s = [
          "[object Int8Array]",
          "[object Uint8Array]",
          "[object Uint8ClampedArray]",
          "[object Int16Array]",
          "[object Uint16Array]",
          "[object Int32Array]",
          "[object Uint32Array]",
          "[object Float32Array]",
          "[object Float64Array]"
        ], l = ArrayBuffer.isView || function(h) {
          return h && s.indexOf(Object.prototype.toString.call(h)) > -1;
        };
      function p(h) {
        if (typeof h != "string" && (h = String(h)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(h))
          throw new TypeError("Invalid character in header field name");
        return h.toLowerCase();
      }
      function f(h) {
        return typeof h != "string" && (h = String(h)), h;
      }
      function m(h) {
        var _ = {
          next: function() {
            var A = h.shift();
            return { done: A === void 0, value: A };
          }
        };
        return u.iterable && (_[Symbol.iterator] = function() {
          return _;
        }), _;
      }
      function v(h) {
        this.map = {}, h instanceof v ? h.forEach(function(_, A) {
          this.append(A, _);
        }, this) : Array.isArray(h) ? h.forEach(function(_) {
          this.append(_[0], _[1]);
        }, this) : h && Object.getOwnPropertyNames(h).forEach(function(_) {
          this.append(_, h[_]);
        }, this);
      }
      v.prototype.append = function(h, _) {
        h = p(h), _ = f(_);
        var A = this.map[h];
        this.map[h] = A ? A + ", " + _ : _;
      }, v.prototype.delete = function(h) {
        delete this.map[p(h)];
      }, v.prototype.get = function(h) {
        return h = p(h), this.has(h) ? this.map[h] : null;
      }, v.prototype.has = function(h) {
        return this.map.hasOwnProperty(p(h));
      }, v.prototype.set = function(h, _) {
        this.map[p(h)] = f(_);
      }, v.prototype.forEach = function(h, _) {
        for (var A in this.map)
          this.map.hasOwnProperty(A) && h.call(_, this.map[A], A, this);
      }, v.prototype.keys = function() {
        var h = [];
        return this.forEach(function(_, A) {
          h.push(A);
        }), m(h);
      }, v.prototype.values = function() {
        var h = [];
        return this.forEach(function(_) {
          h.push(_);
        }), m(h);
      }, v.prototype.entries = function() {
        var h = [];
        return this.forEach(function(_, A) {
          h.push([A, _]);
        }), m(h);
      }, u.iterable && (v.prototype[Symbol.iterator] = v.prototype.entries);
      function y(h) {
        if (h.bodyUsed)
          return Promise.reject(new TypeError("Already read"));
        h.bodyUsed = !0;
      }
      function g(h) {
        return new Promise(function(_, A) {
          h.onload = function() {
            _(h.result);
          }, h.onerror = function() {
            A(h.error);
          };
        });
      }
      function E(h) {
        var _ = new FileReader(), A = g(_);
        return _.readAsArrayBuffer(h), A;
      }
      function N(h) {
        var _ = new FileReader(), A = g(_);
        return _.readAsText(h), A;
      }
      function j(h) {
        for (var _ = new Uint8Array(h), A = new Array(_.length), X = 0; X < _.length; X++)
          A[X] = String.fromCharCode(_[X]);
        return A.join("");
      }
      function U(h) {
        if (h.slice)
          return h.slice(0);
        var _ = new Uint8Array(h.byteLength);
        return _.set(new Uint8Array(h)), _.buffer;
      }
      function F() {
        return this.bodyUsed = !1, this._initBody = function(h) {
          this._bodyInit = h, h ? typeof h == "string" ? this._bodyText = h : u.blob && Blob.prototype.isPrototypeOf(h) ? this._bodyBlob = h : u.formData && FormData.prototype.isPrototypeOf(h) ? this._bodyFormData = h : u.searchParams && URLSearchParams.prototype.isPrototypeOf(h) ? this._bodyText = h.toString() : u.arrayBuffer && u.blob && c(h) ? (this._bodyArrayBuffer = U(h.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : u.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(h) || l(h)) ? this._bodyArrayBuffer = U(h) : this._bodyText = h = Object.prototype.toString.call(h) : this._bodyText = "", this.headers.get("content-type") || (typeof h == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : u.searchParams && URLSearchParams.prototype.isPrototypeOf(h) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, u.blob && (this.blob = function() {
          var h = y(this);
          if (h)
            return h;
          if (this._bodyBlob)
            return Promise.resolve(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(new Blob([this._bodyArrayBuffer]));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as blob");
          return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function() {
          return this._bodyArrayBuffer ? y(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(E);
        }), this.text = function() {
          var h = y(this);
          if (h)
            return h;
          if (this._bodyBlob)
            return N(this._bodyBlob);
          if (this._bodyArrayBuffer)
            return Promise.resolve(j(this._bodyArrayBuffer));
          if (this._bodyFormData)
            throw new Error("could not read FormData body as text");
          return Promise.resolve(this._bodyText);
        }, u.formData && (this.formData = function() {
          return this.text().then(vt);
        }), this.json = function() {
          return this.text().then(JSON.parse);
        }, this;
      }
      var D = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      function H(h) {
        var _ = h.toUpperCase();
        return D.indexOf(_) > -1 ? _ : h;
      }
      function $(h, _) {
        _ = _ || {};
        var A = _.body;
        if (h instanceof $) {
          if (h.bodyUsed)
            throw new TypeError("Already read");
          this.url = h.url, this.credentials = h.credentials, _.headers || (this.headers = new v(h.headers)), this.method = h.method, this.mode = h.mode, this.signal = h.signal, !A && h._bodyInit != null && (A = h._bodyInit, h.bodyUsed = !0);
        } else
          this.url = String(h);
        if (this.credentials = _.credentials || this.credentials || "same-origin", (_.headers || !this.headers) && (this.headers = new v(_.headers)), this.method = H(_.method || this.method || "GET"), this.mode = _.mode || this.mode || null, this.signal = _.signal || this.signal, this.referrer = null, (this.method === "GET" || this.method === "HEAD") && A)
          throw new TypeError("Body not allowed for GET or HEAD requests");
        this._initBody(A);
      }
      $.prototype.clone = function() {
        return new $(this, { body: this._bodyInit });
      };
      function vt(h) {
        var _ = new FormData();
        return h.trim().split("&").forEach(function(A) {
          if (A) {
            var X = A.split("="), z = X.shift().replace(/\+/g, " "), I = X.join("=").replace(/\+/g, " ");
            _.append(decodeURIComponent(z), decodeURIComponent(I));
          }
        }), _;
      }
      function at(h) {
        var _ = new v(), A = h.replace(/\r?\n[\t ]+/g, " ");
        return A.split(/\r?\n/).forEach(function(X) {
          var z = X.split(":"), I = z.shift().trim();
          if (I) {
            var Qe = z.join(":").trim();
            _.append(I, Qe);
          }
        }), _;
      }
      F.call($.prototype);
      function K(h, _) {
        _ || (_ = {}), this.type = "default", this.status = _.status === void 0 ? 200 : _.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in _ ? _.statusText : "OK", this.headers = new v(_.headers), this.url = _.url || "", this._initBody(h);
      }
      F.call(K.prototype), K.prototype.clone = function() {
        return new K(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new v(this.headers),
          url: this.url
        });
      }, K.error = function() {
        var h = new K(null, { status: 0, statusText: "" });
        return h.type = "error", h;
      };
      var Kt = [301, 302, 303, 307, 308];
      K.redirect = function(h, _) {
        if (Kt.indexOf(_) === -1)
          throw new RangeError("Invalid status code");
        return new K(null, { status: _, headers: { location: h } });
      }, a.DOMException = o.DOMException;
      try {
        new a.DOMException();
      } catch {
        a.DOMException = function(_, A) {
          this.message = _, this.name = A;
          var X = Error(_);
          this.stack = X.stack;
        }, a.DOMException.prototype = Object.create(Error.prototype), a.DOMException.prototype.constructor = a.DOMException;
      }
      function ye(h, _) {
        return new Promise(function(A, X) {
          var z = new $(h, _);
          if (z.signal && z.signal.aborted)
            return X(new a.DOMException("Aborted", "AbortError"));
          var I = new XMLHttpRequest();
          function Qe() {
            I.abort();
          }
          I.onload = function() {
            var _e = {
              status: I.status,
              statusText: I.statusText,
              headers: at(I.getAllResponseHeaders() || "")
            };
            _e.url = "responseURL" in I ? I.responseURL : _e.headers.get("X-Request-URL");
            var Jr = "response" in I ? I.response : I.responseText;
            A(new K(Jr, _e));
          }, I.onerror = function() {
            X(new TypeError("Network request failed"));
          }, I.ontimeout = function() {
            X(new TypeError("Network request failed"));
          }, I.onabort = function() {
            X(new a.DOMException("Aborted", "AbortError"));
          }, I.open(z.method, z.url, !0), z.credentials === "include" ? I.withCredentials = !0 : z.credentials === "omit" && (I.withCredentials = !1), "responseType" in I && u.blob && (I.responseType = "blob"), z.headers.forEach(function(_e, Jr) {
            I.setRequestHeader(Jr, _e);
          }), z.signal && (z.signal.addEventListener("abort", Qe), I.onreadystatechange = function() {
            I.readyState === 4 && z.signal.removeEventListener("abort", Qe);
          }), I.send(typeof z._bodyInit > "u" ? null : z._bodyInit);
        });
      }
      return ye.polyfill = !0, o.fetch || (o.fetch = ye, o.Headers = v, o.Request = $, o.Response = K), a.Headers = v, a.Request = $, a.Response = K, a.fetch = ye, Object.defineProperty(a, "__esModule", { value: !0 }), a;
    })({});
  })(n), n.fetch.ponyfill = !0, delete n.fetch.polyfill;
  var i = n;
  t = i.fetch, t.default = i.fetch, t.fetch = i.fetch, t.Headers = i.Headers, t.Request = i.Request, t.Response = i.Response, e.exports = t;
})(Zn, Zn.exports);
var Or = Zn.exports;
const vr = /* @__PURE__ */ Vr(Or), fl = /* @__PURE__ */ yc({
  __proto__: null,
  default: vr
}, [Or]), Wt = (e) => {
  let t = {};
  return e && (typeof Headers < "u" && e instanceof Headers || fl && Or.Headers && e instanceof Or.Headers ? t = ul(e) : Array.isArray(e) ? e.forEach(([r, n]) => {
    r && n !== void 0 && (t[r] = n);
  }) : t = e), t;
}, mo = (e) => e.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim(), hl = (e) => {
  if (!Array.isArray(e.query)) {
    const n = e, i = [`query=${encodeURIComponent(mo(n.query))}`];
    return e.variables && i.push(`variables=${encodeURIComponent(n.jsonSerializer.stringify(n.variables))}`), n.operationName && i.push(`operationName=${encodeURIComponent(n.operationName)}`), i.join("&");
  }
  if (typeof e.variables < "u" && !Array.isArray(e.variables))
    throw new Error("Cannot create query with given variable type, array expected");
  const t = e, r = e.query.reduce((n, i, o) => (n.push({
    query: mo(i),
    variables: t.variables ? t.jsonSerializer.stringify(t.variables[o]) : void 0
  }), n), []);
  return `query=${encodeURIComponent(t.jsonSerializer.stringify(r))}`;
}, dl = (e) => (t) => le(void 0, null, function* () {
  var r;
  const { url: n, query: i, variables: o, operationName: a, fetch: u, fetchOptions: c, middleware: s } = t, l = L({}, t.headers);
  let p = "", f;
  e === "POST" ? (f = ml(i, o, a, c.jsonSerializer), typeof f == "string" && (l["Content-Type"] = "application/json")) : p = hl({
    query: i,
    variables: o,
    operationName: a,
    jsonSerializer: (r = c.jsonSerializer) != null ? r : $i
  });
  const m = L({
    method: e,
    headers: l,
    body: f
  }, c);
  let v = n, y = m;
  if (s) {
    const g = yield Promise.resolve(s(oe(L({}, m), { url: n, operationName: a, variables: o }))), { url: E } = g, N = Re(g, ["url"]);
    v = E, y = N;
  }
  return p && (v = `${v}?${p}`), yield u(v, y);
});
let vl = class {
  constructor(t, r = {}) {
    this.url = t, this.requestConfig = r, this.rawRequest = (...n) => le(this, null, function* () {
      const [i, o, a] = n, u = ll(i, o, a), c = this.requestConfig, { headers: s, fetch: l = vr, method: p = "POST", requestMiddleware: f, responseMiddleware: m } = c, v = Re(c, ["headers", "fetch", "method", "requestMiddleware", "responseMiddleware"]), { url: y } = this;
      u.signal !== void 0 && (v.signal = u.signal);
      const { operationName: g } = Zr(u.query);
      return tn({
        url: y,
        query: u.query,
        variables: u.variables,
        headers: L(L({}, Wt(en(s))), Wt(u.requestHeaders)),
        operationName: g,
        fetch: l,
        method: p,
        fetchOptions: v,
        middleware: f
      }).then((E) => (m && m(E), E)).catch((E) => {
        throw m && m(E), E;
      });
    });
  }
  request(t, ...r) {
    return le(this, null, function* () {
      const [n, i] = r, o = cl(t, n, i), a = this.requestConfig, { headers: u, fetch: c = vr, method: s = "POST", requestMiddleware: l, responseMiddleware: p } = a, f = Re(a, ["headers", "fetch", "method", "requestMiddleware", "responseMiddleware"]), { url: m } = this;
      o.signal !== void 0 && (f.signal = o.signal);
      const { query: v, operationName: y } = Zr(o.document);
      return tn({
        url: m,
        query: v,
        variables: o.variables,
        headers: L(L({}, Wt(en(u))), Wt(o.requestHeaders)),
        operationName: y,
        fetch: c,
        method: s,
        fetchOptions: f,
        middleware: l
      }).then((g) => (p && p(g), g.data)).catch((g) => {
        throw p && p(g), g;
      });
    });
  }
  // prettier-ignore
  batchRequests(t, r) {
    var n;
    const i = pl(t, r), o = this.requestConfig, { headers: a } = o, u = Re(o, ["headers"]);
    i.signal !== void 0 && (u.signal = i.signal);
    const c = i.documents.map(({ document: l }) => Zr(l).query), s = i.documents.map(({ variables: l }) => l);
    return tn({
      url: this.url,
      query: c,
      // @ts-expect-error TODO reconcile batch variables into system.
      variables: s,
      headers: L(L({}, Wt(en(a))), Wt(i.requestHeaders)),
      operationName: void 0,
      fetch: (n = this.requestConfig.fetch) != null ? n : vr,
      method: this.requestConfig.method || "POST",
      fetchOptions: u,
      middleware: this.requestConfig.requestMiddleware
    }).then((l) => (this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(l), l.data)).catch((l) => {
      throw this.requestConfig.responseMiddleware && this.requestConfig.responseMiddleware(l), l;
    });
  }
  setHeaders(t) {
    return this.requestConfig.headers = t, this;
  }
  /**
   * Attach a header to the client. All subsequent requests will have this header.
   */
  setHeader(t, r) {
    const { headers: n } = this.requestConfig;
    return n ? n[t] = r : this.requestConfig.headers = { [t]: r }, this;
  }
  /**
   * Change the client endpoint. All subsequent requests will send to this endpoint.
   */
  setEndpoint(t) {
    return this.url = t, this;
  }
};
const tn = (e) => le(void 0, null, function* () {
  var t, r;
  const { query: n, variables: i, fetchOptions: o } = e, a = dl(sl((t = e.method) != null ? t : "post")), u = Array.isArray(e.query), c = yield a(e), s = yield yl(c, (r = o.jsonSerializer) != null ? r : $i), l = Array.isArray(s) ? !s.some(({ data: f }) => !f) : !!s.data, p = Array.isArray(s) || !s.errors || Array.isArray(s.errors) && !s.errors.length || o.errorPolicy === "all" || o.errorPolicy === "ignore";
  if (c.ok && p && l) {
    const f = s, m = Re(f, ["errors"]), v = o.errorPolicy === "ignore" ? m : s;
    return oe(L({}, u ? { data: v } : v), {
      headers: c.headers,
      status: c.status
    });
  } else {
    const f = typeof s == "string" ? {
      error: s
    } : s;
    throw new fs(
      // @ts-expect-error TODO
      oe(L({}, f), { status: c.status, headers: c.headers }),
      { query: n, variables: i }
    );
  }
}), ml = (e, t, r, n) => {
  const i = n ?? $i;
  if (!Array.isArray(e))
    return i.stringify({ query: e, variables: t, operationName: r });
  if (typeof t < "u" && !Array.isArray(t))
    throw new Error("Cannot create request body with given variable type, array expected");
  const o = e.reduce((a, u, c) => (a.push({ query: u, variables: t ? t[c] : void 0 }), a), []);
  return i.stringify(o);
}, yl = (e, t) => le(void 0, null, function* () {
  let r;
  return e.headers.forEach((n, i) => {
    i.toLowerCase() === "content-type" && (r = n);
  }), r && (r.toLowerCase().startsWith("application/json") || r.toLowerCase().startsWith("application/graphql+json") || r.toLowerCase().startsWith("application/graphql-response+json")) ? t.parse(yield e.text()) : e.text();
}), en = (e) => typeof e == "function" ? e() : e;
var ti = { exports: {} };
(function(e, t) {
  t = e.exports = r, t.getSerialize = n;
  function r(i, o, a, u) {
    return JSON.stringify(i, n(o, u), a);
  }
  function n(i, o) {
    var a = [], u = [];
    return o == null && (o = function(c, s) {
      return a[0] === s ? "[Circular ~]" : "[Circular ~." + u.slice(0, a.indexOf(s)).join(".") + "]";
    }), function(c, s) {
      if (a.length > 0) {
        var l = a.indexOf(this);
        ~l ? a.splice(l + 1) : a.push(this), ~l ? u.splice(l, 1 / 0, c) : u.push(c), ~a.indexOf(s) && (s = o.call(this, c, s));
      } else a.push(s);
      return i == null ? s : i.call(this, c, s);
    };
  }
})(ti, ti.exports);
var _l = ti.exports;
const Ce = /* @__PURE__ */ Vr(_l);
var Sr = function() {
  return Sr = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Sr.apply(this, arguments);
}, mr = /* @__PURE__ */ new Map(), ei = /* @__PURE__ */ new Map(), hs = !0, wr = !1;
function ds(e) {
  return e.replace(/[\s,]+/g, " ").trim();
}
function gl(e) {
  return ds(e.source.body.substring(e.start, e.end));
}
function El(e) {
  var t = /* @__PURE__ */ new Set(), r = [];
  return e.definitions.forEach(function(n) {
    if (n.kind === "FragmentDefinition") {
      var i = n.name.value, o = gl(n.loc), a = ei.get(i);
      a && !a.has(o) ? hs && console.warn("Warning: fragment with name " + i + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : a || ei.set(i, a = /* @__PURE__ */ new Set()), a.add(o), t.has(o) || (t.add(o), r.push(n));
    } else
      r.push(n);
  }), Sr(Sr({}, e), { definitions: r });
}
function Tl(e) {
  var t = new Set(e.definitions);
  t.forEach(function(n) {
    n.loc && delete n.loc, Object.keys(n).forEach(function(i) {
      var o = n[i];
      o && typeof o == "object" && t.add(o);
    });
  });
  var r = e.loc;
  return r && (delete r.startToken, delete r.endToken), e;
}
function bl(e) {
  var t = ds(e);
  if (!mr.has(t)) {
    var r = ji(e, {
      experimentalFragmentVariables: wr,
      allowLegacyFragmentVariables: wr
    });
    if (!r || r.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    mr.set(t, Tl(El(r)));
  }
  return mr.get(t);
}
function tt(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  typeof e == "string" && (e = [e]);
  var n = e[0];
  return t.forEach(function(i, o) {
    i && i.kind === "Document" ? n += i.loc.source.body : n += i, n += e[o + 1];
  }), bl(n);
}
function Ol() {
  mr.clear(), ei.clear();
}
function Sl() {
  hs = !1;
}
function wl() {
  wr = !0;
}
function Al() {
  wr = !1;
}
var ge = {
  gql: tt,
  resetCaches: Ol,
  disableFragmentWarnings: Sl,
  enableExperimentalFragmentVariables: wl,
  disableExperimentalFragmentVariables: Al
};
(function(e) {
  e.gql = ge.gql, e.resetCaches = ge.resetCaches, e.disableFragmentWarnings = ge.disableFragmentWarnings, e.enableExperimentalFragmentVariables = ge.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = ge.disableExperimentalFragmentVariables;
})(tt || (tt = {}));
tt.default = tt;
const vs = tt`
	fragment MatchParts on MatchConfig {
		regexValue
		matchValue
	}
`, Ll = tt`
	mutation PushPayload(
		$session_secure_id: String!
		$payload_id: ID!
		$events: ReplayEventsInput!
		$messages: String!
		$resources: String!
		$web_socket_events: String!
		$errors: [ErrorObjectInput]!
		$is_beacon: Boolean
		$has_session_unloaded: Boolean
		$highlight_logs: String
	) {
		pushPayload(
			session_secure_id: $session_secure_id
			payload_id: $payload_id
			events: $events
			messages: $messages
			resources: $resources
			web_socket_events: $web_socket_events
			errors: $errors
			is_beacon: $is_beacon
			has_session_unloaded: $has_session_unloaded
			highlight_logs: $highlight_logs
		)
	}
`, Rl = tt`
	mutation PushSessionEvents(
		$session_secure_id: String!
		$payload_id: Int64ID!
		$data: String!
	) {
		pushSessionEvents(
			session_secure_id: $session_secure_id
			payload_id: $payload_id
			data: $data
		)
	}
`, Cl = tt`
	mutation identifySession(
		$session_secure_id: String!
		$user_identifier: String!
		$user_object: Any
	) {
		identifySession(
			session_secure_id: $session_secure_id
			user_identifier: $user_identifier
			user_object: $user_object
		)
	}
`, Nl = tt`
	mutation addSessionProperties(
		$session_secure_id: String!
		$properties_object: Any
	) {
		addSessionProperties(
			session_secure_id: $session_secure_id
			properties_object: $properties_object
		)
	}
`, xl = tt`
	mutation pushMetrics($metrics: [MetricInput]!) {
		pushMetrics(metrics: $metrics)
	}
`, Pl = tt`
	mutation addSessionFeedback(
		$session_secure_id: String!
		$user_name: String
		$user_email: String
		$verbatim: String!
		$timestamp: Timestamp!
	) {
		addSessionFeedback(
			session_secure_id: $session_secure_id
			user_name: $user_name
			user_email: $user_email
			verbatim: $verbatim
			timestamp: $timestamp
		)
	}
`, Il = tt`
	mutation initializeSession(
		$session_secure_id: String!
		$session_key: String
		$organization_verbose_id: String!
		$enable_strict_privacy: Boolean!
		$privacy_setting: String!
		$enable_recording_network_contents: Boolean!
		$clientVersion: String!
		$firstloadVersion: String!
		$clientConfig: String!
		$environment: String!
		$id: String!
		$appVersion: String
		$serviceName: String!
		$client_id: String!
		$network_recording_domains: [String!]
		$disable_session_recording: Boolean
	) {
		initializeSession(
			session_secure_id: $session_secure_id
			session_key: $session_key
			organization_verbose_id: $organization_verbose_id
			enable_strict_privacy: $enable_strict_privacy
			enable_recording_network_contents: $enable_recording_network_contents
			clientVersion: $clientVersion
			firstloadVersion: $firstloadVersion
			clientConfig: $clientConfig
			environment: $environment
			appVersion: $appVersion
			serviceName: $serviceName
			fingerprint: $id
			client_id: $client_id
			network_recording_domains: $network_recording_domains
			disable_session_recording: $disable_session_recording
			privacy_setting: $privacy_setting
		) {
			secure_id
			project_id
			sampling {
				spans {
					name {
						...MatchParts
					}
					attributes {
						key {
							...MatchParts
						}
						attribute {
							...MatchParts
						}
					}
					events {
						name {
							...MatchParts
						}
						attributes {
							key {
								...MatchParts
							}
							attribute {
								...MatchParts
							}
						}
					}
					samplingRatio
				}
				logs {
					message {
						...MatchParts
					}
					severityText {
						...MatchParts
					}
					attributes {
						key {
							...MatchParts
						}
						attribute {
							...MatchParts
						}
					}
					samplingRatio
				}
			}
		}
	}
	${vs}
`, Ml = tt`
	query Ignore($id: ID!) {
		ignore(id: $id)
	}
`, kl = tt`
	query GetSamplingConfig($organization_verbose_id: String!) {
		sampling(organization_verbose_id: $organization_verbose_id) {
			spans {
				name {
					...MatchParts
				}
				attributes {
					key {
						...MatchParts
					}
					attribute {
						...MatchParts
					}
				}
				events {
					name {
						...MatchParts
					}
					attributes {
						key {
							...MatchParts
						}
						attribute {
							...MatchParts
						}
					}
				}
				samplingRatio
			}
			logs {
				message {
					...MatchParts
				}
				severityText {
					...MatchParts
				}
				attributes {
					key {
						...MatchParts
					}
					attribute {
						...MatchParts
					}
				}
				samplingRatio
			}
		}
	}
	${vs}
`, Dl = (e, t, r, n) => e();
function Ul(e, t = Dl) {
  return {
    PushPayload(r, n) {
      return t(
        (i) => e.request(
          Ll,
          r,
          L(L({}, n), i)
        ),
        "PushPayload",
        "mutation",
        r
      );
    },
    PushSessionEvents(r, n) {
      return t(
        (i) => e.request(
          Rl,
          r,
          L(L({}, n), i)
        ),
        "PushSessionEvents",
        "mutation",
        r
      );
    },
    identifySession(r, n) {
      return t(
        (i) => e.request(
          Cl,
          r,
          L(L({}, n), i)
        ),
        "identifySession",
        "mutation",
        r
      );
    },
    addSessionProperties(r, n) {
      return t(
        (i) => e.request(
          Nl,
          r,
          L(L({}, n), i)
        ),
        "addSessionProperties",
        "mutation",
        r
      );
    },
    pushMetrics(r, n) {
      return t(
        (i) => e.request(
          xl,
          r,
          L(L({}, n), i)
        ),
        "pushMetrics",
        "mutation",
        r
      );
    },
    addSessionFeedback(r, n) {
      return t(
        (i) => e.request(
          Pl,
          r,
          L(L({}, n), i)
        ),
        "addSessionFeedback",
        "mutation",
        r
      );
    },
    initializeSession(r, n) {
      return t(
        (i) => e.request(
          Il,
          r,
          L(L({}, n), i)
        ),
        "initializeSession",
        "mutation",
        r
      );
    },
    Ignore(r, n) {
      return t(
        (i) => e.request(Ml, r, L(L({}, n), i)),
        "Ignore",
        "query",
        r
      );
    },
    GetSamplingConfig(r, n) {
      return t(
        (i) => e.request(
          kl,
          r,
          L(L({}, n), i)
        ),
        "GetSamplingConfig",
        "query",
        r
      );
    }
  };
}
const jl = [
  "assert",
  "count",
  "countReset",
  "debug",
  "dir",
  "dirxml",
  "error",
  "group",
  "groupCollapsed",
  "groupEnd",
  "info",
  "log",
  "table",
  "time",
  "timeEnd",
  "timeLog",
  "trace",
  "warn"
];
var xt = /* @__PURE__ */ ((e) => (e.DeviceMemory = "DeviceMemory", e.ViewportHeight = "ViewportHeight", e.ViewportWidth = "ViewportWidth", e.ScreenHeight = "ScreenHeight", e.ScreenWidth = "ScreenWidth", e.ViewportArea = "ViewportArea", e))(xt || {}), nt = /* @__PURE__ */ ((e) => (e.Device = "Device", e.WebVital = "WebVital", e.Performance = "Performance", e.Frontend = "Frontend", e.Backend = "Backend", e))(nt || {});
function $l(e, t, r) {
  try {
    if (!(t in e))
      return () => {
      };
    const n = e[t], i = r(n);
    return typeof i == "function" && (i.prototype = i.prototype || {}, Object.defineProperties(i, {
      __rrweb_original__: {
        enumerable: !1,
        value: n
      }
    })), e[t] = i, () => {
      e[t] = n;
    };
  } catch {
    return () => {
    };
  }
}
function Bl(e) {
  if (!e || !e.outerHTML)
    return "";
  let t = "";
  for (; e.parentElement; ) {
    let r = e.localName;
    if (!r)
      break;
    r = r.toLowerCase();
    let n = e.parentElement, i = [];
    if (n.children && n.children.length > 0)
      for (let o = 0; o < n.children.length; o++) {
        let a = n.children[o];
        a.localName && a.localName.toLowerCase && a.localName.toLowerCase() === r && i.push(a);
      }
    i.length > 1 && (r += ":eq(" + i.indexOf(e) + ")"), t = r + (t ? ">" + t : ""), e = n;
  }
  return t;
}
function ri(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ms(e, t) {
  if (t === 0)
    return !0;
  const r = Object.keys(e);
  for (const n of r)
    if (ri(e[n]) && ms(e[n], t - 1))
      return !0;
  return !1;
}
function ni(e, t) {
  const r = {
    numOfKeysLimit: 50,
    depthOfLimit: 4
  };
  Object.assign(r, t);
  const n = [], i = [];
  return JSON.stringify(e, function(u, c) {
    if (n.length > 0) {
      const s = n.indexOf(this);
      ~s ? n.splice(s + 1) : n.push(this), ~s ? i.splice(s, 1 / 0, u) : i.push(u), ~n.indexOf(c) && (n[0] === c ? c = "[Circular ~]" : c = "[Circular ~." + i.slice(0, n.indexOf(c)).join(".") + "]");
    } else
      n.push(c);
    if (c == null)
      return c;
    if (o(c))
      return a(c);
    if (c instanceof Event) {
      const s = {};
      for (const l in c) {
        const p = c[l];
        Array.isArray(p) ? s[l] = Bl(
          p.length ? p[0] : null
        ) : s[l] = p;
      }
      return s;
    } else {
      if (c instanceof Node)
        return c instanceof HTMLElement ? c ? c.outerHTML : "" : c.nodeName;
      if (c instanceof Error)
        return c.name + ": " + c.message;
    }
    return c;
  });
  function o(u) {
    return ri(u) && Object.keys(u).length > r.numOfKeysLimit || typeof u == "function" ? !0 : u instanceof Event && u.isTrusted === !1 ? Object.keys(u).length === 1 : !!(ri(u) && ms(u, r.depthOfLimit));
  }
  function a(u) {
    let c = u.toString();
    return r.stringLengthLimit && c.length > r.stringLengthLimit && (c = `${c.slice(0, r.stringLengthLimit)}...`), c;
  }
}
function Fl(e) {
  return typeof e == "number" && !isNaN(e) && isFinite(e);
}
const rn = "exception.message", Vl = "exception.stacktrace", nn = "exception.type", Gl = "service.name", Hl = "telemetry.sdk.name", zl = "telemetry.sdk.version", Xl = "url.full", ql = "url.path", Kl = "url.query", Wl = "user_agent.original", Fi = 15 * 60 * 1e3;
/*! js-cookie v3.0.5 | MIT */
function tr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      e[n] = r[n];
  }
  return e;
}
var Yl = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function ii(e, t) {
  function r(i, o, a) {
    if (typeof document < "u") {
      a = tr({}, t, a), typeof a.expires == "number" && (a.expires = new Date(Date.now() + a.expires * 864e5)), a.expires && (a.expires = a.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var u = "";
      for (var c in a)
        a[c] && (u += "; " + c, a[c] !== !0 && (u += "=" + a[c].split(";")[0]));
      return document.cookie = i + "=" + e.write(o, i) + u;
    }
  }
  function n(i) {
    if (!(typeof document > "u" || arguments.length && !i)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], a = {}, u = 0; u < o.length; u++) {
        var c = o[u].split("="), s = c.slice(1).join("=");
        try {
          var l = decodeURIComponent(c[0]);
          if (a[l] = e.read(s, l), i === l)
            break;
        } catch {
        }
      }
      return i ? a[i] : a;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(i, o) {
        r(
          i,
          "",
          tr({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(i) {
        return ii(this.converter, tr({}, this.attributes, i));
      },
      withConverter: function(i) {
        return ii(tr({}, this.converter, i), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var on = ii(Yl, { path: "/" });
let oi = "localStorage", ai = !0, Jl = class {
  constructor() {
    Me(this, "storage", {});
  }
  get length() {
    return Object.keys(this.storage).length;
  }
  key(t) {
    var r;
    return (r = Object.keys(this.storage)[t]) != null ? r : null;
  }
  getItem(t) {
    var r;
    return (r = this.storage[t]) != null ? r : "";
  }
  setItem(t, r) {
    this.storage[t] = r;
  }
  removeItem(t) {
    delete this.storage[t];
  }
}, Ql = class {
  getItem(t) {
    var r;
    return (r = on.get(t)) != null ? r : "";
  }
  setItem(t, r) {
    if (!ai)
      return;
    const n = /* @__PURE__ */ new Date();
    n.setTime(n.getTime() + Fi), on.set(t, r, { expires: n });
  }
  removeItem(t) {
    ai && on.remove(t);
  }
};
const ae = new Jl(), Ar = new Ql(), De = () => {
  let e = null;
  if (typeof window > "u")
    return ae;
  try {
    switch (oi) {
      case "localStorage":
        e = window.localStorage;
        break;
      case "sessionStorage":
        e = window.sessionStorage;
        break;
    }
    e || (gt(
      "storage",
      "getPersistentStorage",
      "debug",
      `persistent storage was not found for mode ${oi}; using global storage`
    ), e = ae);
  } catch (t) {
    gt(
      "storage",
      "getPersistentStorage",
      "debug",
      "failed to get persistent storage; using global storage",
      t
    ), e = ae;
  }
  return e;
}, Zl = (e) => {
  oi = e;
}, yo = (e) => {
  ai = e;
}, Vi = (e) => {
  try {
    return De().getItem(e);
  } catch (t) {
    return gt(
      "storage",
      "getItem",
      "debug",
      `failed to get item ${e}; using global storage`,
      t
    ), ae.getItem(e);
  }
}, ys = (e, t) => {
  Ar.setItem(e, t);
  try {
    return De().setItem(e, t);
  } catch (r) {
    return gt(
      "storage",
      "setItem",
      "debug",
      `failed to set item ${e}; using global storage`,
      r
    ), ae.setItem(e, t);
  }
}, _s = (e) => {
  Ar.removeItem(e);
  try {
    return De().removeItem(e);
  } catch (t) {
    return gt(
      "storage",
      "removeItem",
      "debug",
      `failed to remove item ${e}; using global storage`,
      t
    ), ae.removeItem(e);
  }
};
var ve = /* @__PURE__ */ ((e) => (e.SEGMENT_LAST_SENT_HASH_KEY = "HIGHLIGHT_SEGMENT_LAST_SENT_HASH_KEY", e.SESSION_ID = "sessionID", e.SESSION_DATA = "sessionData", e.USER_IDENTIFIER = "highlightIdentifier", e.USER_OBJECT = "highlightUserObject", e))(ve || {});
const Gr = (e) => `${ve.SESSION_DATA}_${e}`, Ot = () => {
  var e;
  return typeof globalThis < "u" && (e = globalThis.persistentSessionSecureID) != null && e.length ? globalThis.persistentSessionSecureID : gs();
}, tp = (e) => {
  typeof globalThis < "u" && e != null && e.length && (globalThis.persistentSessionSecureID = e);
}, gs = () => {
  var e;
  return (e = Vi(ve.SESSION_ID)) != null ? e : "";
}, Es = (e) => {
  ys(ve.SESSION_ID, e);
}, ep = (e) => {
  const t = Gr(e);
  return JSON.parse(Vi(t) || "{}");
}, rp = (e) => {
  e || (e = gs());
  let t = ep(e);
  if (t && t.lastPushTime && Date.now() - t.lastPushTime < Fi)
    return t;
  _s(Gr(e));
}, Ts = function(e) {
  if (!(e != null && e.sessionSecureID)) return;
  const t = e.sessionSecureID;
  tp(t);
  const r = Gr(t);
  ys(r, JSON.stringify(e)), ip(r);
}, np = function() {
  const e = Ar.getItem(
    ve.SESSION_ID
  );
  Es(e);
  const t = Gr(e), r = Ar.getItem(t);
  try {
    Ts(JSON.parse(r));
  } catch {
  }
};
function ip(e) {
  const t = `${ve.SESSION_DATA}_`;
  for (let r = De().length - 1; r >= 0; r--) {
    const n = De().key(r);
    if (n && n.startsWith(t) && n !== e)
      try {
        const i = JSON.parse(
          Vi(n) || "{}"
        );
        i.lastPushTime === void 0 ? gt(
          "highlightSession",
          "pruneSessionData",
          "error",
          `data for key ${n} is not session data`
        ) : Date.now() - i.lastPushTime >= Fi && (gt(
          "highlightSession",
          "pruneSessionData",
          "debug",
          `removing session data for stale key ${n}`
        ), _s(n));
      } catch (i) {
        gt(
          "highlightSession",
          "pruneSessionData",
          "error",
          `failed to parse session data for key ${n}`,
          i
        );
      }
  }
}
var bs = /* @__PURE__ */ ((e) => (e.BillingQuotaExceeded = "BillingQuotaExceeded", e))(bs || {});
const Gi = 3, Hi = 1e3, zi = 500, op = [bs.BillingQuotaExceeded.toString()], ap = (e) => {
  var t;
  return ((t = e.response.errors) == null ? void 0 : t.find(
    (r) => op.includes(r.message)
  )) === void 0;
}, sp = () => {
  const e = (t, r, n, i, o = 0) => le(void 0, null, function* () {
    try {
      return yield t();
    } catch (a) {
      if (a instanceof fs && !ap(a))
        throw a;
      if (o < Gi)
        return yield new Promise(
          (u) => setTimeout(
            u,
            Hi + zi * Math.pow(2, o)
          )
        ), yield e(
          t,
          r,
          n,
          i,
          o + 1
        );
      throw console.error(
        `highlight.io: data request failed after ${o} retries`
      ), a;
    }
  });
  return e;
}, Y = "feature_flag", Os = "launchdarkly", up = "evaluation", cp = `${Y}.set.id`, lp = `${Y}.key`, pp = `${Y}.contextKeys`, fp = `${Y}.context.id`, hp = `${Y}.result.value`, dp = `${Y}.provider.name`, _o = {
  kind: `${Y}.result.reason.kind`,
  errorKind: `${Y}.result.reason.errorKind`,
  ruleIndex: `${Y}.result.reason.ruleIndex`,
  ruleId: `${Y}.result.reason.ruleId`,
  prerequisiteKey: `${Y}.result.reason.prerequisiteKey`,
  inExperiment: `${Y}.result.reason.inExperiment`,
  bigSegmentsStatus: `${Y}.result.reason.bigSegmentsStatus`
}, vp = `${Y}.result.variationIndex`, mp = `${Os}.application.id`, yp = `${Os}.application.version`, _p = "$ld:telemetry:session:init", gp = "$ld:telemetry:error", go = "$ld:telemetry:track", Ep = "$ld:telemetry:metric", Ss = "document_load", Tp = "result.status";
function Eo(e) {
  return e.includes("%") || e.includes(":") ? e.replace(/%/g, "%25").replace(/:/g, "%3A") : e;
}
function ws(e) {
  return e.kind === "multi";
}
function an(e) {
  return ws(e) ? Object.keys(e).sort().filter((t) => t !== "kind").map((t) => `${t}:${Eo(e[t].key)}`).join(":") : "kind" in e && e.kind === "user" ? e.key : "kind" in e ? `${e.kind}:${Eo(e.key)}` : e.key;
}
function To(e) {
  return ws(e) ? Object.keys(e).sort().filter((t) => t !== "kind").map((t) => ({
    [t]: e[t].key
  })).reduce((t, r) => L(L({}, t), r), {}) : "kind" in e ? {
    [e.kind]: e.key
  } : {
    user: e.key
  };
}
let bp = class {
  constructor(t, r) {
    Me(this, "client"), Me(this, "metadata"), this.client = t, this.metadata = r;
  }
  getHooks(t) {
    return [];
  }
  init(t) {
    this.client.track(_p, {
      sessionID: t
    });
  }
  recordGauge(t, r) {
    var n;
    r.category !== nt.WebVital && r.name !== Ss || r.name !== "Jank" && this.client.track(
      `${Ep}:${r.name.toLowerCase()}`,
      oe(L({}, (n = r.tags) == null ? void 0 : n.map((i) => ({ [i.name]: i.value })).reduce((i, o) => L(L({}, i), o), {})), {
        category: r.category,
        group: r.group,
        sessionID: t
      }),
      r.value
    );
  }
  identify(t, r, n = {}, i) {
  }
  error(t, r) {
    this.client.track(gp, oe(L({}, r), {
      sessionID: t
    }));
  }
  track(t, r) {
    const n = r.event;
    this.client.track(
      n ? `${go}:${n}` : go,
      oe(L({}, r), {
        sessionID: t
      })
    );
  }
}, Op = class extends Qa {
  constructor(t, r) {
    super(), Me(this, "client"), this.client = new bp(t, r);
  }
  getHooks(t) {
    return [
      {
        getMetadata: () => ({
          name: "highlight.run/ld"
        }),
        afterIdentify: (r, n, i) => (this.load(this.client), n)
      }
    ];
  }
  init(t) {
    return this._bufferCall("init", [t]);
  }
  recordGauge(t, r) {
    return this._bufferCall("recordGauge", [t, r]);
  }
  identify(t, r, n = {}, i) {
    return this._bufferCall("identify", [
      t,
      r,
      n,
      i
    ]);
  }
  error(t, r) {
    return this._bufferCall("error", [t, r]);
  }
  track(t, r) {
    return this._bufferCall("track", [t, r]);
  }
};
const Sp = "9.22.2", wp = {
  version: Sp
}, Ap = wp.version;
function Lp(e) {
  if (e.id.length)
    return `#${e.id}`;
  if (e.classList.length) {
    let t = [];
    for (const r of e.classList)
      t.push(`.${r}`);
    return `${e.nodeName.toLowerCase()}${t.join(",")}`;
  }
  return e.nodeName.toLowerCase();
}
const Rp = (e) => {
  let t;
  const r = () => {
    clearTimeout(t), t = setTimeout(() => {
      var n, i;
      e({
        height: window.innerHeight,
        width: window.innerWidth,
        availHeight: window.screen.availHeight,
        availWidth: window.screen.availWidth,
        colorDepth: window.screen.colorDepth,
        pixelDepth: window.screen.pixelDepth,
        orientation: (i = (n = window.screen.orientation) == null ? void 0 : n.angle) != null ? i : 0
      });
    }, 500);
  };
  return window.addEventListener("resize", r), r(), () => window.removeEventListener("resize", r);
};
var As = { exports: {} };
/**
 * @preserve
 * JS Implementation of incremental MurmurHash3 (r150) (as of May 10, 2013)
 *
 * @author <a href="mailto:jensyt@gmail.com">Jens Taylor</a>
 * @see http://github.com/homebrewing/brauhaus-diff
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/murmurhash-js
 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
 * @see http://sites.google.com/site/murmurhash/
 */
(function(e) {
  (function() {
    var t;
    function r(n, i) {
      var o = this instanceof r ? this : t;
      if (o.reset(i), typeof n == "string" && n.length > 0 && o.hash(n), o !== this)
        return o;
    }
    r.prototype.hash = function(n) {
      var i, o, a, u, c;
      switch (c = n.length, this.len += c, o = this.k1, a = 0, this.rem) {
        case 0:
          o ^= c > a ? n.charCodeAt(a++) & 65535 : 0;
        case 1:
          o ^= c > a ? (n.charCodeAt(a++) & 65535) << 8 : 0;
        case 2:
          o ^= c > a ? (n.charCodeAt(a++) & 65535) << 16 : 0;
        case 3:
          o ^= c > a ? (n.charCodeAt(a) & 255) << 24 : 0, o ^= c > a ? (n.charCodeAt(a++) & 65280) >> 8 : 0;
      }
      if (this.rem = c + this.rem & 3, c -= this.rem, c > 0) {
        for (i = this.h1; o = o * 11601 + (o & 65535) * 3432906752 & 4294967295, o = o << 15 | o >>> 17, o = o * 13715 + (o & 65535) * 461832192 & 4294967295, i ^= o, i = i << 13 | i >>> 19, i = i * 5 + 3864292196 & 4294967295, !(a >= c); )
          o = n.charCodeAt(a++) & 65535 ^ (n.charCodeAt(a++) & 65535) << 8 ^ (n.charCodeAt(a++) & 65535) << 16, u = n.charCodeAt(a++), o ^= (u & 255) << 24 ^ (u & 65280) >> 8;
        switch (o = 0, this.rem) {
          case 3:
            o ^= (n.charCodeAt(a + 2) & 65535) << 16;
          case 2:
            o ^= (n.charCodeAt(a + 1) & 65535) << 8;
          case 1:
            o ^= n.charCodeAt(a) & 65535;
        }
        this.h1 = i;
      }
      return this.k1 = o, this;
    }, r.prototype.result = function() {
      var n, i;
      return n = this.k1, i = this.h1, n > 0 && (n = n * 11601 + (n & 65535) * 3432906752 & 4294967295, n = n << 15 | n >>> 17, n = n * 13715 + (n & 65535) * 461832192 & 4294967295, i ^= n), i ^= this.len, i ^= i >>> 16, i = i * 51819 + (i & 65535) * 2246770688 & 4294967295, i ^= i >>> 13, i = i * 44597 + (i & 65535) * 3266445312 & 4294967295, i ^= i >>> 16, i >>> 0;
    }, r.prototype.reset = function(n) {
      return this.h1 = typeof n == "number" ? n : 0, this.rem = this.k1 = this.len = 0, this;
    }, t = new r(), e.exports = r;
  })();
})(As);
var Cp = As.exports;
const Np = /* @__PURE__ */ Vr(Cp), sn = 28, Yt = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789", xp = 2246822507, bo = (e) => {
  var t, r = "";
  if (e) {
    const n = Np(e).result();
    for (let i = 0; i < sn; i++) {
      const o = ((n ^ i * xp) >>> 0) % Yt.length;
      r += Yt.charAt(o);
    }
  } else {
    const n = typeof window < "u" && ((t = window.crypto) == null ? void 0 : t.getRandomValues), i = new Uint32Array(sn);
    n && window.crypto.getRandomValues(i);
    for (let o = 0; o < sn; o++)
      n ? r += Yt.charAt(
        i[o] % Yt.length
      ) : r += Yt.charAt(
        Math.floor(Math.random() * Yt.length)
      );
  }
  return r;
};
let Pp = class {
  constructor(t) {
    Me(this, "sessionSecureID");
    try {
      t != null && t.storageMode && Zl(t?.storageMode), yo(!!(t != null && t.sessionCookie)), t != null && t.sessionCookie ? np() : yo(!1);
    } catch (r) {
      Rt(
        "Error initializing @launchdarkly observability plugin",
        "error",
        r
      );
    }
  }
  configureSession(t, r) {
    try {
      const n = Ot();
      let i = rp(
        n
      );
      i != null && i.sessionSecureID ? this.sessionSecureID = i.sessionSecureID : (r != null && r.sessionKey ? this.sessionSecureID = bo(
        `${t}-${r.sessionKey}`
      ) : this.sessionSecureID = bo(), Es(this.sessionSecureID), Ts({
        sessionSecureID: this.sessionSecureID,
        sessionKey: r?.sessionKey,
        projectID: 0,
        sessionStartTime: Date.now(),
        lastPushTime: Date.now()
      }));
    } catch (n) {
      Rt(
        "Error configuring session in @launchdarkly observability plugin",
        "error",
        n
      );
    }
  }
};
class Oo extends Qa {
  start() {
    return this._sdk.start();
  }
  stop() {
    return this._sdk.stop();
  }
  recordGauge(t) {
    return this._bufferCall("recordGauge", [t]);
  }
  recordCount(t) {
    return this._bufferCall("recordCount", [t]);
  }
  recordIncr(t) {
    return this._bufferCall("recordIncr", [t]);
  }
  recordHistogram(t) {
    return this._bufferCall("recordHistogram", [t]);
  }
  recordUpDownCounter(t) {
    return this._bufferCall("recordUpDownCounter", [t]);
  }
  // TODO: Ask @vkorolik about using this method before initialization. Doesn't
  // this cause problems if someone tries to work with the returned span?
  startSpan(t, r, n, i) {
    return this._bufferCall("startSpan", [t, r, n, i]);
  }
  startManualSpan(t, r, n, i) {
    return this._bufferCall("startManualSpan", [t, r, n, i]);
  }
  register(t, r) {
    return this._bufferCall("register", [t, r]);
  }
  recordLog(t, r, n) {
    return this._bufferCall("recordLog", [t, r, n]);
  }
  recordError(t, r, n, i, o) {
    return this._bufferCall("recordError", [
      t,
      r,
      n,
      i,
      o
    ]);
  }
}
let ne;
typeof globalThis < "u" ? globalThis.LDObserve ? ne = globalThis.LDObserve : (ne = new Oo(), globalThis.LDObserve = ne) : ne = new Oo();
const Ip = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get LDObserve() {
    return ne;
  }
}, Symbol.toStringTag, { value: "Module" }));
var Mp = Object.defineProperty, kp = Object.defineProperties, Dp = Object.getOwnPropertyDescriptors, So = Object.getOwnPropertySymbols, Up = Object.prototype.hasOwnProperty, jp = Object.prototype.propertyIsEnumerable, si = (e, t, r) => t in e ? Mp(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, M = (e, t) => {
  for (var r in t || (t = {}))
    Up.call(t, r) && si(e, r, t[r]);
  if (So)
    for (var r of So(t))
      jp.call(t, r) && si(e, r, t[r]);
  return e;
}, et = (e, t) => kp(e, Dp(t)), k = (e, t, r) => si(e, typeof t != "symbol" ? t + "" : t, r), se = (e, t, r) => new Promise((n, i) => {
  var o = (c) => {
    try {
      u(r.next(c));
    } catch (s) {
      i(s);
    }
  }, a = (c) => {
    try {
      u(r.throw(c));
    } catch (s) {
      i(s);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(o, a);
  u((r = r.apply(e, t)).next());
}), Ls = { exports: {} }, wo = { exports: {} }, Ao;
function $p() {
  return Ao || (Ao = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(Bi, function() {
      function r(y) {
        return !isNaN(parseFloat(y)) && isFinite(y);
      }
      function n(y) {
        return y.charAt(0).toUpperCase() + y.substring(1);
      }
      function i(y) {
        return function() {
          return this[y];
        };
      }
      var o = ["isConstructor", "isEval", "isNative", "isToplevel"], a = ["columnNumber", "lineNumber"], u = ["fileName", "functionName", "source"], c = ["args"], s = ["evalOrigin"], l = o.concat(a, u, c, s);
      function p(y) {
        if (y)
          for (var g = 0; g < l.length; g++)
            y[l[g]] !== void 0 && this["set" + n(l[g])](y[l[g]]);
      }
      p.prototype = {
        getArgs: function() {
          return this.args;
        },
        setArgs: function(y) {
          if (Object.prototype.toString.call(y) !== "[object Array]")
            throw new TypeError("Args must be an Array");
          this.args = y;
        },
        getEvalOrigin: function() {
          return this.evalOrigin;
        },
        setEvalOrigin: function(y) {
          if (y instanceof p)
            this.evalOrigin = y;
          else if (y instanceof Object)
            this.evalOrigin = new p(y);
          else
            throw new TypeError("Eval Origin must be an Object or StackFrame");
        },
        toString: function() {
          var y = this.getFileName() || "", g = this.getLineNumber() || "", E = this.getColumnNumber() || "", N = this.getFunctionName() || "";
          return this.getIsEval() ? y ? "[eval] (" + y + ":" + g + ":" + E + ")" : "[eval]:" + g + ":" + E : N ? N + " (" + y + ":" + g + ":" + E + ")" : y + ":" + g + ":" + E;
        }
      }, p.fromString = function(y) {
        var g = y.indexOf("("), E = y.lastIndexOf(")"), N = y.substring(0, g), j = y.substring(g + 1, E).split(","), U = y.substring(E + 1);
        if (U.indexOf("@") === 0)
          var F = /@(.+?)(?::(\d+))?(?::(\d+))?$/.exec(U, ""), D = F[1], H = F[2], $ = F[3];
        return new p({
          functionName: N,
          args: j || void 0,
          fileName: D,
          lineNumber: H || void 0,
          columnNumber: $ || void 0
        });
      };
      for (var f = 0; f < o.length; f++)
        p.prototype["get" + n(o[f])] = i(o[f]), p.prototype["set" + n(o[f])] = /* @__PURE__ */ function(y) {
          return function(g) {
            this[y] = !!g;
          };
        }(o[f]);
      for (var m = 0; m < a.length; m++)
        p.prototype["get" + n(a[m])] = i(a[m]), p.prototype["set" + n(a[m])] = /* @__PURE__ */ function(y) {
          return function(g) {
            if (!r(g))
              throw new TypeError(y + " must be a Number");
            this[y] = Number(g);
          };
        }(a[m]);
      for (var v = 0; v < u.length; v++)
        p.prototype["get" + n(u[v])] = i(u[v]), p.prototype["set" + n(u[v])] = /* @__PURE__ */ function(y) {
          return function(g) {
            this[y] = String(g);
          };
        }(u[v]);
      return p;
    });
  }(wo)), wo.exports;
}
(function(e, t) {
  (function(r, n) {
    e.exports = n($p());
  })(Bi, function(r) {
    var n = /(^|@)\S+:\d+/, i = /^\s*at .*(\S+:\d+|\(native\))/m, o = /^(eval@)?(\[native code])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function(a) {
        if (typeof a.stacktrace < "u" || typeof a["opera#sourceloc"] < "u")
          return this.parseOpera(a);
        if (a.stack && a.stack.match(i))
          return this.parseV8OrIE(a);
        if (a.stack)
          return this.parseFFOrSafari(a);
        throw new Error("Cannot parse given Error object");
      },
      // Separate line and column numbers from a string of the form: (URI:Line:Column)
      extractLocation: function(a) {
        if (a.indexOf(":") === -1)
          return [a];
        var u = /(.+?)(?::(\d+))?(?::(\d+))?$/, c = u.exec(a.replace(/[()]/g, ""));
        return [c[1], c[2] || void 0, c[3] || void 0];
      },
      parseV8OrIE: function(a) {
        var u = a.stack.split(`
`).filter(function(c) {
          return !!c.match(i);
        }, this);
        return u.map(function(c) {
          c.indexOf("(eval ") > -1 && (c = c.replace(/eval code/g, "eval").replace(/(\(eval at [^()]*)|(\),.*$)/g, ""));
          var s = c.replace(/^\s+/, "").replace(/\(eval code/g, "("), l = s.match(/ (\((.+):(\d+):(\d+)\)$)/);
          s = l ? s.replace(l[0], "") : s;
          var p = s.split(/\s+/).slice(1), f = this.extractLocation(l ? l[1] : p.pop()), m = p.join(" ") || void 0, v = ["eval", "<anonymous>"].indexOf(f[0]) > -1 ? void 0 : f[0];
          return new r({
            functionName: m,
            fileName: v,
            lineNumber: f[1],
            columnNumber: f[2],
            source: c
          });
        }, this);
      },
      parseFFOrSafari: function(a) {
        var u = a.stack.split(`
`).filter(function(c) {
          return !c.match(o);
        }, this);
        return u.map(function(c) {
          if (c.indexOf(" > eval") > -1 && (c = c.replace(/ line (\d+)(?: > eval line \d+)* > eval:\d+:\d+/g, ":$1")), c.indexOf("@") === -1 && c.indexOf(":") === -1)
            return new r({
              functionName: c
            });
          var s = /((.*".+"[^@]*)?[^@]*)(?:@)/, l = c.match(s), p = l && l[1] ? l[1] : void 0, f = this.extractLocation(c.replace(s, ""));
          return new r({
            functionName: p,
            fileName: f[0],
            lineNumber: f[1],
            columnNumber: f[2],
            source: c
          });
        }, this);
      },
      parseOpera: function(a) {
        return !a.stacktrace || a.message.indexOf(`
`) > -1 && a.message.split(`
`).length > a.stacktrace.split(`
`).length ? this.parseOpera9(a) : a.stack ? this.parseOpera11(a) : this.parseOpera10(a);
      },
      parseOpera9: function(a) {
        for (var u = /Line (\d+).*script (?:in )?(\S+)/i, c = a.message.split(`
`), s = [], l = 2, p = c.length; l < p; l += 2) {
          var f = u.exec(c[l]);
          f && s.push(new r({
            fileName: f[2],
            lineNumber: f[1],
            source: c[l]
          }));
        }
        return s;
      },
      parseOpera10: function(a) {
        for (var u = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, c = a.stacktrace.split(`
`), s = [], l = 0, p = c.length; l < p; l += 2) {
          var f = u.exec(c[l]);
          f && s.push(
            new r({
              functionName: f[3] || void 0,
              fileName: f[2],
              lineNumber: f[1],
              source: c[l]
            })
          );
        }
        return s;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function(a) {
        var u = a.stack.split(`
`).filter(function(c) {
          return !!c.match(n) && !c.match(/^Error created at/);
        }, this);
        return u.map(function(c) {
          var s = c.split("@"), l = this.extractLocation(s.pop()), p = s.shift() || "", f = p.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^)]*\)/g, "") || void 0, m;
          p.match(/\(([^)]*)\)/) && (m = p.replace(/^[^(]+\(([^)]*)\)$/, "$1"));
          var v = m === void 0 || m === "[arguments not available]" ? void 0 : m.split(",");
          return new r({
            functionName: f,
            args: v,
            fileName: l[0],
            lineNumber: l[1],
            columnNumber: l[2],
            source: c
          });
        }, this);
      }
    };
  });
})(Ls);
var Bp = Ls.exports;
const Lo = /* @__PURE__ */ Vr(Bp);
function Hr(e) {
  try {
    return Lo.parse(e);
  } catch (t) {
    try {
      return Lo.parse(new Error());
    } catch (r) {
      return console.warn("Highlight Warning: failed to parse error", {
        originalError: t,
        secondaryError: r
      }), [];
    }
  }
}
function Fp(e, t) {
  const r = t.logger;
  let n;
  n = window[r];
  const i = [];
  if (t.level.includes("error") && window) {
    const a = (u) => {
      const { message: c, error: s } = u;
      let l = [];
      s && (l = Hr(s));
      const p = [
        ni(c, t.stringifyOptions)
      ];
      e({
        type: "Error",
        trace: l,
        time: Date.now(),
        value: p
      });
    };
    window.addEventListener("error", a), i.push(() => {
      window && window.removeEventListener("error", a);
    });
  }
  for (const a of t.level)
    i.push(o(n, a));
  return () => {
    i.forEach((a) => a());
  };
  function o(a, u) {
    return a[u] ? $l(a, u, (c) => (...s) => {
      c.apply(this, s);
      try {
        e(Vp(u, t, ...s));
      } catch (l) {
        c("highlight logger error:", l, ...s);
      }
    }) : () => {
    };
  }
}
function Vp(e, t, ...r) {
  const n = Hr(new Error()), i = t.serializeConsoleAttributes ? r.map(
    (o) => typeof o == "object" ? ni(o, t.stringifyOptions) : o
  ) : r.filter((o) => typeof o != "object").map((o) => `${o}`);
  return {
    type: e,
    trace: n,
    value: i,
    attributes: ni(
      r.filter((o) => typeof o == "object").reduce((o, a) => M(M({}, o), a), {}),
      t.stringifyOptions
    ),
    time: Date.now()
  };
}
const Gp = {
  start: 0,
  end: 3
}, Hp = {
  start: 4,
  end: 5
}, un = {
  start: 6,
  end: 7
}, cn = {
  start: 8,
  end: 8
}, zp = {
  start: 9,
  end: 9
}, Xp = {
  start: 10,
  end: 15
};
function qp() {
  if (crypto && crypto.getRandomValues) {
    const t = new Uint8Array(16);
    return crypto.getRandomValues(t), [...t.values()];
  }
  const e = [];
  for (let t = 0; t < 16; t += 1)
    e.push(Math.floor(Math.random() * 256));
  return e;
}
function Jt(e, t) {
  let r = "";
  for (let n = t.start; n <= t.end; n += 1)
    r += e[n].toString(16).padStart(2, "0");
  return r;
}
function Kp(e) {
  return e[cn.start] = (e[cn.start] | 128) & 191, e[un.start] = e[un.start] & 15 | 64, `${Jt(e, Gp)}-${Jt(e, Hp)}-${Jt(e, un)}-${Jt(e, cn)}${Jt(e, zp)}-${Jt(e, Xp)}`;
}
function Wp() {
  const e = qp();
  return Kp(e);
}
function Rs() {
  return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : Wp();
}
function ln(e, t, r, n) {
  var i, o, a, u;
  let c = n ?? t, s = Hr(c), l = {};
  t instanceof Error && (t = t.message, t.cause && (l = { "exception.cause": t.cause }));
  const p = Jp(s);
  e({
    error: c,
    event: Ce(t),
    type: "window.onerror",
    url: window.location.href,
    source: r ?? "",
    lineNumber: (i = p[0]) != null && i.lineNumber ? (o = p[0]) == null ? void 0 : o.lineNumber : 0,
    columnNumber: (a = p[0]) != null && a.columnNumber ? (u = p[0]) == null ? void 0 : u.columnNumber : 0,
    stackTrace: p,
    timestamp: (/* @__PURE__ */ new Date()).toISOString(),
    payload: l ? Ce(l) : void 0,
    id: Rs()
  });
}
const Yp = (e, { enablePromisePatch: t }) => {
  if (typeof window > "u") return () => {
  };
  const r = window.onerror = (a, u, c, s, l) => {
    ln(e, a, u, l);
  }, n = window.onunhandledrejection = (a) => {
    if (a.reason) {
      const u = a.promise;
      u.getStack ? ln(
        e,
        a.reason,
        a.type,
        u.getStack()
      ) : ln(e, a.reason, a.type);
    }
  }, i = window.Promise, o = class extends i {
    constructor(a) {
      super(a), k(this, "promiseCreationError"), this.promiseCreationError = new Error();
    }
    getStack() {
      return this.promiseCreationError;
    }
    static shouldPatch() {
      const a = typeof window.Zone > "u";
      return t && a;
    }
  };
  return o.shouldPatch() && (window.Promise = o), () => {
    window.Promise = i, window.onunhandledrejection = n, window.onerror = r;
  };
}, Jp = (e) => {
  var t, r;
  if (e.length === 0)
    return e;
  const n = e[0];
  return (t = n.fileName) != null && t.includes("highlight.run") || (r = n.fileName) != null && r.includes("highlight.io") || n.functionName === "new highlightPromise" ? e.slice(1) : e;
}, Qp = [
  '["\\"Script error.\\""]',
  '"Script error."',
  '["\\"Load failed.\\""]',
  '"Load failed."',
  '["\\"Network request failed.\\""]',
  '"Network request failed."',
  '["\\"Document is not focused.\\""]',
  '"Document is not focused."',
  '["\\"Failed to fetch\\""]',
  '"Failed to fetch"',
  '[{"isTrusted":true}]',
  '{"isTrusted":true}',
  '["{}"]',
  '"{}"',
  '[""]',
  '""',
  '["\\"\\""]',
  '""'
], Zp = [
  "websocket error",
  '\\"ResizeObserver loop'
];
var tf = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, Ut = "1.9.0", Ro = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function ef(e) {
  var t = /* @__PURE__ */ new Set([e]), r = /* @__PURE__ */ new Set(), n = e.match(Ro);
  if (!n)
    return function() {
      return !1;
    };
  var i = {
    major: +n[1],
    minor: +n[2],
    patch: +n[3],
    prerelease: n[4]
  };
  if (i.prerelease != null)
    return function(u) {
      return u === e;
    };
  function o(u) {
    return r.add(u), !1;
  }
  function a(u) {
    return t.add(u), !0;
  }
  return function(u) {
    if (t.has(u))
      return !0;
    if (r.has(u))
      return !1;
    var c = u.match(Ro);
    if (!c)
      return o(u);
    var s = {
      major: +c[1],
      minor: +c[2],
      patch: +c[3],
      prerelease: c[4]
    };
    return s.prerelease != null || i.major !== s.major ? o(u) : i.major === 0 ? i.minor === s.minor && i.patch <= s.patch ? a(u) : o(u) : i.minor <= s.minor ? a(u) : o(u);
  };
}
var rf = ef(Ut), nf = Ut.split(".")[0], Ue = Symbol.for("opentelemetry.js.api." + nf), je = tf;
function ze(e, t, r, n) {
  var i;
  n === void 0 && (n = !1);
  var o = je[Ue] = (i = je[Ue]) !== null && i !== void 0 ? i : {
    version: Ut
  };
  if (!n && o[e]) {
    var a = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + e);
    return r.error(a.stack || a.message), !1;
  }
  if (o.version !== Ut) {
    var a = new Error("@opentelemetry/api: Registration of version v" + o.version + " for " + e + " does not match previously registered API v" + Ut);
    return r.error(a.stack || a.message), !1;
  }
  return o[e] = t, r.debug("@opentelemetry/api: Registered a global for " + e + " v" + Ut + "."), !0;
}
function Bt(e) {
  var t, r, n = (t = je[Ue]) === null || t === void 0 ? void 0 : t.version;
  if (!(!n || !rf(n)))
    return (r = je[Ue]) === null || r === void 0 ? void 0 : r[e];
}
function Xe(e, t) {
  t.debug("@opentelemetry/api: Unregistering a global for " + e + " v" + Ut + ".");
  var r = je[Ue];
  r && delete r[e];
}
var of = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, af = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, sf = (
  /** @class */
  function() {
    function e(t) {
      this._namespace = t.namespace || "DiagComponentLogger";
    }
    return e.prototype.debug = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Ee("debug", this._namespace, t);
    }, e.prototype.error = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Ee("error", this._namespace, t);
    }, e.prototype.info = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Ee("info", this._namespace, t);
    }, e.prototype.warn = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Ee("warn", this._namespace, t);
    }, e.prototype.verbose = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      return Ee("verbose", this._namespace, t);
    }, e;
  }()
);
function Ee(e, t, r) {
  var n = Bt("diag");
  if (n)
    return r.unshift(t), n[e].apply(n, af([], of(r), !1));
}
var P;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.ERROR = 30] = "ERROR", e[e.WARN = 50] = "WARN", e[e.INFO = 60] = "INFO", e[e.DEBUG = 70] = "DEBUG", e[e.VERBOSE = 80] = "VERBOSE", e[e.ALL = 9999] = "ALL";
})(P || (P = {}));
function uf(e, t) {
  e < P.NONE ? e = P.NONE : e > P.ALL && (e = P.ALL), t = t || {};
  function r(n, i) {
    var o = t[n];
    return typeof o == "function" && e >= i ? o.bind(t) : function() {
    };
  }
  return {
    error: r("error", P.ERROR),
    warn: r("warn", P.WARN),
    info: r("info", P.INFO),
    debug: r("debug", P.DEBUG),
    verbose: r("verbose", P.VERBOSE)
  };
}
var cf = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, lf = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, pf = "diag", ht = (
  /** @class */
  function() {
    function e() {
      function t(i) {
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var u = Bt("diag");
          if (u)
            return u[i].apply(u, lf([], cf(o), !1));
        };
      }
      var r = this, n = function(i, o) {
        var a, u, c;
        if (o === void 0 && (o = { logLevel: P.INFO }), i === r) {
          var s = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
          return r.error((a = s.stack) !== null && a !== void 0 ? a : s.message), !1;
        }
        typeof o == "number" && (o = {
          logLevel: o
        });
        var l = Bt("diag"), p = uf((u = o.logLevel) !== null && u !== void 0 ? u : P.INFO, i);
        if (l && !o.suppressOverrideMessage) {
          var f = (c = new Error().stack) !== null && c !== void 0 ? c : "<failed to generate stacktrace>";
          l.warn("Current logger will be overwritten from " + f), p.warn("Current logger will overwrite one already registered from " + f);
        }
        return ze("diag", p, r, !0);
      };
      r.setLogger = n, r.disable = function() {
        Xe(pf, r);
      }, r.createComponentLogger = function(i) {
        return new sf(i);
      }, r.verbose = t("verbose"), r.debug = t("debug"), r.info = t("info"), r.warn = t("warn"), r.error = t("error");
    }
    return e.instance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e;
  }()
), ff = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, hf = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, df = (
  /** @class */
  function() {
    function e(t) {
      this._entries = t ? new Map(t) : /* @__PURE__ */ new Map();
    }
    return e.prototype.getEntry = function(t) {
      var r = this._entries.get(t);
      if (r)
        return Object.assign({}, r);
    }, e.prototype.getAllEntries = function() {
      return Array.from(this._entries.entries()).map(function(t) {
        var r = ff(t, 2), n = r[0], i = r[1];
        return [n, i];
      });
    }, e.prototype.setEntry = function(t, r) {
      var n = new e(this._entries);
      return n._entries.set(t, r), n;
    }, e.prototype.removeEntry = function(t) {
      var r = new e(this._entries);
      return r._entries.delete(t), r;
    }, e.prototype.removeEntries = function() {
      for (var t, r, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      var o = new e(this._entries);
      try {
        for (var a = hf(n), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          o._entries.delete(c);
        }
      } catch (s) {
        t = { error: s };
      } finally {
        try {
          u && !u.done && (r = a.return) && r.call(a);
        } finally {
          if (t) throw t.error;
        }
      }
      return o;
    }, e.prototype.clear = function() {
      return new e();
    }, e;
  }()
), vf = Symbol("BaggageEntryMetadata"), mf = ht.instance();
function yf(e) {
  return e === void 0 && (e = {}), new df(new Map(Object.entries(e)));
}
function Cs(e) {
  return typeof e != "string" && (mf.error("Cannot create baggage metadata from unknown type: " + typeof e), e = ""), {
    __TYPE__: vf,
    toString: function() {
      return e;
    }
  };
}
function qe(e) {
  return Symbol.for(e);
}
var _f = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      var r = this;
      r._currentContext = t ? new Map(t) : /* @__PURE__ */ new Map(), r.getValue = function(n) {
        return r._currentContext.get(n);
      }, r.setValue = function(n, i) {
        var o = new e(r._currentContext);
        return o._currentContext.set(n, i), o;
      }, r.deleteValue = function(n) {
        var i = new e(r._currentContext);
        return i._currentContext.delete(n), i;
      };
    }
    return e;
  }()
), It = new _f(), Gt = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), gf = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.createGauge = function(t, r) {
      return Rf;
    }, e.prototype.createHistogram = function(t, r) {
      return Cf;
    }, e.prototype.createCounter = function(t, r) {
      return Lf;
    }, e.prototype.createUpDownCounter = function(t, r) {
      return Nf;
    }, e.prototype.createObservableGauge = function(t, r) {
      return Pf;
    }, e.prototype.createObservableCounter = function(t, r) {
      return xf;
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      return If;
    }, e.prototype.addBatchObservableCallback = function(t, r) {
    }, e.prototype.removeBatchObservableCallback = function(t) {
    }, e;
  }()
), zr = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
    }
    return e;
  }()
), Ef = (
  /** @class */
  function(e) {
    Gt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(zr)
), Tf = (
  /** @class */
  function(e) {
    Gt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n) {
    }, t;
  }(zr)
), bf = (
  /** @class */
  function(e) {
    Gt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(zr)
), Of = (
  /** @class */
  function(e) {
    Gt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n) {
    }, t;
  }(zr)
), Xi = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.addCallback = function(t) {
    }, e.prototype.removeCallback = function(t) {
    }, e;
  }()
), Sf = (
  /** @class */
  function(e) {
    Gt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Xi)
), wf = (
  /** @class */
  function(e) {
    Gt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Xi)
), Af = (
  /** @class */
  function(e) {
    Gt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Xi)
), Ns = new gf(), Lf = new Ef(), Rf = new bf(), Cf = new Of(), Nf = new Tf(), xf = new Sf(), Pf = new wf(), If = new Af();
function Mf() {
  return Ns;
}
var Ct;
(function(e) {
  e[e.INT = 0] = "INT", e[e.DOUBLE = 1] = "DOUBLE";
})(Ct || (Ct = {}));
var kf = {
  get: function(e, t) {
    if (e != null)
      return e[t];
  },
  keys: function(e) {
    return e == null ? [] : Object.keys(e);
  }
}, Df = {
  set: function(e, t, r) {
    e != null && (e[t] = r);
  }
}, Uf = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, jf = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, $f = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.active = function() {
      return It;
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      return r.call.apply(r, jf([n], Uf(i), !1));
    }, e.prototype.bind = function(t, r) {
      return r;
    }, e.prototype.enable = function() {
      return this;
    }, e.prototype.disable = function() {
      return this;
    }, e;
  }()
), Bf = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ff = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, pn = "context", Vf = new $f(), Xr = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalContextManager = function(t) {
      return ze(pn, t, ht.instance());
    }, e.prototype.active = function() {
      return this._getContextManager().active();
    }, e.prototype.with = function(t, r, n) {
      for (var i, o = [], a = 3; a < arguments.length; a++)
        o[a - 3] = arguments[a];
      return (i = this._getContextManager()).with.apply(i, Ff([t, r, n], Bf(o), !1));
    }, e.prototype.bind = function(t, r) {
      return this._getContextManager().bind(t, r);
    }, e.prototype._getContextManager = function() {
      return Bt(pn) || Vf;
    }, e.prototype.disable = function() {
      this._getContextManager().disable(), Xe(pn, ht.instance());
    }, e;
  }()
), dt;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(dt || (dt = {}));
var xs = "0000000000000000", Ps = "00000000000000000000000000000000", Is = {
  traceId: Ps,
  spanId: xs,
  traceFlags: dt.NONE
}, Ne = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = Is), this._spanContext = t;
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return this;
    }, e.prototype.setAttributes = function(t) {
      return this;
    }, e.prototype.addEvent = function(t, r) {
      return this;
    }, e.prototype.addLink = function(t) {
      return this;
    }, e.prototype.addLinks = function(t) {
      return this;
    }, e.prototype.setStatus = function(t) {
      return this;
    }, e.prototype.updateName = function(t) {
      return this;
    }, e.prototype.end = function(t) {
    }, e.prototype.isRecording = function() {
      return !1;
    }, e.prototype.recordException = function(t, r) {
    }, e;
  }()
), qi = qe("OpenTelemetry Context Key SPAN");
function Ki(e) {
  return e.getValue(qi) || void 0;
}
function Gf() {
  return Ki(Xr.getInstance().active());
}
function Wi(e, t) {
  return e.setValue(qi, t);
}
function Hf(e) {
  return e.deleteValue(qi);
}
function zf(e, t) {
  return Wi(e, new Ne(t));
}
function Ms(e) {
  var t;
  return (t = Ki(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
var Xf = /^([0-9a-f]{32})$/i, qf = /^[0-9a-f]{16}$/i;
function ks(e) {
  return Xf.test(e) && e !== Ps;
}
function Kf(e) {
  return qf.test(e) && e !== xs;
}
function Ke(e) {
  return ks(e.traceId) && Kf(e.spanId);
}
function Wf(e) {
  return new Ne(e);
}
var fn = Xr.getInstance(), Ds = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.startSpan = function(t, r, n) {
      n === void 0 && (n = fn.active());
      var i = !!(r != null && r.root);
      if (i)
        return new Ne();
      var o = n && Ms(n);
      return Yf(o) && Ke(o) ? new Ne(o) : new Ne();
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a ?? fn.active(), s = this.startSpan(t, o, c), l = Wi(c, s);
        return fn.with(l, u, void 0, s);
      }
    }, e;
  }()
);
function Yf(e) {
  return typeof e == "object" && typeof e.spanId == "string" && typeof e.traceId == "string" && typeof e.traceFlags == "number";
}
var Jf = new Ds(), Qf = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.startSpan = function(t, r, n) {
      return this._getTracer().startSpan(t, r, n);
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o = this._getTracer();
      return Reflect.apply(o.startActiveSpan, o, arguments);
    }, e.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Jf;
    }, e;
  }()
), Zf = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      return new Ds();
    }, e;
  }()
), th = new Zf(), Co = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i;
      return (i = this.getDelegateTracer(t, r, n)) !== null && i !== void 0 ? i : new Qf(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : th;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateTracer = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, r, n);
    }, e;
  }()
), Lr;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(Lr || (Lr = {}));
var $e;
(function(e) {
  e[e.INTERNAL = 0] = "INTERNAL", e[e.SERVER = 1] = "SERVER", e[e.CLIENT = 2] = "CLIENT", e[e.PRODUCER = 3] = "PRODUCER", e[e.CONSUMER = 4] = "CONSUMER";
})($e || ($e = {}));
var Rr;
(function(e) {
  e[e.UNSET = 0] = "UNSET", e[e.OK = 1] = "OK", e[e.ERROR = 2] = "ERROR";
})(Rr || (Rr = {}));
var C = Xr.getInstance(), T = ht.instance(), eh = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getMeter = function(t, r, n) {
      return Ns;
    }, e;
  }()
), rh = new eh(), hn = "metrics", nh = (
  /** @class */
  function() {
    function e() {
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalMeterProvider = function(t) {
      return ze(hn, t, ht.instance());
    }, e.prototype.getMeterProvider = function() {
      return Bt(hn) || rh;
    }, e.prototype.getMeter = function(t, r, n) {
      return this.getMeterProvider().getMeter(t, r, n);
    }, e.prototype.disable = function() {
      Xe(hn, ht.instance());
    }, e;
  }()
), pt = nh.getInstance(), ih = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r) {
    }, e.prototype.extract = function(t, r) {
      return t;
    }, e.prototype.fields = function() {
      return [];
    }, e;
  }()
), Yi = qe("OpenTelemetry Baggage Key");
function Us(e) {
  return e.getValue(Yi) || void 0;
}
function oh() {
  return Us(Xr.getInstance().active());
}
function ah(e, t) {
  return e.setValue(Yi, t);
}
function sh(e) {
  return e.deleteValue(Yi);
}
var dn = "propagation", uh = new ih(), ch = (
  /** @class */
  function() {
    function e() {
      this.createBaggage = yf, this.getBaggage = Us, this.getActiveBaggage = oh, this.setBaggage = ah, this.deleteBaggage = sh;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalPropagator = function(t) {
      return ze(dn, t, ht.instance());
    }, e.prototype.inject = function(t, r, n) {
      return n === void 0 && (n = Df), this._getGlobalPropagator().inject(t, r, n);
    }, e.prototype.extract = function(t, r, n) {
      return n === void 0 && (n = kf), this._getGlobalPropagator().extract(t, r, n);
    }, e.prototype.fields = function() {
      return this._getGlobalPropagator().fields();
    }, e.prototype.disable = function() {
      Xe(dn, ht.instance());
    }, e.prototype._getGlobalPropagator = function() {
      return Bt(dn) || uh;
    }, e;
  }()
), Q = ch.getInstance(), vn = "trace", lh = (
  /** @class */
  function() {
    function e() {
      this._proxyTracerProvider = new Co(), this.wrapSpanContext = Wf, this.isSpanContextValid = Ke, this.deleteSpan = Hf, this.getSpan = Ki, this.getActiveSpan = Gf, this.getSpanContext = Ms, this.setSpan = Wi, this.setSpanContext = zf;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalTracerProvider = function(t) {
      var r = ze(vn, this._proxyTracerProvider, ht.instance());
      return r && this._proxyTracerProvider.setDelegate(t), r;
    }, e.prototype.getTracerProvider = function() {
      return Bt(vn) || this._proxyTracerProvider;
    }, e.prototype.getTracer = function(t, r) {
      return this.getTracerProvider().getTracer(t, r);
    }, e.prototype.disable = function() {
      Xe(vn, ht.instance()), this._proxyTracerProvider = new Co();
    }, e;
  }()
), x = lh.getInstance(), ph = qe("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function js(e) {
  return e.getValue(ph) === !0;
}
var fh = "=", ui = ";", ci = ",", mn = "baggage", hh = 180, dh = 4096, vh = 8192, mh = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function yh(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? ci : "") + r;
    return n.length > vh ? t : n;
  }, "");
}
function _h(e) {
  return e.getAllEntries().map(function(t) {
    var r = mh(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += ui + i.metadata.toString()), o;
  });
}
function gh(e) {
  var t = e.split(ui);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf(fh);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = Cs(t.join(ui))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var Eh = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = Q.getBaggage(t);
      if (!(!i || js(t))) {
        var o = _h(i).filter(function(u) {
          return u.length <= dh;
        }).slice(0, hh), a = yh(o);
        a.length > 0 && n.set(r, mn, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, mn), o = Array.isArray(i) ? i.join(ci) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var u = o.split(ci);
      return u.forEach(function(c) {
        var s = gh(c);
        if (s) {
          var l = { value: s.value };
          s.metadata && (l.metadata = s.metadata), a[s.key] = l;
        }
      }), Object.entries(a).length === 0 ? t : Q.setBaggage(t, Q.createBaggage(a));
    }, e.prototype.fields = function() {
      return [mn];
    }, e;
  }()
), li;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(li || (li = {}));
var Th = ",", bh = ["OTEL_SDK_DISABLED"];
function Oh(e) {
  return bh.indexOf(e) > -1;
}
var Sh = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function wh(e) {
  return Sh.indexOf(e) > -1;
}
var Ah = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function Lh(e) {
  return Ah.indexOf(e) > -1;
}
var yn = 1 / 0, _n = 128, Rh = 128, Ch = 128, $s = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: P.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: yn,
  OTEL_ATTRIBUTE_COUNT_LIMIT: _n,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: yn,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: _n,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: yn,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: _n,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: Rh,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: Ch,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: li.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function Nh(e, t, r) {
  if (typeof r[e] < "u") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function xh(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] < "u") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function Ph(e, t, r, n) {
  n === void 0 && (n = Th);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var Ih = {
  ALL: P.ALL,
  VERBOSE: P.VERBOSE,
  DEBUG: P.DEBUG,
  INFO: P.INFO,
  WARN: P.WARN,
  ERROR: P.ERROR,
  NONE: P.NONE
};
function Mh(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = Ih[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function kh(e) {
  var t = {};
  for (var r in $s) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        Mh(n, t, e);
        break;
      default:
        if (Oh(n))
          Nh(n, t, e);
        else if (wh(n))
          xh(n, t, e);
        else if (Lh(n))
          Ph(n, t, e);
        else {
          var i = e[n];
          typeof i < "u" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var Dh = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function Uh() {
  var e = kh(Dh);
  return Object.assign({}, $s, e);
}
var pi = performance, jh = 9, $h = 6, Bh = Math.pow(10, $h), No = Math.pow(10, jh);
function xo(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * Bh);
  return [r, n];
}
function Fh() {
  var e = pi.timeOrigin;
  if (typeof e != "number") {
    var t = pi;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Vh(e) {
  var t = xo(Fh()), r = xo(pi.now());
  return Gh(t, r);
}
function Gh(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= No && (r[1] -= No, r[0] += 1), r;
}
var J;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(J || (J = {}));
var Hh = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, zh = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = Hh(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(t, r, n);
          } catch (s) {
            T.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          T.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), fi = "[_0-9a-z-*/]", Xh = "[a-z]" + fi + "{0,255}", qh = "[a-z0-9]" + fi + "{0,240}@[a-z]" + fi + "{0,13}", Kh = new RegExp("^(?:" + Xh + "|" + qh + ")$"), Wh = /^[ -~]{0,255}[!-~]$/, Yh = /,|=/;
function Jh(e) {
  return Kh.test(e);
}
function Qh(e) {
  return Wh.test(e) && !Yh.test(e);
}
var Po = 32, Zh = 512, Io = ",", Mo = "=", td = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + Mo + t.get(n)), r;
      }, []).join(Io);
    }, e.prototype._parse = function(t) {
      t.length > Zh || (this._internalState = t.split(Io).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(Mo);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, n.length);
          Jh(a) && Qh(u) && r.set(a, u);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > Po && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, Po))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), gn = "traceparent", En = "tracestate", ed = "00", rd = "(?!ff)[\\da-f]{2}", nd = "(?![0]{32})[\\da-f]{32}", id = "(?![0]{16})[\\da-f]{16}", od = "[\\da-f]{2}", ad = new RegExp("^\\s?(" + rd + ")-(" + nd + ")-(" + id + ")-(" + od + ")(-.*)?\\s?$");
function sd(e) {
  var t = ad.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var ud = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = x.getSpanContext(t);
      if (!(!i || js(t) || !Ke(i))) {
        var o = ed + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || dt.NONE).toString(16);
        n.set(r, gn, o), i.traceState && n.set(r, En, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, gn);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = sd(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var u = n.get(r, En);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new td(typeof c == "string" ? c : void 0);
      }
      return x.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [gn, En];
    }, e;
  }()
), cd = "[object Object]", ld = "[object Null]", pd = "[object Undefined]", fd = Function.prototype, Bs = fd.toString, hd = Bs.call(Object), dd = vd(Object.getPrototypeOf, Object), Fs = Object.prototype, Vs = Fs.hasOwnProperty, Mt = Symbol ? Symbol.toStringTag : void 0, Gs = Fs.toString;
function vd(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function ko(e) {
  if (!md(e) || yd(e) !== cd)
    return !1;
  var t = dd(e);
  if (t === null)
    return !0;
  var r = Vs.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && Bs.call(r) === hd;
}
function md(e) {
  return e != null && typeof e == "object";
}
function yd(e) {
  return e == null ? e === void 0 ? pd : ld : Mt && Mt in Object(e) ? _d(e) : gd(e);
}
function _d(e) {
  var t = Vs.call(e, Mt), r = e[Mt], n = !1;
  try {
    e[Mt] = void 0, n = !0;
  } catch {
  }
  var i = Gs.call(e);
  return n && (t ? e[Mt] = r : delete e[Mt]), i;
}
function gd(e) {
  return Gs.call(e);
}
var Ed = 20;
function Td() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = Hs(r, e.shift(), 0, n);
  return r;
}
function Tn(e) {
  return Cr(e) ? e.slice() : e;
}
function Hs(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > Ed)) {
    if (r++, yr(e) || yr(t) || zs(t))
      i = Tn(t);
    else if (Cr(e)) {
      if (i = e.slice(), Cr(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(Tn(t[o]));
      else if (Te(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = Tn(t[c]);
        }
    } else if (Te(e))
      if (Te(t)) {
        if (!bd(e, t))
          return t;
        i = Object.assign({}, e);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = t[c];
          if (yr(s))
            typeof s > "u" ? delete i[c] : i[c] = s;
          else {
            var l = i[c], p = s;
            if (Do(e, c, n) || Do(t, c, n))
              delete i[c];
            else {
              if (Te(l) && Te(p)) {
                var f = n.get(l) || [], m = n.get(p) || [];
                f.push({ obj: e, key: c }), m.push({ obj: t, key: c }), n.set(l, f), n.set(p, m);
              }
              i[c] = Hs(i[c], s, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function Do(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function Cr(e) {
  return Array.isArray(e);
}
function zs(e) {
  return typeof e == "function";
}
function Te(e) {
  return !yr(e) && !Cr(e) && !zs(e) && typeof e == "object";
}
function yr(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e > "u" || e instanceof Date || e instanceof RegExp || e === null;
}
function bd(e, t) {
  return !(!ko(e) || !ko(t));
}
var Xs = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), Od = new Xs(), Sd = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new Xs();
    }, e;
  }()
), qs = new Sd(), wd = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : Od;
    }, e;
  }()
), Uo = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      var i;
      return (i = this.getDelegateLogger(t, r, n)) !== null && i !== void 0 ? i : new wd(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : qs;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, r, n);
    }, e;
  }()
), Ad = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, er = Symbol.for("io.opentelemetry.js.api.logs"), be = Ad;
function Ld(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var jo = 1, Rd = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new Uo();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return be[er] ? this.getLoggerProvider() : (be[er] = Ld(jo, t, qs), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = be[er]) === null || t === void 0 ? void 0 : t.call(be, jo)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete be[er], this._proxyLoggerProvider = new Uo();
    }, e;
  }()
), We = Rd.getInstance();
function Cd(e, t, r, n) {
  for (var i = 0, o = e.length; i < o; i++) {
    var a = e[i];
    t && a.setTracerProvider(t), r && a.setMeterProvider(r), n && a.setLoggerProvider && a.setLoggerProvider(n), a.getConfig().enabled || a.enable();
  }
}
function Nd(e) {
  e.forEach(function(t) {
    return t.disable();
  });
}
function xd(e) {
  var t, r, n = e.tracerProvider || x.getTracerProvider(), i = e.meterProvider || pt.getMeterProvider(), o = e.loggerProvider || We.getLoggerProvider(), a = (r = (t = e.instrumentations) === null || t === void 0 ? void 0 : t.flat()) !== null && r !== void 0 ? r : [];
  return Cd(a, n, i, o), function() {
    Nd(a);
  };
}
function hi(e) {
  return typeof e == "function";
}
var Z = console.error.bind(console);
function Oe(e, t, r) {
  var n = !!e[t] && e.propertyIsEnumerable(t);
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: n,
    writable: !0,
    value: r
  });
}
function Ye(e) {
  e && e.logger && (hi(e.logger) ? Z = e.logger : Z("new logger isn't a function, not replacing"));
}
function Ks(e, t, r) {
  if (!e || !e[t]) {
    Z("no original function " + t + " to wrap");
    return;
  }
  if (!r) {
    Z("no wrapper function"), Z(new Error().stack);
    return;
  }
  if (!hi(e[t]) || !hi(r)) {
    Z("original object and wrapper must be functions");
    return;
  }
  var n = e[t], i = r(n, t);
  return Oe(i, "__original", n), Oe(i, "__unwrap", function() {
    e[t] === i && Oe(e, t, n);
  }), Oe(i, "__wrapped", !0), Oe(e, t, i), i;
}
function Pd(e, t, r) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    Z("must provide one or more modules to patch"), Z(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    Z("must provide one or more functions to wrap on modules");
    return;
  }
  e.forEach(function(n) {
    t.forEach(function(i) {
      Ks(n, i, r);
    });
  });
}
function Ws(e, t) {
  if (!e || !e[t]) {
    Z("no function to unwrap."), Z(new Error().stack);
    return;
  }
  if (!e[t].__unwrap)
    Z("no original to unwrap to -- has " + t + " already been unwrapped?");
  else
    return e[t].__unwrap();
}
function Id(e, t) {
  if (e)
    Array.isArray(e) || (e = [e]);
  else {
    Z("must provide one or more modules to patch"), Z(new Error().stack);
    return;
  }
  if (!(t && Array.isArray(t))) {
    Z("must provide one or more functions to unwrap on modules");
    return;
  }
  e.forEach(function(r) {
    t.forEach(function(n) {
      Ws(r, n);
    });
  });
}
Ye.wrap = Ks;
Ye.massWrap = Pd;
Ye.unwrap = Ws;
Ye.massUnwrap = Id;
var q = Ye, di = function() {
  return di = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, di.apply(this, arguments);
}, Md = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = q.wrap, this._unwrap = q.unwrap, this._massWrap = q.massWrap, this._massUnwrap = q.massUnwrap, this.setConfig(n), this._diag = T.createComponentLogger({
        namespace: t
      }), this._tracer = x.getTracer(t, r), this._meter = pt.getMeter(t, r), this._logger = We.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = di({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), kd = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Dd = (
  /** @class */
  function(e) {
    kd(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(Md)
);
function W(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var Nr = performance, Ud = "traceparent", Ys = qe("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function jd(e) {
  return e.setValue(Ys, !0);
}
function Ji(e) {
  return e.getValue(Ys) === !0;
}
var $d = "=", vi = ";", mi = ",", bn = "baggage", Bd = 180, Fd = 4096, Vd = 8192, Gd = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Hd(e) {
  return e.reduce(function(t, r) {
    var n = "" + t + (t !== "" ? mi : "") + r;
    return n.length > Vd ? t : n;
  }, "");
}
function zd(e) {
  return e.getAllEntries().map(function(t) {
    var r = Gd(t, 2), n = r[0], i = r[1], o = encodeURIComponent(n) + "=" + encodeURIComponent(i.value);
    return i.metadata !== void 0 && (o += vi + i.metadata.toString()), o;
  });
}
function Xd(e) {
  var t = e.split(vi);
  if (!(t.length <= 0)) {
    var r = t.shift();
    if (r) {
      var n = r.indexOf($d);
      if (!(n <= 0)) {
        var i = decodeURIComponent(r.substring(0, n).trim()), o = decodeURIComponent(r.substring(n + 1).trim()), a;
        return t.length > 0 && (a = Cs(t.join(vi))), { key: i, value: o, metadata: a };
      }
    }
  }
}
var qd = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = Q.getBaggage(t);
      if (!(!i || Ji(t))) {
        var o = zd(i).filter(function(u) {
          return u.length <= Fd;
        }).slice(0, Bd), a = Hd(o);
        a.length > 0 && n.set(r, bn, a);
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, bn), o = Array.isArray(i) ? i.join(mi) : i;
      if (!o)
        return t;
      var a = {};
      if (o.length === 0)
        return t;
      var u = o.split(mi);
      return u.forEach(function(c) {
        var s = Xd(c);
        if (s) {
          var l = { value: s.value };
          s.metadata && (l.metadata = s.metadata), a[s.key] = l;
        }
      }), Object.entries(a).length === 0 ? t : Q.setBaggage(t, Q.createBaggage(a));
    }, e.prototype.fields = function() {
      return [bn];
    }, e;
  }()
), Js = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Kd = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function _r(e) {
  var t, r, n = {};
  if (typeof e != "object" || e == null)
    return n;
  try {
    for (var i = Js(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
      var a = Kd(o.value, 2), u = a[0], c = a[1];
      if (!Wd(u)) {
        T.warn("Invalid attribute key: " + u);
        continue;
      }
      if (!Qs(c)) {
        T.warn("Invalid attribute value set for key: " + u);
        continue;
      }
      Array.isArray(c) ? n[u] = c.slice() : n[u] = c;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function Wd(e) {
  return typeof e == "string" && e.length > 0;
}
function Qs(e) {
  return e == null ? !0 : Array.isArray(e) ? Yd(e) : Zs(e);
}
function Yd(e) {
  var t, r, n;
  try {
    for (var i = Js(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!n) {
          if (Zs(a)) {
            n = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== n)
          return !1;
      }
    }
  } catch (u) {
    t = { error: u };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function Zs(e) {
  switch (typeof e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
function Jd() {
  return function(e) {
    T.error(Qd(e));
  };
}
function Qd(e) {
  return typeof e == "string" ? e : JSON.stringify(Zd(e));
}
function Zd(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!t[n]) {
        var i = r[n];
        i && (t[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var tv = Jd();
function pe(e) {
  try {
    tv(e);
  } catch {
  }
}
var ct;
(function(e) {
  e.AlwaysOff = "always_off", e.AlwaysOn = "always_on", e.ParentBasedAlwaysOff = "parentbased_always_off", e.ParentBasedAlwaysOn = "parentbased_always_on", e.ParentBasedTraceIdRatio = "parentbased_traceidratio", e.TraceIdRatio = "traceidratio";
})(ct || (ct = {}));
var ev = ",", rv = ["OTEL_SDK_DISABLED"];
function nv(e) {
  return rv.indexOf(e) > -1;
}
var iv = [
  "OTEL_BSP_EXPORT_TIMEOUT",
  "OTEL_BSP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BSP_MAX_QUEUE_SIZE",
  "OTEL_BSP_SCHEDULE_DELAY",
  "OTEL_BLRP_EXPORT_TIMEOUT",
  "OTEL_BLRP_MAX_EXPORT_BATCH_SIZE",
  "OTEL_BLRP_MAX_QUEUE_SIZE",
  "OTEL_BLRP_SCHEDULE_DELAY",
  "OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT",
  "OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT",
  "OTEL_SPAN_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_LINK_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT",
  "OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT",
  "OTEL_EXPORTER_OTLP_TIMEOUT",
  "OTEL_EXPORTER_OTLP_TRACES_TIMEOUT",
  "OTEL_EXPORTER_OTLP_METRICS_TIMEOUT",
  "OTEL_EXPORTER_OTLP_LOGS_TIMEOUT",
  "OTEL_EXPORTER_JAEGER_AGENT_PORT"
];
function ov(e) {
  return iv.indexOf(e) > -1;
}
var av = [
  "OTEL_NO_PATCH_MODULES",
  "OTEL_PROPAGATORS",
  "OTEL_SEMCONV_STABILITY_OPT_IN"
];
function sv(e) {
  return av.indexOf(e) > -1;
}
var gr = 1 / 0, Er = 128, uv = 128, cv = 128, tu = {
  OTEL_SDK_DISABLED: !1,
  CONTAINER_NAME: "",
  ECS_CONTAINER_METADATA_URI_V4: "",
  ECS_CONTAINER_METADATA_URI: "",
  HOSTNAME: "",
  KUBERNETES_SERVICE_HOST: "",
  NAMESPACE: "",
  OTEL_BSP_EXPORT_TIMEOUT: 3e4,
  OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BSP_MAX_QUEUE_SIZE: 2048,
  OTEL_BSP_SCHEDULE_DELAY: 5e3,
  OTEL_BLRP_EXPORT_TIMEOUT: 3e4,
  OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
  OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
  OTEL_BLRP_SCHEDULE_DELAY: 5e3,
  OTEL_EXPORTER_JAEGER_AGENT_HOST: "",
  OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
  OTEL_EXPORTER_JAEGER_ENDPOINT: "",
  OTEL_EXPORTER_JAEGER_PASSWORD: "",
  OTEL_EXPORTER_JAEGER_USER: "",
  OTEL_EXPORTER_OTLP_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: "",
  OTEL_EXPORTER_OTLP_HEADERS: "",
  OTEL_EXPORTER_OTLP_TRACES_HEADERS: "",
  OTEL_EXPORTER_OTLP_METRICS_HEADERS: "",
  OTEL_EXPORTER_OTLP_LOGS_HEADERS: "",
  OTEL_EXPORTER_OTLP_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 1e4,
  OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 1e4,
  OTEL_EXPORTER_ZIPKIN_ENDPOINT: "http://localhost:9411/api/v2/spans",
  OTEL_LOG_LEVEL: P.INFO,
  OTEL_NO_PATCH_MODULES: [],
  OTEL_PROPAGATORS: ["tracecontext", "baggage"],
  OTEL_RESOURCE_ATTRIBUTES: "",
  OTEL_SERVICE_NAME: "",
  OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: gr,
  OTEL_ATTRIBUTE_COUNT_LIMIT: Er,
  OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: gr,
  OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: Er,
  OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: gr,
  OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: Er,
  OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
  OTEL_SPAN_LINK_COUNT_LIMIT: 128,
  OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: uv,
  OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: cv,
  OTEL_TRACES_EXPORTER: "",
  OTEL_TRACES_SAMPLER: ct.ParentBasedAlwaysOn,
  OTEL_TRACES_SAMPLER_ARG: "",
  OTEL_LOGS_EXPORTER: "",
  OTEL_EXPORTER_OTLP_INSECURE: "",
  OTEL_EXPORTER_OTLP_TRACES_INSECURE: "",
  OTEL_EXPORTER_OTLP_METRICS_INSECURE: "",
  OTEL_EXPORTER_OTLP_LOGS_INSECURE: "",
  OTEL_EXPORTER_OTLP_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: "",
  OTEL_EXPORTER_OTLP_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: "",
  OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: "",
  OTEL_EXPORTER_OTLP_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: "http/protobuf",
  OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: "cumulative",
  OTEL_SEMCONV_STABILITY_OPT_IN: []
};
function lv(e, t, r) {
  if (typeof r[e] < "u") {
    var n = String(r[e]);
    t[e] = n.toLowerCase() === "true";
  }
}
function pv(e, t, r, n, i) {
  if (n === void 0 && (n = -1 / 0), i === void 0 && (i = 1 / 0), typeof r[e] < "u") {
    var o = Number(r[e]);
    isNaN(o) || (o < n ? t[e] = n : o > i ? t[e] = i : t[e] = o);
  }
}
function fv(e, t, r, n) {
  n === void 0 && (n = ev);
  var i = r[e];
  typeof i == "string" && (t[e] = i.split(n).map(function(o) {
    return o.trim();
  }));
}
var hv = {
  ALL: P.ALL,
  VERBOSE: P.VERBOSE,
  DEBUG: P.DEBUG,
  INFO: P.INFO,
  WARN: P.WARN,
  ERROR: P.ERROR,
  NONE: P.NONE
};
function dv(e, t, r) {
  var n = r[e];
  if (typeof n == "string") {
    var i = hv[n.toUpperCase()];
    i != null && (t[e] = i);
  }
}
function eu(e) {
  var t = {};
  for (var r in tu) {
    var n = r;
    switch (n) {
      case "OTEL_LOG_LEVEL":
        dv(n, t, e);
        break;
      default:
        if (nv(n))
          lv(n, t, e);
        else if (ov(n))
          pv(n, t, e);
        else if (sv(n))
          fv(n, t, e);
        else {
          var i = e[n];
          typeof i < "u" && i !== null && (t[n] = String(i));
        }
    }
  }
  return t;
}
var ru = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {};
function Be() {
  var e = eu(ru);
  return Object.assign({}, tu, e);
}
function vv() {
  return eu(ru);
}
var ue = performance, mv = "exception.type", yv = "exception.message", _v = "exception.stacktrace", gv = "http.response_content_length", Ev = "http.response_content_length_uncompressed", On = mv, Sn = yv, Tv = _v, bv = gv, Ov = Ev, Sv = 9, wv = 6, Av = Math.pow(10, wv), xr = Math.pow(10, Sv);
function At(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * Av);
  return [r, n];
}
function Qi() {
  var e = ue.timeOrigin;
  if (typeof e != "number") {
    var t = ue;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function nu(e) {
  var t = At(Qi()), r = At(typeof e == "number" ? e : ue.now());
  return iu(t, r);
}
function xe(e) {
  if (Zi(e))
    return e;
  if (typeof e == "number")
    return e < Qi() ? nu(e) : At(e);
  if (e instanceof Date)
    return At(e.getTime());
  throw TypeError("Invalid input type");
}
function Lv(e, t) {
  var r = t[0] - e[0], n = t[1] - e[1];
  return n < 0 && (r -= 1, n += xr), [r, n];
}
function Lt(e) {
  return e[0] * xr + e[1];
}
function Zi(e) {
  return Array.isArray(e) && e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number";
}
function $o(e) {
  return Zi(e) || typeof e == "number" || e instanceof Date;
}
function iu(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= xr && (r[1] -= xr, r[0] += 1), r;
}
var yi;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(yi || (yi = {}));
var Rv = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Cv = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r;
      this._propagators = (r = t.propagators) !== null && r !== void 0 ? r : [], this._fields = Array.from(new Set(this._propagators.map(function(n) {
        return typeof n.fields == "function" ? n.fields() : [];
      }).reduce(function(n, i) {
        return n.concat(i);
      }, [])));
    }
    return e.prototype.inject = function(t, r, n) {
      var i, o;
      try {
        for (var a = Rv(this._propagators), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          try {
            c.inject(t, r, n);
          } catch (s) {
            T.warn("Failed to inject with " + c.constructor.name + ". Err: " + s.message);
          }
        }
      } catch (s) {
        i = { error: s };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
    }, e.prototype.extract = function(t, r, n) {
      return this._propagators.reduce(function(i, o) {
        try {
          return o.extract(i, r, n);
        } catch (a) {
          T.warn("Failed to extract with " + o.constructor.name + ". Err: " + a.message);
        }
        return i;
      }, t);
    }, e.prototype.fields = function() {
      return this._fields.slice();
    }, e;
  }()
), _i = "[_0-9a-z-*/]", Nv = "[a-z]" + _i + "{0,255}", xv = "[a-z0-9]" + _i + "{0,240}@[a-z]" + _i + "{0,13}", Pv = new RegExp("^(?:" + Nv + "|" + xv + ")$"), Iv = /^[ -~]{0,255}[!-~]$/, Mv = /,|=/;
function kv(e) {
  return Pv.test(e);
}
function Dv(e) {
  return Iv.test(e) && !Mv.test(e);
}
var Bo = 32, Uv = 512, Fo = ",", Vo = "=", jv = (
  /** @class */
  function() {
    function e(t) {
      this._internalState = /* @__PURE__ */ new Map(), t && this._parse(t);
    }
    return e.prototype.set = function(t, r) {
      var n = this._clone();
      return n._internalState.has(t) && n._internalState.delete(t), n._internalState.set(t, r), n;
    }, e.prototype.unset = function(t) {
      var r = this._clone();
      return r._internalState.delete(t), r;
    }, e.prototype.get = function(t) {
      return this._internalState.get(t);
    }, e.prototype.serialize = function() {
      var t = this;
      return this._keys().reduce(function(r, n) {
        return r.push(n + Vo + t.get(n)), r;
      }, []).join(Fo);
    }, e.prototype._parse = function(t) {
      t.length > Uv || (this._internalState = t.split(Fo).reverse().reduce(function(r, n) {
        var i = n.trim(), o = i.indexOf(Vo);
        if (o !== -1) {
          var a = i.slice(0, o), u = i.slice(o + 1, n.length);
          kv(a) && Dv(u) && r.set(a, u);
        }
        return r;
      }, /* @__PURE__ */ new Map()), this._internalState.size > Bo && (this._internalState = new Map(Array.from(this._internalState.entries()).reverse().slice(0, Bo))));
    }, e.prototype._keys = function() {
      return Array.from(this._internalState.keys()).reverse();
    }, e.prototype._clone = function() {
      var t = new e();
      return t._internalState = new Map(this._internalState), t;
    }, e;
  }()
), wn = "traceparent", An = "tracestate", $v = "00", Bv = "(?!ff)[\\da-f]{2}", Fv = "(?![0]{32})[\\da-f]{32}", Vv = "(?![0]{16})[\\da-f]{16}", Gv = "[\\da-f]{2}", Hv = new RegExp("^\\s?(" + Bv + ")-(" + Fv + ")-(" + Vv + ")-(" + Gv + ")(-.*)?\\s?$");
function zv(e) {
  var t = Hv.exec(e);
  return !t || t[1] === "00" && t[5] ? null : {
    traceId: t[2],
    spanId: t[3],
    traceFlags: parseInt(t[4], 16)
  };
}
var Xv = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.inject = function(t, r, n) {
      var i = x.getSpanContext(t);
      if (!(!i || Ji(t) || !Ke(i))) {
        var o = $v + "-" + i.traceId + "-" + i.spanId + "-0" + Number(i.traceFlags || dt.NONE).toString(16);
        n.set(r, wn, o), i.traceState && n.set(r, An, i.traceState.serialize());
      }
    }, e.prototype.extract = function(t, r, n) {
      var i = n.get(r, wn);
      if (!i)
        return t;
      var o = Array.isArray(i) ? i[0] : i;
      if (typeof o != "string")
        return t;
      var a = zv(o);
      if (!a)
        return t;
      a.isRemote = !0;
      var u = n.get(r, An);
      if (u) {
        var c = Array.isArray(u) ? u.join(",") : u;
        a.traceState = new jv(typeof c == "string" ? c : void 0);
      }
      return x.setSpanContext(t, a);
    }, e.prototype.fields = function() {
      return [wn, An];
    }, e;
  }()
), qv = "[object Object]", Kv = "[object Null]", Wv = "[object Undefined]", Yv = Function.prototype, ou = Yv.toString, Jv = ou.call(Object), Qv = Zv(Object.getPrototypeOf, Object), au = Object.prototype, su = au.hasOwnProperty, kt = Symbol ? Symbol.toStringTag : void 0, uu = au.toString;
function Zv(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function Go(e) {
  if (!tm(e) || em(e) !== qv)
    return !1;
  var t = Qv(e);
  if (t === null)
    return !0;
  var r = su.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && ou.call(r) === Jv;
}
function tm(e) {
  return e != null && typeof e == "object";
}
function em(e) {
  return e == null ? e === void 0 ? Wv : Kv : kt && kt in Object(e) ? rm(e) : nm(e);
}
function rm(e) {
  var t = su.call(e, kt), r = e[kt], n = !1;
  try {
    e[kt] = void 0, n = !0;
  } catch {
  }
  var i = uu.call(e);
  return n && (t ? e[kt] = r : delete e[kt]), i;
}
function nm(e) {
  return uu.call(e);
}
var im = 20;
function om() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = cu(r, e.shift(), 0, n);
  return r;
}
function Ln(e) {
  return Pr(e) ? e.slice() : e;
}
function cu(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > im)) {
    if (r++, Tr(e) || Tr(t) || lu(t))
      i = Ln(t);
    else if (Pr(e)) {
      if (i = e.slice(), Pr(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(Ln(t[o]));
      else if (Se(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o];
          i[c] = Ln(t[c]);
        }
    } else if (Se(e))
      if (Se(t)) {
        if (!am(e, t))
          return t;
        i = Object.assign({}, e);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var c = u[o], s = t[c];
          if (Tr(s))
            typeof s > "u" ? delete i[c] : i[c] = s;
          else {
            var l = i[c], p = s;
            if (Ho(e, c, n) || Ho(t, c, n))
              delete i[c];
            else {
              if (Se(l) && Se(p)) {
                var f = n.get(l) || [], m = n.get(p) || [];
                f.push({ obj: e, key: c }), m.push({ obj: t, key: c }), n.set(l, f), n.set(p, m);
              }
              i[c] = cu(i[c], s, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function Ho(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function Pr(e) {
  return Array.isArray(e);
}
function lu(e) {
  return typeof e == "function";
}
function Se(e) {
  return !Tr(e) && !Pr(e) && !lu(e) && typeof e == "object";
}
function Tr(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e > "u" || e instanceof Date || e instanceof RegExp || e === null;
}
function am(e, t) {
  return !(!Go(e) || !Go(t));
}
function sm(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
var um = (
  /** @class */
  function() {
    function e() {
      var t = this;
      this._promise = new Promise(function(r, n) {
        t._resolve = r, t._reject = n;
      });
    }
    return Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolve = function(t) {
      this._resolve(t);
    }, e.prototype.reject = function(t) {
      this._reject(t);
    }, e;
  }()
), cm = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, lm = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, pm = (
  /** @class */
  function() {
    function e(t, r) {
      this._callback = t, this._that = r, this._isCalled = !1, this._deferred = new um();
    }
    return Object.defineProperty(e.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.call = function() {
      for (var t, r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((t = this._callback).call.apply(t, lm([this._that], cm(n), !1))).then(function(o) {
            return r._deferred.resolve(o);
          }, function(o) {
            return r._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, e;
  }()
), fm = "exception", gi = function() {
  return gi = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, gi.apply(this, arguments);
}, hm = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, zo = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, dm = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, vm = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, u, c, s, l) {
      u === void 0 && (u = []), this.attributes = {}, this.links = [], this.events = [], this._droppedAttributesCount = 0, this._droppedEventsCount = 0, this._droppedLinksCount = 0, this.status = {
        code: Rr.UNSET
      }, this.endTime = [0, 0], this._ended = !1, this._duration = [-1, -1], this.name = n, this._spanContext = i, this.parentSpanId = a, this.kind = o, this.links = u;
      var p = Date.now();
      this._performanceStartTime = ue.now(), this._performanceOffset = p - (this._performanceStartTime + Qi()), this._startTimeProvided = c != null, this.startTime = this._getTime(c ?? p), this.resource = t.resource, this.instrumentationLibrary = t.instrumentationLibrary, this._spanLimits = t.getSpanLimits(), this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0, l != null && this.setAttributes(l), this._spanProcessor = t.getActiveSpanProcessor(), this._spanProcessor.onStart(this, r);
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return r == null || this._isSpanEnded() ? this : t.length === 0 ? (T.warn("Invalid attribute key: " + t), this) : Qs(r) ? Object.keys(this.attributes).length >= this._spanLimits.attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, t) ? (this._droppedAttributesCount++, this) : (this.attributes[t] = this._truncateToSize(r), this) : (T.warn("Invalid attribute value set for key: " + t), this);
    }, e.prototype.setAttributes = function(t) {
      var r, n;
      try {
        for (var i = hm(Object.entries(t)), o = i.next(); !o.done; o = i.next()) {
          var a = zo(o.value, 2), u = a[0], c = a[1];
          this.setAttribute(u, c);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
      return this;
    }, e.prototype.addEvent = function(t, r, n) {
      if (this._isSpanEnded())
        return this;
      if (this._spanLimits.eventCountLimit === 0)
        return T.warn("No events allowed."), this._droppedEventsCount++, this;
      this.events.length >= this._spanLimits.eventCountLimit && (this._droppedEventsCount === 0 && T.debug("Dropping extra events."), this.events.shift(), this._droppedEventsCount++), $o(r) && ($o(n) || (n = r), r = void 0);
      var i = _r(r);
      return this.events.push({
        name: t,
        attributes: i,
        time: this._getTime(n),
        droppedAttributesCount: 0
      }), this;
    }, e.prototype.addLink = function(t) {
      return this.links.push(t), this;
    }, e.prototype.addLinks = function(t) {
      var r;
      return (r = this.links).push.apply(r, dm([], zo(t), !1)), this;
    }, e.prototype.setStatus = function(t) {
      return this._isSpanEnded() ? this : (this.status = gi({}, t), this.status.message != null && typeof t.message != "string" && (T.warn("Dropping invalid status.message of type '" + typeof t.message + "', expected 'string'"), delete this.status.message), this);
    }, e.prototype.updateName = function(t) {
      return this._isSpanEnded() ? this : (this.name = t, this);
    }, e.prototype.end = function(t) {
      if (this._isSpanEnded()) {
        T.error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
        return;
      }
      this._ended = !0, this.endTime = this._getTime(t), this._duration = Lv(this.startTime, this.endTime), this._duration[0] < 0 && (T.warn("Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.", this.startTime, this.endTime), this.endTime = this.startTime.slice(), this._duration = [0, 0]), this._droppedEventsCount > 0 && T.warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached"), this._spanProcessor.onEnd(this);
    }, e.prototype._getTime = function(t) {
      if (typeof t == "number" && t <= ue.now())
        return nu(t + this._performanceOffset);
      if (typeof t == "number")
        return At(t);
      if (t instanceof Date)
        return At(t.getTime());
      if (Zi(t))
        return t;
      if (this._startTimeProvided)
        return At(Date.now());
      var r = ue.now() - this._performanceStartTime;
      return iu(this.startTime, At(r));
    }, e.prototype.isRecording = function() {
      return this._ended === !1;
    }, e.prototype.recordException = function(t, r) {
      var n = {};
      typeof t == "string" ? n[Sn] = t : t && (t.code ? n[On] = t.code.toString() : t.name && (n[On] = t.name), t.message && (n[Sn] = t.message), t.stack && (n[Tv] = t.stack)), n[On] || n[Sn] ? this.addEvent(fm, n, r) : T.warn("Failed to record an exception " + t);
    }, Object.defineProperty(e.prototype, "duration", {
      get: function() {
        return this._duration;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ended", {
      get: function() {
        return this._ended;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedAttributesCount", {
      get: function() {
        return this._droppedAttributesCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedEventsCount", {
      get: function() {
        return this._droppedEventsCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "droppedLinksCount", {
      get: function() {
        return this._droppedLinksCount;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._isSpanEnded = function() {
      return this._ended && T.warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}"), this._ended;
    }, e.prototype._truncateToLimitUtil = function(t, r) {
      return t.length <= r ? t : t.substring(0, r);
    }, e.prototype._truncateToSize = function(t) {
      var r = this, n = this._attributeValueLengthLimit;
      return n <= 0 ? (T.warn("Attribute value limit must be positive, got " + n), t) : typeof t == "string" ? this._truncateToLimitUtil(t, n) : Array.isArray(t) ? t.map(function(i) {
        return typeof i == "string" ? r._truncateToLimitUtil(i, n) : i;
      }) : t;
    }, e;
  }()
), fe;
(function(e) {
  e[e.NOT_RECORD = 0] = "NOT_RECORD", e[e.RECORD = 1] = "RECORD", e[e.RECORD_AND_SAMPLED = 2] = "RECORD_AND_SAMPLED";
})(fe || (fe = {}));
var Ir = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: fe.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "AlwaysOffSampler";
    }, e;
  }()
), ce = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.shouldSample = function() {
      return {
        decision: fe.RECORD_AND_SAMPLED
      };
    }, e.prototype.toString = function() {
      return "AlwaysOnSampler";
    }, e;
  }()
), Rn = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o;
      this._root = t.root, this._root || (pe(new Error("ParentBasedSampler must have a root sampler configured")), this._root = new ce()), this._remoteParentSampled = (r = t.remoteParentSampled) !== null && r !== void 0 ? r : new ce(), this._remoteParentNotSampled = (n = t.remoteParentNotSampled) !== null && n !== void 0 ? n : new Ir(), this._localParentSampled = (i = t.localParentSampled) !== null && i !== void 0 ? i : new ce(), this._localParentNotSampled = (o = t.localParentNotSampled) !== null && o !== void 0 ? o : new Ir();
    }
    return e.prototype.shouldSample = function(t, r, n, i, o, a) {
      var u = x.getSpanContext(t);
      return !u || !Ke(u) ? this._root.shouldSample(t, r, n, i, o, a) : u.isRemote ? u.traceFlags & dt.SAMPLED ? this._remoteParentSampled.shouldSample(t, r, n, i, o, a) : this._remoteParentNotSampled.shouldSample(t, r, n, i, o, a) : u.traceFlags & dt.SAMPLED ? this._localParentSampled.shouldSample(t, r, n, i, o, a) : this._localParentNotSampled.shouldSample(t, r, n, i, o, a);
    }, e.prototype.toString = function() {
      return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    }, e;
  }()
), Xo = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = 0), this._ratio = t, this._ratio = this._normalize(t), this._upperBound = Math.floor(this._ratio * 4294967295);
    }
    return e.prototype.shouldSample = function(t, r) {
      return {
        decision: ks(r) && this._accumulate(r) < this._upperBound ? fe.RECORD_AND_SAMPLED : fe.NOT_RECORD
      };
    }, e.prototype.toString = function() {
      return "TraceIdRatioBased{" + this._ratio + "}";
    }, e.prototype._normalize = function(t) {
      return typeof t != "number" || isNaN(t) ? 0 : t >= 1 ? 1 : t <= 0 ? 0 : t;
    }, e.prototype._accumulate = function(t) {
      for (var r = 0, n = 0; n < t.length / 8; n++) {
        var i = n * 8, o = parseInt(t.slice(i, i + 8), 16);
        r = (r ^ o) >>> 0;
      }
      return r;
    }, e;
  }()
), mm = ct.AlwaysOn, Qt = 1;
function pu() {
  var e = Be();
  return {
    sampler: fu(e),
    forceFlushTimeoutMillis: 3e4,
    generalLimits: {
      attributeValueLengthLimit: e.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_ATTRIBUTE_COUNT_LIMIT
    },
    spanLimits: {
      attributeValueLengthLimit: e.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
      attributeCountLimit: e.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
      linkCountLimit: e.OTEL_SPAN_LINK_COUNT_LIMIT,
      eventCountLimit: e.OTEL_SPAN_EVENT_COUNT_LIMIT,
      attributePerEventCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
      attributePerLinkCountLimit: e.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT
    },
    mergeResourceWithDefaults: !0
  };
}
function fu(e) {
  switch (e === void 0 && (e = Be()), e.OTEL_TRACES_SAMPLER) {
    case ct.AlwaysOn:
      return new ce();
    case ct.AlwaysOff:
      return new Ir();
    case ct.ParentBasedAlwaysOn:
      return new Rn({
        root: new ce()
      });
    case ct.ParentBasedAlwaysOff:
      return new Rn({
        root: new Ir()
      });
    case ct.TraceIdRatio:
      return new Xo(qo(e));
    case ct.ParentBasedTraceIdRatio:
      return new Rn({
        root: new Xo(qo(e))
      });
    default:
      return T.error('OTEL_TRACES_SAMPLER value "' + e.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + mm + '".'), new ce();
  }
}
function qo(e) {
  if (e.OTEL_TRACES_SAMPLER_ARG === void 0 || e.OTEL_TRACES_SAMPLER_ARG === "")
    return T.error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + Qt + "."), Qt;
  var t = Number(e.OTEL_TRACES_SAMPLER_ARG);
  return isNaN(t) ? (T.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + Qt + "."), Qt) : t < 0 || t > 1 ? (T.error("OTEL_TRACES_SAMPLER_ARG=" + e.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + Qt + "."), Qt) : t;
}
function ym(e) {
  var t = {
    sampler: fu()
  }, r = pu(), n = Object.assign({}, r, t, e);
  return n.generalLimits = Object.assign({}, r.generalLimits, e.generalLimits || {}), n.spanLimits = Object.assign({}, r.spanLimits, e.spanLimits || {}), n;
}
function _m(e) {
  var t, r, n, i, o, a, u, c, s, l, p, f, m = Object.assign({}, e.spanLimits), v = vv();
  return m.attributeCountLimit = (a = (o = (i = (r = (t = e.spanLimits) === null || t === void 0 ? void 0 : t.attributeCountLimit) !== null && r !== void 0 ? r : (n = e.generalLimits) === null || n === void 0 ? void 0 : n.attributeCountLimit) !== null && i !== void 0 ? i : v.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && o !== void 0 ? o : v.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && a !== void 0 ? a : Er, m.attributeValueLengthLimit = (f = (p = (l = (c = (u = e.spanLimits) === null || u === void 0 ? void 0 : u.attributeValueLengthLimit) !== null && c !== void 0 ? c : (s = e.generalLimits) === null || s === void 0 ? void 0 : s.attributeValueLengthLimit) !== null && l !== void 0 ? l : v.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && p !== void 0 ? p : v.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && f !== void 0 ? f : gr, Object.assign({}, e, { spanLimits: m });
}
var gm = (
  /** @class */
  function() {
    function e(t, r) {
      this._exporter = t, this._isExporting = !1, this._finishedSpans = [], this._droppedSpansCount = 0;
      var n = Be();
      this._maxExportBatchSize = typeof r?.maxExportBatchSize == "number" ? r.maxExportBatchSize : n.OTEL_BSP_MAX_EXPORT_BATCH_SIZE, this._maxQueueSize = typeof r?.maxQueueSize == "number" ? r.maxQueueSize : n.OTEL_BSP_MAX_QUEUE_SIZE, this._scheduledDelayMillis = typeof r?.scheduledDelayMillis == "number" ? r.scheduledDelayMillis : n.OTEL_BSP_SCHEDULE_DELAY, this._exportTimeoutMillis = typeof r?.exportTimeoutMillis == "number" ? r.exportTimeoutMillis : n.OTEL_BSP_EXPORT_TIMEOUT, this._shutdownOnce = new pm(this._shutdown, this), this._maxExportBatchSize > this._maxQueueSize && (T.warn("BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize"), this._maxExportBatchSize = this._maxQueueSize);
    }
    return e.prototype.forceFlush = function() {
      return this._shutdownOnce.isCalled ? this._shutdownOnce.promise : this._flushAll();
    }, e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
      this._shutdownOnce.isCalled || t.spanContext().traceFlags & dt.SAMPLED && this._addToBuffer(t);
    }, e.prototype.shutdown = function() {
      return this._shutdownOnce.call();
    }, e.prototype._shutdown = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.onShutdown();
      }).then(function() {
        return t._flushAll();
      }).then(function() {
        return t._exporter.shutdown();
      });
    }, e.prototype._addToBuffer = function(t) {
      if (this._finishedSpans.length >= this._maxQueueSize) {
        this._droppedSpansCount === 0 && T.debug("maxQueueSize reached, dropping spans"), this._droppedSpansCount++;
        return;
      }
      this._droppedSpansCount > 0 && (T.warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached"), this._droppedSpansCount = 0), this._finishedSpans.push(t), this._maybeStartTimer();
    }, e.prototype._flushAll = function() {
      var t = this;
      return new Promise(function(r, n) {
        for (var i = [], o = Math.ceil(t._finishedSpans.length / t._maxExportBatchSize), a = 0, u = o; a < u; a++)
          i.push(t._flushOneBatch());
        Promise.all(i).then(function() {
          r();
        }).catch(n);
      });
    }, e.prototype._flushOneBatch = function() {
      var t = this;
      return this._clearTimer(), this._finishedSpans.length === 0 ? Promise.resolve() : new Promise(function(r, n) {
        var i = setTimeout(function() {
          n(new Error("Timeout"));
        }, t._exportTimeoutMillis);
        C.with(jd(C.active()), function() {
          var o;
          t._finishedSpans.length <= t._maxExportBatchSize ? (o = t._finishedSpans, t._finishedSpans = []) : o = t._finishedSpans.splice(0, t._maxExportBatchSize);
          for (var a = function() {
            return t._exporter.export(o, function(p) {
              var f;
              clearTimeout(i), p.code === yi.SUCCESS ? r() : n((f = p.error) !== null && f !== void 0 ? f : new Error("BatchSpanProcessor: span export failed"));
            });
          }, u = null, c = 0, s = o.length; c < s; c++) {
            var l = o[c];
            l.resource.asyncAttributesPending && l.resource.waitForAsyncAttributes && (u != null || (u = []), u.push(l.resource.waitForAsyncAttributes()));
          }
          u === null ? a() : Promise.all(u).then(a, function(p) {
            pe(p), n(p);
          });
        });
      });
    }, e.prototype._maybeStartTimer = function() {
      var t = this;
      if (!this._isExporting) {
        var r = function() {
          t._isExporting = !0, t._flushOneBatch().finally(function() {
            t._isExporting = !1, t._finishedSpans.length > 0 && (t._clearTimer(), t._maybeStartTimer());
          }).catch(function(n) {
            t._isExporting = !1, pe(n);
          });
        };
        if (this._finishedSpans.length >= this._maxExportBatchSize)
          return r();
        this._timer === void 0 && (this._timer = setTimeout(function() {
          return r();
        }, this._scheduledDelayMillis));
      }
    }, e.prototype._clearTimer = function() {
      this._timer !== void 0 && (clearTimeout(this._timer), this._timer = void 0);
    }, e;
  }()
), Em = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), hu = (
  /** @class */
  function(e) {
    Em(t, e);
    function t(r, n) {
      var i = e.call(this, r, n) || this;
      return i.onInit(n), i;
    }
    return t.prototype.onInit = function(r) {
      var n = this;
      r?.disableAutoFlushOnDocumentHide !== !0 && typeof document < "u" && (this._visibilityChangeListener = function() {
        document.visibilityState === "hidden" && n.forceFlush().catch(function(i) {
          pe(i);
        });
      }, this._pageHideListener = function() {
        n.forceFlush().catch(function(i) {
          pe(i);
        });
      }, document.addEventListener("visibilitychange", this._visibilityChangeListener), document.addEventListener("pagehide", this._pageHideListener));
    }, t.prototype.onShutdown = function() {
      typeof document < "u" && (this._visibilityChangeListener && document.removeEventListener("visibilitychange", this._visibilityChangeListener), this._pageHideListener && document.removeEventListener("pagehide", this._pageHideListener));
    }, t;
  }(gm)
), Tm = 8, bm = 16, Om = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.generateTraceId = Ko(bm), this.generateSpanId = Ko(Tm);
    }
    return e;
  }()
), rr = Array(32);
function Ko(e) {
  return function() {
    for (var t = 0; t < e * 2; t++)
      rr[t] = Math.floor(Math.random() * 16) + 48, rr[t] >= 58 && (rr[t] += 39);
    return String.fromCharCode.apply(null, rr.slice(0, e * 2));
  };
}
var Sm = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._tracerProvider = n;
      var i = ym(r);
      this._sampler = i.sampler, this._generalLimits = i.generalLimits, this._spanLimits = i.spanLimits, this._idGenerator = r.idGenerator || new Om(), this.resource = n.resource, this.instrumentationLibrary = t;
    }
    return e.prototype.startSpan = function(t, r, n) {
      var i, o, a;
      r === void 0 && (r = {}), n === void 0 && (n = C.active()), r.root && (n = x.deleteSpan(n));
      var u = x.getSpan(n);
      if (Ji(n)) {
        T.debug("Instrumentation suppressed, returning Noop Span");
        var c = x.wrapSpanContext(Is);
        return c;
      }
      var s = u?.spanContext(), l = this._idGenerator.generateSpanId(), p, f, m;
      !s || !x.isSpanContextValid(s) ? p = this._idGenerator.generateTraceId() : (p = s.traceId, f = s.traceState, m = s.spanId);
      var v = (i = r.kind) !== null && i !== void 0 ? i : $e.INTERNAL, y = ((o = r.links) !== null && o !== void 0 ? o : []).map(function(D) {
        return {
          context: D.context,
          attributes: _r(D.attributes)
        };
      }), g = _r(r.attributes), E = this._sampler.shouldSample(n, p, t, v, g, y);
      f = (a = E.traceState) !== null && a !== void 0 ? a : f;
      var N = E.decision === Lr.RECORD_AND_SAMPLED ? dt.SAMPLED : dt.NONE, j = { traceId: p, spanId: l, traceFlags: N, traceState: f };
      if (E.decision === Lr.NOT_RECORD) {
        T.debug("Recording is off, propagating context in a non-recording span");
        var c = x.wrapSpanContext(j);
        return c;
      }
      var U = _r(Object.assign(g, E.attributes)), F = new vm(this, n, t, j, v, m, y, r.startTime, void 0, U);
      return F;
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var c = a ?? C.active(), s = this.startSpan(t, o, c), l = x.setSpan(c, s);
        return C.with(l, u, void 0, s);
      }
    }, e.prototype.getGeneralLimits = function() {
      return this._generalLimits;
    }, e.prototype.getSpanLimits = function() {
      return this._spanLimits;
    }, e.prototype.getActiveSpanProcessor = function() {
      return this._tracerProvider.getActiveSpanProcessor();
    }, e;
  }()
), wm = "process.runtime.name", Am = "service.name", Lm = "telemetry.sdk.name", Rm = "telemetry.sdk.language", Cm = "telemetry.sdk.version", Nm = wm, xm = Am, Ei = Lm, Ti = Rm, bi = Cm, Pm = "webjs", Im = Pm, Mm = "1.30.1", Zt, Cn = (Zt = {}, Zt[Ei] = "opentelemetry", Zt[Nm] = "browser", Zt[Ti] = Im, Zt[bi] = Mm, Zt);
function km() {
  return "unknown_service";
}
var St = function() {
  return St = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, St.apply(this, arguments);
}, Dm = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (p) {
        a(p);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (p) {
        a(p);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, [])).next());
  });
}, Um = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, jm = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Fe = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this, i;
      this._attributes = t, this.asyncAttributesPending = r != null, this._syncAttributes = (i = this._attributes) !== null && i !== void 0 ? i : {}, this._asyncAttributesPromise = r?.then(function(o) {
        return n._attributes = Object.assign({}, n._attributes, o), n.asyncAttributesPending = !1, o;
      }, function(o) {
        return T.debug("a resource's async attributes promise rejected: %s", o), n.asyncAttributesPending = !1, {};
      });
    }
    return e.empty = function() {
      return e.EMPTY;
    }, e.default = function() {
      var t;
      return new e((t = {}, t[xm] = km(), t[Ti] = Cn[Ti], t[Ei] = Cn[Ei], t[bi] = Cn[bi], t));
    }, Object.defineProperty(e.prototype, "attributes", {
      get: function() {
        var t;
        return this.asyncAttributesPending && T.error("Accessing resource attributes before async attributes settled"), (t = this._attributes) !== null && t !== void 0 ? t : {};
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.waitForAsyncAttributes = function() {
      return Dm(this, void 0, void 0, function() {
        return Um(this, function(t) {
          switch (t.label) {
            case 0:
              return this.asyncAttributesPending ? [4, this._asyncAttributesPromise] : [3, 2];
            case 1:
              t.sent(), t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.merge = function(t) {
      var r = this, n;
      if (!t)
        return this;
      var i = St(St({}, this._syncAttributes), (n = t._syncAttributes) !== null && n !== void 0 ? n : t.attributes);
      if (!this._asyncAttributesPromise && !t._asyncAttributesPromise)
        return new e(i);
      var o = Promise.all([
        this._asyncAttributesPromise,
        t._asyncAttributesPromise
      ]).then(function(a) {
        var u, c = jm(a, 2), s = c[0], l = c[1];
        return St(St(St(St({}, r._syncAttributes), s), (u = t._syncAttributes) !== null && u !== void 0 ? u : t.attributes), l);
      });
      return new e(i, o);
    }, e.EMPTY = new e({}), e;
  }()
), nr = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Wo = (
  /** @class */
  function() {
    function e(t) {
      this._spanProcessors = t;
    }
    return e.prototype.forceFlush = function() {
      var t, r, n = [];
      try {
        for (var i = nr(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.forceFlush());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u) {
        Promise.all(n).then(function() {
          u();
        }).catch(function(c) {
          pe(c || new Error("MultiSpanProcessor: forceFlush failed")), u();
        });
      });
    }, e.prototype.onStart = function(t, r) {
      var n, i;
      try {
        for (var o = nr(this._spanProcessors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          u.onStart(t, r);
        }
      } catch (c) {
        n = { error: c };
      } finally {
        try {
          a && !a.done && (i = o.return) && i.call(o);
        } finally {
          if (n) throw n.error;
        }
      }
    }, e.prototype.onEnd = function(t) {
      var r, n;
      try {
        for (var i = nr(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          a.onEnd(t);
        }
      } catch (u) {
        r = { error: u };
      } finally {
        try {
          o && !o.done && (n = i.return) && n.call(i);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype.shutdown = function() {
      var t, r, n = [];
      try {
        for (var i = nr(this._spanProcessors), o = i.next(); !o.done; o = i.next()) {
          var a = o.value;
          n.push(a.shutdown());
        }
      } catch (u) {
        t = { error: u };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (t) throw t.error;
        }
      }
      return new Promise(function(u, c) {
        Promise.all(n).then(function() {
          u();
        }, c);
      });
    }, e;
  }()
), $m = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.onStart = function(t, r) {
    }, e.prototype.onEnd = function(t) {
    }, e.prototype.shutdown = function() {
      return Promise.resolve();
    }, e.prototype.forceFlush = function() {
      return Promise.resolve();
    }, e;
  }()
), Bm = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Fm = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, Dt;
(function(e) {
  e[e.resolved = 0] = "resolved", e[e.timeout = 1] = "timeout", e[e.error = 2] = "error", e[e.unresolved = 3] = "unresolved";
})(Dt || (Dt = {}));
var Vm = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = {});
      var r, n;
      this._registeredSpanProcessors = [], this._tracers = /* @__PURE__ */ new Map();
      var i = om({}, pu(), _m(t));
      if (this.resource = (r = i.resource) !== null && r !== void 0 ? r : Fe.empty(), i.mergeResourceWithDefaults && (this.resource = Fe.default().merge(this.resource)), this._config = Object.assign({}, i, {
        resource: this.resource
      }), !((n = t.spanProcessors) === null || n === void 0) && n.length)
        this._registeredSpanProcessors = Fm([], Bm(t.spanProcessors), !1), this.activeSpanProcessor = new Wo(this._registeredSpanProcessors);
      else {
        var o = this._buildExporterFromEnv();
        if (o !== void 0) {
          var a = new hu(o);
          this.activeSpanProcessor = a;
        } else
          this.activeSpanProcessor = new $m();
      }
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i = t + "@" + (r || "") + ":" + (n?.schemaUrl || "");
      return this._tracers.has(i) || this._tracers.set(i, new Sm({ name: t, version: r, schemaUrl: n?.schemaUrl }, this._config, this)), this._tracers.get(i);
    }, e.prototype.addSpanProcessor = function(t) {
      this._registeredSpanProcessors.length === 0 && this.activeSpanProcessor.shutdown().catch(function(r) {
        return T.error("Error while trying to shutdown current span processor", r);
      }), this._registeredSpanProcessors.push(t), this.activeSpanProcessor = new Wo(this._registeredSpanProcessors);
    }, e.prototype.getActiveSpanProcessor = function() {
      return this.activeSpanProcessor;
    }, e.prototype.register = function(t) {
      t === void 0 && (t = {}), x.setGlobalTracerProvider(this), t.propagator === void 0 && (t.propagator = this._buildPropagatorFromEnv()), t.contextManager && C.setGlobalContextManager(t.contextManager), t.propagator && Q.setGlobalPropagator(t.propagator);
    }, e.prototype.forceFlush = function() {
      var t = this._config.forceFlushTimeoutMillis, r = this._registeredSpanProcessors.map(function(n) {
        return new Promise(function(i) {
          var o, a = setTimeout(function() {
            i(new Error("Span processor did not completed within timeout period of " + t + " ms")), o = Dt.timeout;
          }, t);
          n.forceFlush().then(function() {
            clearTimeout(a), o !== Dt.timeout && (o = Dt.resolved, i(o));
          }).catch(function(u) {
            clearTimeout(a), o = Dt.error, i(u);
          });
        });
      });
      return new Promise(function(n, i) {
        Promise.all(r).then(function(o) {
          var a = o.filter(function(u) {
            return u !== Dt.resolved;
          });
          a.length > 0 ? i(a) : n();
        }).catch(function(o) {
          return i([o]);
        });
      });
    }, e.prototype.shutdown = function() {
      return this.activeSpanProcessor.shutdown();
    }, e.prototype._getPropagator = function(t) {
      var r;
      return (r = this.constructor._registeredPropagators.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._getSpanExporter = function(t) {
      var r;
      return (r = this.constructor._registeredExporters.get(t)) === null || r === void 0 ? void 0 : r();
    }, e.prototype._buildPropagatorFromEnv = function() {
      var t = this, r = Array.from(new Set(Be().OTEL_PROPAGATORS)), n = r.map(function(o) {
        var a = t._getPropagator(o);
        return a || T.warn('Propagator "' + o + '" requested through environment variable is unavailable.'), a;
      }), i = n.reduce(function(o, a) {
        return a && o.push(a), o;
      }, []);
      if (i.length !== 0)
        return r.length === 1 ? i[0] : new Cv({
          propagators: i
        });
    }, e.prototype._buildExporterFromEnv = function() {
      var t = Be().OTEL_TRACES_EXPORTER;
      if (!(t === "none" || t === "")) {
        var r = this._getSpanExporter(t);
        return r || T.error('Exporter "' + t + '" requested through environment variable is unavailable.'), r;
      }
    }, e._registeredPropagators = /* @__PURE__ */ new Map([
      ["tracecontext", function() {
        return new Xv();
      }],
      ["baggage", function() {
        return new qd();
      }]
    ]), e._registeredExporters = /* @__PURE__ */ new Map(), e;
  }()
), Gm = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Hm = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, du = (
  /** @class */
  function() {
    function e() {
      this._enabled = !1, this._currentContext = It;
    }
    return e.prototype._bindFunction = function(t, r) {
      t === void 0 && (t = It);
      var n = this, i = function() {
        for (var o = this, a = [], u = 0; u < arguments.length; u++)
          a[u] = arguments[u];
        return n.with(t, function() {
          return r.apply(o, a);
        });
      };
      return Object.defineProperty(i, "length", {
        enumerable: !1,
        configurable: !0,
        writable: !1,
        value: r.length
      }), i;
    }, e.prototype.active = function() {
      return this._currentContext;
    }, e.prototype.bind = function(t, r) {
      return t === void 0 && (t = this.active()), typeof r == "function" ? this._bindFunction(t, r) : r;
    }, e.prototype.disable = function() {
      return this._currentContext = It, this._enabled = !1, this;
    }, e.prototype.enable = function() {
      return this._enabled ? this : (this._enabled = !0, this._currentContext = It, this);
    }, e.prototype.with = function(t, r, n) {
      for (var i = [], o = 3; o < arguments.length; o++)
        i[o - 3] = arguments[o];
      var a = this._currentContext;
      this._currentContext = t || It;
      try {
        return r.call.apply(r, Hm([n], Gm(i), !1));
      } finally {
        this._currentContext = a;
      }
    }, e;
  }()
), zm = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Xm = (
  /** @class */
  function(e) {
    zm(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, r) || this;
      if (r.contextManager)
        throw "contextManager should be defined in register method not in constructor";
      if (r.propagator)
        throw "propagator should be defined in register method not in constructor";
      return n;
    }
    return t.prototype.register = function(r) {
      r === void 0 && (r = {}), r.contextManager === void 0 && (r.contextManager = new du()), r.contextManager && r.contextManager.enable(), e.prototype.register.call(this, r);
    }, t;
  }(Vm)
), S;
(function(e) {
  e.CONNECT_END = "connectEnd", e.CONNECT_START = "connectStart", e.DECODED_BODY_SIZE = "decodedBodySize", e.DOM_COMPLETE = "domComplete", e.DOM_CONTENT_LOADED_EVENT_END = "domContentLoadedEventEnd", e.DOM_CONTENT_LOADED_EVENT_START = "domContentLoadedEventStart", e.DOM_INTERACTIVE = "domInteractive", e.DOMAIN_LOOKUP_END = "domainLookupEnd", e.DOMAIN_LOOKUP_START = "domainLookupStart", e.ENCODED_BODY_SIZE = "encodedBodySize", e.FETCH_START = "fetchStart", e.LOAD_EVENT_END = "loadEventEnd", e.LOAD_EVENT_START = "loadEventStart", e.NAVIGATION_START = "navigationStart", e.REDIRECT_END = "redirectEnd", e.REDIRECT_START = "redirectStart", e.REQUEST_START = "requestStart", e.RESPONSE_END = "responseEnd", e.RESPONSE_START = "responseStart", e.SECURE_CONNECTION_START = "secureConnectionStart", e.UNLOAD_EVENT_END = "unloadEventEnd", e.UNLOAD_EVENT_START = "unloadEventStart";
})(S || (S = {}));
var Nn;
function qm() {
  return Nn || (Nn = document.createElement("a")), Nn;
}
function Nt(e, t) {
  return t in e;
}
function V(e, t, r, n) {
  var i = void 0, o = void 0;
  Nt(r, t) && typeof r[t] == "number" && (i = r[t]);
  var a = S.FETCH_START;
  if (Nt(r, a) && typeof r[a] == "number" && (o = r[a]), i !== void 0 && o !== void 0 && i >= o)
    return e.addEvent(t, i), e;
}
function he(e, t, r) {
  r === void 0 && (r = !1), r || (V(e, S.FETCH_START, t), V(e, S.DOMAIN_LOOKUP_START, t), V(e, S.DOMAIN_LOOKUP_END, t), V(e, S.CONNECT_START, t), Nt(t, "name") && t.name.startsWith("https:") && V(e, S.SECURE_CONNECTION_START, t), V(e, S.CONNECT_END, t), V(e, S.REQUEST_START, t), V(e, S.RESPONSE_START, t), V(e, S.RESPONSE_END, t));
  var n = t[S.ENCODED_BODY_SIZE];
  n !== void 0 && e.setAttribute(bv, n);
  var i = t[S.DECODED_BODY_SIZE];
  i !== void 0 && n !== i && e.setAttribute(Ov, i);
}
function Km(e) {
  return e.slice().sort(function(t, r) {
    var n = t[S.FETCH_START], i = r[S.FETCH_START];
    return n > i ? 1 : n < i ? -1 : 0;
  });
}
function vu() {
  return typeof location < "u" ? location.origin : void 0;
}
function mu(e, t, r, n, i, o) {
  i === void 0 && (i = /* @__PURE__ */ new WeakSet());
  var a = _t(e);
  e = a.toString();
  var u = Ym(e, t, r, n, i, o);
  if (u.length === 0)
    return {
      mainRequest: void 0
    };
  if (u.length === 1)
    return {
      mainRequest: u[0]
    };
  var c = Km(u);
  if (a.origin !== vu() && c.length > 1) {
    var s = c[0], l = Wm(c, s[S.RESPONSE_END], r), p = s[S.RESPONSE_END], f = l[S.FETCH_START];
    return f < p && (l = s, s = void 0), {
      corsPreFlightRequest: s,
      mainRequest: l
    };
  } else
    return {
      mainRequest: u[0]
    };
}
function Wm(e, t, r) {
  for (var n = Lt(r), i = Lt(xe(t)), o = e[1], a, u = e.length, c = 1; c < u; c++) {
    var s = e[c], l = Lt(xe(s[S.FETCH_START])), p = Lt(xe(s[S.RESPONSE_END])), f = n - p;
    l >= i && (!a || f < a) && (a = f, o = s);
  }
  return o;
}
function Ym(e, t, r, n, i, o) {
  var a = Lt(t), u = Lt(r), c = n.filter(function(s) {
    var l = Lt(xe(s[S.FETCH_START])), p = Lt(xe(s[S.RESPONSE_END]));
    return s.initiatorType.toLowerCase() === (o || "xmlhttprequest") && s.name === e && l >= a && p <= u;
  });
  return c.length > 0 && (c = c.filter(function(s) {
    return !i.has(s);
  })), c;
}
function _t(e) {
  if (typeof URL == "function")
    return new URL(e, typeof document < "u" ? document.baseURI : typeof location < "u" ? location.href : void 0);
  var t = qm();
  return t.href = e, t;
}
function yu(e, t) {
  if (e.nodeType === Node.DOCUMENT_NODE)
    return "/";
  var r = Qm(e, t);
  if (t && r.indexOf("@id") > 0)
    return r;
  var n = "";
  return e.parentNode && (n += yu(e.parentNode, !1)), n += r, n;
}
function Jm(e) {
  if (!e.parentNode)
    return 0;
  var t = [e.nodeType];
  e.nodeType === Node.CDATA_SECTION_NODE && t.push(Node.TEXT_NODE);
  var r = Array.from(e.parentNode.childNodes);
  return r = r.filter(function(n) {
    var i = n.localName;
    return t.indexOf(n.nodeType) >= 0 && i === e.localName;
  }), r.length >= 1 ? r.indexOf(e) + 1 : 0;
}
function Qm(e, t) {
  var r = e.nodeType, n = Jm(e), i = "";
  if (r === Node.ELEMENT_NODE) {
    var o = e.getAttribute("id");
    if (t && o)
      return '//*[@id="' + o + '"]';
    i = e.localName;
  } else if (r === Node.TEXT_NODE || r === Node.CDATA_SECTION_NODE)
    i = "text()";
  else if (r === Node.COMMENT_NODE)
    i = "comment()";
  else
    return "";
  return i && n > 1 ? "/" + i + "[" + n + "]" : "/" + i;
}
function _u(e, t) {
  var r = t || [];
  (typeof r == "string" || r instanceof RegExp) && (r = [r]);
  var n = _t(e);
  return n.origin === vu() ? !0 : r.some(function(i) {
    return sm(e, i);
  });
}
var Oi = function() {
  return Oi = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Oi.apply(this, arguments);
}, Zm = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = q.wrap, this._unwrap = q.unwrap, this._massWrap = q.massWrap, this._massUnwrap = q.massUnwrap, this.setConfig(n), this._diag = T.createComponentLogger({
        namespace: t
      }), this._tracer = x.getTracer(t, r), this._meter = pt.getMeter(t, r), this._logger = We.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = Oi({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), ty = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ey = (
  /** @class */
  function(e) {
    ty(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(Zm)
);
function Yo(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
var Pe;
(function(e) {
  e.DOCUMENT_LOAD = "documentLoad", e.DOCUMENT_FETCH = "documentFetch", e.RESOURCE_FETCH = "resourceFetch";
})(Pe || (Pe = {}));
var ry = "0.44.0", ny = "@opentelemetry/instrumentation-document-load";
const iy = "http.url", oy = "http.user_agent", xn = iy, ay = oy;
var Mr;
(function(e) {
  e.FIRST_PAINT = "firstPaint", e.FIRST_CONTENTFUL_PAINT = "firstContentfulPaint";
})(Mr || (Mr = {}));
var sy = function() {
  var e, t, r = {}, n = (t = (e = Nr).getEntriesByType) === null || t === void 0 ? void 0 : t.call(e, "navigation")[0];
  if (n) {
    var i = Object.values(S);
    i.forEach(function(u) {
      if (Nt(n, u)) {
        var c = n[u];
        typeof c == "number" && (r[u] = c);
      }
    });
  } else {
    var o = Nr, a = o.timing;
    if (a) {
      var i = Object.values(S);
      i.forEach(function(c) {
        if (Nt(a, c)) {
          var s = a[c];
          typeof s == "number" && (r[c] = s);
        }
      });
    }
  }
  return r;
}, Jo = {
  "first-paint": Mr.FIRST_PAINT,
  "first-contentful-paint": Mr.FIRST_CONTENTFUL_PAINT
}, uy = function(e) {
  var t, r, n = (r = (t = Nr).getEntriesByType) === null || r === void 0 ? void 0 : r.call(t, "paint");
  n && n.forEach(function(i) {
    var o = i.name, a = i.startTime;
    Nt(Jo, o) && e.addEvent(Jo[o], a);
  });
}, cy = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ly = (
  /** @class */
  function(e) {
    cy(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, ny, ry, r) || this;
      return n.component = "document-load", n.version = "1", n.moduleName = n.component, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._onDocumentLoaded = function() {
      var r = this;
      window.setTimeout(function() {
        r._collectPerformance();
      });
    }, t.prototype._addResourcesSpans = function(r) {
      var n = this, i, o, a = (o = (i = Nr).getEntriesByType) === null || o === void 0 ? void 0 : o.call(i, "resource");
      a && a.forEach(function(u) {
        n._initResourceSpan(u, r);
      });
    }, t.prototype._collectPerformance = function() {
      var r = this, n = Array.from(document.getElementsByTagName("meta")).find(function(a) {
        return a.getAttribute("name") === Ud;
      }), i = sy(), o = n && n.content || "";
      C.with(Q.extract(It, { traceparent: o }), function() {
        var a, u = r._startSpan(Pe.DOCUMENT_LOAD, S.FETCH_START, i);
        u && (C.with(x.setSpan(C.active(), u), function() {
          var c = r._startSpan(Pe.DOCUMENT_FETCH, S.FETCH_START, i);
          c && (c.setAttribute(xn, location.href), C.with(x.setSpan(C.active(), c), function() {
            var s;
            r.getConfig().ignoreNetworkEvents || he(c, i), r._addCustomAttributesOnSpan(c, (s = r.getConfig().applyCustomAttributesOnSpan) === null || s === void 0 ? void 0 : s.documentFetch), r._endSpan(c, S.RESPONSE_END, i);
          }));
        }), u.setAttribute(xn, location.href), u.setAttribute(ay, navigator.userAgent), r._addResourcesSpans(u), r.getConfig().ignoreNetworkEvents || (V(u, S.FETCH_START, i), V(u, S.UNLOAD_EVENT_START, i), V(u, S.UNLOAD_EVENT_END, i), V(u, S.DOM_INTERACTIVE, i), V(u, S.DOM_CONTENT_LOADED_EVENT_START, i), V(u, S.DOM_CONTENT_LOADED_EVENT_END, i), V(u, S.DOM_COMPLETE, i), V(u, S.LOAD_EVENT_START, i), V(u, S.LOAD_EVENT_END, i)), r.getConfig().ignorePerformancePaintEvents || uy(u), r._addCustomAttributesOnSpan(u, (a = r.getConfig().applyCustomAttributesOnSpan) === null || a === void 0 ? void 0 : a.documentLoad), r._endSpan(u, S.LOAD_EVENT_END, i));
      });
    }, t.prototype._endSpan = function(r, n, i) {
      r && (Nt(i, n) ? r.end(i[n]) : r.end());
    }, t.prototype._initResourceSpan = function(r, n) {
      var i, o = this._startSpan(Pe.RESOURCE_FETCH, S.FETCH_START, r, n);
      o && (o.setAttribute(xn, r.name), this.getConfig().ignoreNetworkEvents || he(o, r), this._addCustomAttributesOnResourceSpan(o, r, (i = this.getConfig().applyCustomAttributesOnSpan) === null || i === void 0 ? void 0 : i.resourceFetch), this._endSpan(o, S.RESPONSE_END, r));
    }, t.prototype._startSpan = function(r, n, i, o) {
      if (Nt(i, n) && typeof i[n] == "number") {
        var a = this.tracer.startSpan(r, {
          startTime: i[n]
        }, o ? x.setSpan(C.active(), o) : void 0);
        return a;
      }
    }, t.prototype._waitForPageLoad = function() {
      window.document.readyState === "complete" ? this._onDocumentLoaded() : (this._onDocumentLoaded = this._onDocumentLoaded.bind(this), window.addEventListener("load", this._onDocumentLoaded));
    }, t.prototype._addCustomAttributesOnSpan = function(r, n) {
      var i = this;
      n && Yo(function() {
        return n(r);
      }, function(o) {
        o && i._diag.error("addCustomAttributesOnSpan", o);
      });
    }, t.prototype._addCustomAttributesOnResourceSpan = function(r, n, i) {
      var o = this;
      i && Yo(function() {
        return i(r, n);
      }, function(a) {
        a && o._diag.error("addCustomAttributesOnResourceSpan", a);
      });
    }, t.prototype.enable = function() {
      window.removeEventListener("load", this._onDocumentLoaded), this._waitForPageLoad();
    }, t.prototype.disable = function() {
      window.removeEventListener("load", this._onDocumentLoaded);
    }, t;
  }(ey)
), Si = function() {
  return Si = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Si.apply(this, arguments);
}, py = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = q.wrap, this._unwrap = q.unwrap, this._massWrap = q.massWrap, this._massUnwrap = q.massUnwrap, this.setConfig(n), this._diag = T.createComponentLogger({
        namespace: t
      }), this._tracer = x.getTracer(t, r), this._meter = pt.getMeter(t, r), this._logger = We.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = Si({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), fy = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), hy = (
  /** @class */
  function(e) {
    fy(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(py)
);
function dy(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
function vy(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var Pn = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, wi = performance, my = "http.method", yy = "http.url", _y = "http.host", gy = "http.scheme", Ey = "http.status_code", Ty = "http.user_agent", by = "http.request_content_length_uncompressed", Oy = my, Sy = yy, wy = _y, Ay = gy, Ly = Ey, Ry = Ty, Cy = by, Ny = 9, xy = 6, Py = Math.pow(10, xy), Qo = Math.pow(10, Ny);
function Ai(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * Py);
  return [r, n];
}
function Iy() {
  var e = wi.timeOrigin;
  if (typeof e != "number") {
    var t = wi;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function Zo(e) {
  var t = Ai(Iy()), r = Ai(wi.now());
  return My(t, r);
}
function My(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= Qo && (r[1] -= Qo, r[0] += 1), r;
}
var ky = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function Dy(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function Uy(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = ky(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (Dy(e, a))
        return !0;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var kr;
(function(e) {
  e.COMPONENT = "component", e.HTTP_ERROR_NAME = "http.error_name", e.HTTP_STATUS_TEXT = "http.status_text";
})(kr || (kr = {}));
var jy = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (p) {
        a(p);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (p) {
        a(p);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, [])).next());
  });
}, $y = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, By = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Fy = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, gu = T.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-fetch/utils"
});
function Vy() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  if (e[0] instanceof URL || typeof e[0] == "string") {
    var r = e[1];
    if (!(r != null && r.body))
      return Promise.resolve();
    if (r.body instanceof ReadableStream) {
      var n = Gy(r.body), i = n.body, o = n.length;
      return r.body = i, o;
    } else
      return Promise.resolve(Hy(r.body));
  } else {
    var a = e[0];
    return a != null && a.body ? a.clone().text().then(function(u) {
      return Li(u);
    }) : Promise.resolve();
  }
}
function Gy(e) {
  if (!e.pipeThrough)
    return gu.warn("Platform has ReadableStream but not pipeThrough!"), {
      body: e,
      length: Promise.resolve(void 0)
    };
  var t = 0, r, n = new Promise(function(o) {
    r = o;
  }), i = new TransformStream({
    start: function() {
    },
    transform: function(o, a) {
      return jy(this, void 0, void 0, function() {
        var u;
        return $y(this, function(c) {
          switch (c.label) {
            case 0:
              return [4, o];
            case 1:
              return u = c.sent(), t += u.byteLength, a.enqueue(o), [
                2
                /*return*/
              ];
          }
        });
      });
    },
    flush: function() {
      r(t);
    }
  });
  return {
    body: e.pipeThrough(i),
    length: n
  };
}
function Hy(e) {
  if (typeof Document < "u" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return Xy(e);
  if (e instanceof URLSearchParams)
    return Li(e.toString());
  if (typeof e == "string")
    return Li(e);
  gu.warn("unknown body type");
}
var zy = new TextEncoder();
function Li(e) {
  return zy.encode(e).byteLength;
}
function Xy(e) {
  var t, r, n = 0;
  try {
    for (var i = By(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = Fy(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var ta = "0.57.2", qy = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Ky = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Wy = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, In, Yy = 300, ea = typeof process == "object" && ((In = process.release) === null || In === void 0 ? void 0 : In.name) === "node", Jy = (
  /** @class */
  function(e) {
    qy(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-fetch", ta, r) || this;
      return n.component = "fetch", n.version = ta, n.moduleName = n.component, n._usedResources = /* @__PURE__ */ new WeakSet(), n._tasksCount = 0, n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this.tracer.startSpan("CORS Preflight", {
        startTime: n[S.FETCH_START]
      }, x.setSpan(C.active(), r));
      he(i, n, this.getConfig().ignoreNetworkEvents), i.end(n[S.RESPONSE_END]);
    }, t.prototype._addFinalSpanAttributes = function(r, n) {
      var i = _t(n.url);
      r.setAttribute(Ly, n.status), n.statusText != null && r.setAttribute(kr.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(wy, i.host), r.setAttribute(Ay, i.protocol.replace(":", "")), typeof navigator < "u" && r.setAttribute(Ry, navigator.userAgent);
    }, t.prototype._addHeaders = function(r, n) {
      if (!_u(n, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var i = {};
        Q.inject(C.active(), i), Object.keys(i).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      if (r instanceof Request)
        Q.inject(C.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Headers)
        Q.inject(C.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else if (r.headers instanceof Map)
        Q.inject(C.active(), r.headers, {
          set: function(o, a, u) {
            return o.set(a, typeof u == "string" ? u : String(u));
          }
        });
      else {
        var i = {};
        Q.inject(C.active(), i), r.headers = Object.assign({}, i, r.headers || {});
      }
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (performance.clearResourceTimings(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._createSpan = function(r, n) {
      var i;
      if (n === void 0 && (n = {}), Uy(r, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var o = (n.method || "GET").toUpperCase(), a = "HTTP " + o;
      return this.tracer.startSpan(a, {
        kind: $e.CLIENT,
        attributes: (i = {}, i[kr.COMPONENT] = this.moduleName, i[Oy] = o, i[Sy] = r, i)
      });
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i) {
      var o = n.entries;
      if (!o.length) {
        if (!performance.getEntriesByType)
          return;
        o = performance.getEntriesByType("resource");
      }
      var a = mu(n.spanUrl, n.startTime, i, o, this._usedResources, "fetch");
      if (a.mainRequest) {
        var u = a.mainRequest;
        this._markResourceAsUsed(u);
        var c = a.corsPreFlightRequest;
        c && (this._addChildSpan(r, c), this._markResourceAsUsed(c)), he(r, u, this.getConfig().ignoreNetworkEvents);
      }
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._endSpan = function(r, n, i) {
      var o = this, a = Ai(Date.now()), u = Zo();
      this._addFinalSpanAttributes(r, i), setTimeout(function() {
        var c;
        (c = n.observer) === null || c === void 0 || c.disconnect(), o._findResourceAndAddNetworkEvents(r, n, u), o._tasksCount--, o._clearResources(), r.end(a);
      }, Yy);
    }, t.prototype._patchConstructor = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var u = this, c = _t(o[0] instanceof Request ? o[0].url : String(o[0])).href, s = o[0] instanceof Request ? o[0] : o[1] || {}, l = i._createSpan(c, s);
          if (!l)
            return n.apply(this, o);
          var p = i._prepareSpanData(c);
          i.getConfig().measureRequestSize && Vy.apply(void 0, Wy([], Ky(o), !1)).then(function(g) {
            g && l.setAttribute(Cy, g);
          }).catch(function(g) {
            i._diag.warn("getFetchBodyLength", g);
          });
          function f(g, E) {
            i._applyAttributesAfterFetch(g, s, E), i._endSpan(g, p, {
              status: E.status || 0,
              statusText: E.message,
              url: c
            });
          }
          function m(g, E) {
            i._applyAttributesAfterFetch(g, s, E), E.status >= 200 && E.status < 400 ? i._endSpan(g, p, E) : i._endSpan(g, p, {
              status: E.status,
              statusText: E.statusText,
              url: c
            });
          }
          function v(g, E, N) {
            try {
              var j = N.clone(), U = N.clone(), F = j.body;
              if (F) {
                var D = F.getReader(), H = function() {
                  D.read().then(function($) {
                    var vt = $.done;
                    vt ? m(g, U) : H();
                  }, function($) {
                    f(g, $);
                  });
                };
                H();
              } else
                m(g, N);
            } finally {
              E(N);
            }
          }
          function y(g, E, N) {
            try {
              f(g, N);
            } finally {
              E(N);
            }
          }
          return new Promise(function(g, E) {
            return C.with(x.setSpan(C.active(), l), function() {
              return i._addHeaders(s, c), i._tasksCount++, n.apply(u, s instanceof Request ? [s] : [c, s]).then(v.bind(u, l, g), y.bind(u, l, E));
            });
          });
        };
      };
    }, t.prototype._applyAttributesAfterFetch = function(r, n, i) {
      var o = this, a = this.getConfig().applyCustomAttributesOnSpan;
      a && dy(function() {
        return a(r, n, i);
      }, function(u) {
        u && o._diag.error("applyCustomAttributesOnSpan", u);
      });
    }, t.prototype._prepareSpanData = function(r) {
      var n = Zo(), i = [];
      if (typeof PerformanceObserver != "function")
        return { entries: i, startTime: n, spanUrl: r };
      var o = new PerformanceObserver(function(a) {
        var u = a.getEntries();
        u.forEach(function(c) {
          c.initiatorType === "fetch" && c.name === r && i.push(c);
        });
      });
      return o.observe({
        entryTypes: ["resource"]
      }), { entries: i, observer: o, startTime: n, spanUrl: r };
    }, t.prototype.enable = function() {
      if (ea) {
        this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
        return;
      }
      vy(fetch) && (this._unwrap(Pn, "fetch"), this._diag.debug("removing previous patch for constructor")), this._wrap(Pn, "fetch", this._patchConstructor());
    }, t.prototype.disable = function() {
      ea || (this._unwrap(Pn, "fetch"), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t;
  }(hy)
), Ri = function() {
  return Ri = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Ri.apply(this, arguments);
}, Qy = (
  /** @class */
  function() {
    function e(t, r, n) {
      this.instrumentationName = t, this.instrumentationVersion = r, this._config = {}, this._wrap = q.wrap, this._unwrap = q.unwrap, this._massWrap = q.massWrap, this._massUnwrap = q.massUnwrap, this.setConfig(n), this._diag = T.createComponentLogger({
        namespace: t
      }), this._tracer = x.getTracer(t, r), this._meter = pt.getMeter(t, r), this._logger = We.getLogger(t, r), this._updateMetricInstruments();
    }
    return Object.defineProperty(e.prototype, "meter", {
      /* Returns meter */
      get: function() {
        return this._meter;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setMeterProvider = function(t) {
      this._meter = t.getMeter(this.instrumentationName, this.instrumentationVersion), this._updateMetricInstruments();
    }, Object.defineProperty(e.prototype, "logger", {
      /* Returns logger */
      get: function() {
        return this._logger;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.setLoggerProvider = function(t) {
      this._logger = t.getLogger(this.instrumentationName, this.instrumentationVersion);
    }, e.prototype.getModuleDefinitions = function() {
      var t, r = (t = this.init()) !== null && t !== void 0 ? t : [];
      return Array.isArray(r) ? r : [r];
    }, e.prototype._updateMetricInstruments = function() {
    }, e.prototype.getConfig = function() {
      return this._config;
    }, e.prototype.setConfig = function(t) {
      this._config = Ri({ enabled: !0 }, t);
    }, e.prototype.setTracerProvider = function(t) {
      this._tracer = t.getTracer(this.instrumentationName, this.instrumentationVersion);
    }, Object.defineProperty(e.prototype, "tracer", {
      /* Returns tracer */
      get: function() {
        return this._tracer;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._runSpanCustomizationHook = function(t, r, n, i) {
      if (t)
        try {
          t(n, i);
        } catch (o) {
          this._diag.error("Error running span customization hook due to exception in handler", { triggerName: r }, o);
        }
    }, e;
  }()
), Zy = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), t_ = (
  /** @class */
  function(e) {
    Zy(t, e);
    function t(r, n, i) {
      var o = e.call(this, r, n, i) || this;
      return o._config.enabled && o.enable(), o;
    }
    return t;
  }(Qy)
);
function e_(e, t, r) {
  var n, i;
  try {
    i = e();
  } catch (o) {
    n = o;
  } finally {
    return t(n, i), i;
  }
}
function ra(e) {
  return typeof e == "function" && typeof e.__original == "function" && typeof e.__unwrap == "function" && e.__wrapped === !0;
}
var Ve = performance, r_ = "http.method", n_ = "http.url", i_ = "http.host", o_ = "http.scheme", a_ = "http.status_code", s_ = "http.user_agent", u_ = "http.request_content_length_uncompressed", c_ = r_, l_ = n_, p_ = i_, f_ = o_, h_ = a_, d_ = s_, v_ = u_, m_ = 9, y_ = 6, __ = Math.pow(10, y_), na = Math.pow(10, m_);
function ia(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * __);
  return [r, n];
}
function g_() {
  var e = Ve.timeOrigin;
  if (typeof e != "number") {
    var t = Ve;
    e = t.timing && t.timing.fetchStart;
  }
  return e;
}
function oa(e) {
  var t = ia(g_()), r = ia(Ve.now());
  return E_(t, r);
}
function E_(e, t) {
  var r = [e[0] + t[0], e[1] + t[1]];
  return r[1] >= na && (r[1] -= na, r[0] += 1), r;
}
var T_ = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function b_(e, t) {
  return typeof t == "string" ? e === t : !!e.match(t);
}
function O_(e, t) {
  var r, n;
  if (!t)
    return !1;
  try {
    for (var i = T_(t), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (b_(e, a))
        return !0;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !1;
}
var yt;
(function(e) {
  e.METHOD_OPEN = "open", e.METHOD_SEND = "send", e.EVENT_ABORT = "abort", e.EVENT_ERROR = "error", e.EVENT_LOAD = "loaded", e.EVENT_TIMEOUT = "timeout";
})(yt || (yt = {}));
var S_ = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, w_ = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, A_ = T.createComponentLogger({
  namespace: "@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils"
});
function L_(e) {
  if (typeof Document < "u" && e instanceof Document)
    return new XMLSerializer().serializeToString(document).length;
  if (e instanceof Blob)
    return e.size;
  if (e.byteLength !== void 0)
    return e.byteLength;
  if (e instanceof FormData)
    return C_(e);
  if (e instanceof URLSearchParams)
    return aa(e.toString());
  if (typeof e == "string")
    return aa(e);
  A_.warn("unknown body type");
}
var R_ = new TextEncoder();
function aa(e) {
  return R_.encode(e).byteLength;
}
function C_(e) {
  var t, r, n = 0;
  try {
    for (var i = S_(e.entries()), o = i.next(); !o.done; o = i.next()) {
      var a = w_(o.value, 2), u = a[0], c = a[1];
      n += u.length, c instanceof Blob ? n += c.size : n += c.length;
    }
  } catch (s) {
    t = { error: s };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
var sa = "0.57.2", Ci;
(function(e) {
  e.HTTP_STATUS_TEXT = "http.status_text";
})(Ci || (Ci = {}));
var N_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), x_ = 300, P_ = (
  /** @class */
  function(e) {
    N_(t, e);
    function t(r) {
      r === void 0 && (r = {});
      var n = e.call(this, "@opentelemetry/instrumentation-xml-http-request", sa, r) || this;
      return n.component = "xml-http-request", n.version = sa, n.moduleName = n.component, n._tasksCount = 0, n._xhrMem = /* @__PURE__ */ new WeakMap(), n._usedResources = /* @__PURE__ */ new WeakSet(), n;
    }
    return t.prototype.init = function() {
    }, t.prototype._addHeaders = function(r, n) {
      var i = _t(n).href;
      if (!_u(i, this.getConfig().propagateTraceHeaderCorsUrls)) {
        var o = {};
        Q.inject(C.active(), o), Object.keys(o).length > 0 && this._diag.debug("headers inject skipped due to CORS policy");
        return;
      }
      var a = {};
      Q.inject(C.active(), a), Object.keys(a).forEach(function(u) {
        r.setRequestHeader(u, String(a[u]));
      });
    }, t.prototype._addChildSpan = function(r, n) {
      var i = this;
      C.with(x.setSpan(C.active(), r), function() {
        var o = i.tracer.startSpan("CORS Preflight", {
          startTime: n[S.FETCH_START]
        });
        he(o, n, i.getConfig().ignoreNetworkEvents), o.end(n[S.RESPONSE_END]);
      });
    }, t.prototype._addFinalSpanAttributes = function(r, n, i) {
      if (typeof i == "string") {
        var o = _t(i);
        n.status !== void 0 && r.setAttribute(h_, n.status), n.statusText !== void 0 && r.setAttribute(Ci.HTTP_STATUS_TEXT, n.statusText), r.setAttribute(p_, o.host), r.setAttribute(f_, o.protocol.replace(":", "")), r.setAttribute(d_, navigator.userAgent);
      }
    }, t.prototype._applyAttributesAfterXHR = function(r, n) {
      var i = this, o = this.getConfig().applyCustomAttributesOnSpan;
      typeof o == "function" && e_(function() {
        return o(r, n);
      }, function(a) {
        a && i._diag.error("applyCustomAttributesOnSpan", a);
      });
    }, t.prototype._addResourceObserver = function(r, n) {
      var i = this._xhrMem.get(r);
      !i || typeof PerformanceObserver != "function" || typeof PerformanceResourceTiming != "function" || (i.createdResources = {
        observer: new PerformanceObserver(function(o) {
          var a = o.getEntries(), u = _t(n);
          a.forEach(function(c) {
            c.initiatorType === "xmlhttprequest" && c.name === u.href && i.createdResources && i.createdResources.entries.push(c);
          });
        }),
        entries: []
      }, i.createdResources.observer.observe({
        entryTypes: ["resource"]
      }));
    }, t.prototype._clearResources = function() {
      this._tasksCount === 0 && this.getConfig().clearTimingResources && (Ve.clearResourceTimings(), this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet());
    }, t.prototype._findResourceAndAddNetworkEvents = function(r, n, i, o, a) {
      if (!(!i || !o || !a || !r.createdResources)) {
        var u = r.createdResources.entries;
        (!u || !u.length) && (u = Ve.getEntriesByType("resource"));
        var c = mu(_t(i).href, o, a, u, this._usedResources);
        if (c.mainRequest) {
          var s = c.mainRequest;
          this._markResourceAsUsed(s);
          var l = c.corsPreFlightRequest;
          l && (this._addChildSpan(n, l), this._markResourceAsUsed(l)), he(n, s, this.getConfig().ignoreNetworkEvents);
        }
      }
    }, t.prototype._cleanPreviousSpanInformation = function(r) {
      var n = this._xhrMem.get(r);
      if (n) {
        var i = n.callbackToRemoveEvents;
        i && i(), this._xhrMem.delete(r);
      }
    }, t.prototype._createSpan = function(r, n, i) {
      var o;
      if (O_(n, this.getConfig().ignoreUrls)) {
        this._diag.debug("ignoring span as url matches ignored url");
        return;
      }
      var a = i.toUpperCase(), u = this.tracer.startSpan(a, {
        kind: $e.CLIENT,
        attributes: (o = {}, o[c_] = i, o[l_] = _t(n).toString(), o)
      });
      return u.addEvent(yt.METHOD_OPEN), this._cleanPreviousSpanInformation(r), this._xhrMem.set(r, {
        span: u,
        spanUrl: n
      }), u;
    }, t.prototype._markResourceAsUsed = function(r) {
      this._usedResources.add(r);
    }, t.prototype._patchOpen = function() {
      var r = this;
      return function(n) {
        var i = r;
        return function() {
          for (var o = [], a = 0; a < arguments.length; a++)
            o[a] = arguments[a];
          var u = o[0], c = o[1];
          return i._createSpan(this, c, u), n.apply(this, o);
        };
      };
    }, t.prototype._patchSend = function() {
      var r = this;
      function n(l, p, f, m) {
        var v = p.callbackToRemoveEvents;
        typeof v == "function" && v();
        var y = p.span, g = p.spanUrl, E = p.sendStartTime;
        y && (r._findResourceAndAddNetworkEvents(p, y, g, E, f), y.addEvent(l, m), r._addFinalSpanAttributes(y, p, g), y.end(m), r._tasksCount--), r._clearResources();
      }
      function i(l, p) {
        var f = r._xhrMem.get(p);
        if (f) {
          f.status = p.status, f.statusText = p.statusText, r._xhrMem.delete(p), f.span && r._applyAttributesAfterXHR(f.span, p);
          var m = oa(), v = Date.now();
          setTimeout(function() {
            n(l, f, m, v);
          }, x_);
        }
      }
      function o() {
        i(yt.EVENT_ERROR, this);
      }
      function a() {
        i(yt.EVENT_ABORT, this);
      }
      function u() {
        i(yt.EVENT_TIMEOUT, this);
      }
      function c() {
        this.status < 299 ? i(yt.EVENT_LOAD, this) : i(yt.EVENT_ERROR, this);
      }
      function s(l) {
        l.removeEventListener("abort", a), l.removeEventListener("error", o), l.removeEventListener("load", c), l.removeEventListener("timeout", u);
        var p = r._xhrMem.get(l);
        p && (p.callbackToRemoveEvents = void 0);
      }
      return function(l) {
        return function() {
          for (var p = this, f = [], m = 0; m < arguments.length; m++)
            f[m] = arguments[m];
          var v = r._xhrMem.get(this);
          if (!v)
            return l.apply(this, f);
          var y = v.span, g = v.spanUrl;
          if (y && g) {
            if (r.getConfig().measureRequestSize && f != null && f[0]) {
              var E = f[0], N = L_(E);
              N !== void 0 && y.setAttribute(v_, N);
            }
            C.with(x.setSpan(C.active(), y), function() {
              r._tasksCount++, v.sendStartTime = oa(), y.addEvent(yt.METHOD_SEND), p.addEventListener("abort", a), p.addEventListener("error", o), p.addEventListener("load", c), p.addEventListener("timeout", u), v.callbackToRemoveEvents = function() {
                s(p), v.createdResources && v.createdResources.observer.disconnect();
              }, r._addHeaders(p, g), r._addResourceObserver(p, g);
            });
          }
          return l.apply(this, f);
        };
      };
    }, t.prototype.enable = function() {
      this._diag.debug("applying patch to", this.moduleName, this.version), ra(XMLHttpRequest.prototype.open) && (this._unwrap(XMLHttpRequest.prototype, "open"), this._diag.debug("removing previous patch from method open")), ra(XMLHttpRequest.prototype.send) && (this._unwrap(XMLHttpRequest.prototype, "send"), this._diag.debug("removing previous patch from method send")), this._wrap(XMLHttpRequest.prototype, "open", this._patchOpen()), this._wrap(XMLHttpRequest.prototype, "send", this._patchSend());
    }, t.prototype.disable = function() {
      this._diag.debug("removing patch from", this.moduleName, this.version), this._unwrap(XMLHttpRequest.prototype, "open"), this._unwrap(XMLHttpRequest.prototype, "send"), this._tasksCount = 0, this._xhrMem = /* @__PURE__ */ new WeakMap(), this._usedResources = /* @__PURE__ */ new WeakSet();
    }, t;
  }(t_)
);
const I_ = (e, t, r) => {
  var n, i;
  const o = M({}, t);
  return r ? ((n = Object.keys(o)) == null || n.forEach((a) => {
    [...r].includes(a?.toLowerCase()) || (o[a] = "[REDACTED]");
  }), o) : ((i = Object.keys(o)) == null || i.forEach((a) => {
    [...M_, ...e].includes(
      a?.toLowerCase()
    ) && (o[a] = "[REDACTED]");
  }), o);
}, M_ = [
  "authorization",
  "cookie",
  "proxy-authorization",
  "token"
], k_ = [
  "https://www.googleapis.com/identitytoolkit",
  "https://securetoken.googleapis.com"
], D_ = new RegExp("sdk\\/evalx\\/[^/]+\\/contexts\\/(?<context>[^/?]*)\\??.*?"), U_ = new RegExp("\\/eval\\/[^/]+\\/(?<context>[^/?]*)\\??.*?");
function j_(e) {
  return !!(e.includes("/sdk/evalx") && e.match(D_) || e.includes("/eval/") && e.match(U_));
}
const $_ = (e) => ["events.ld.catamorphic.com", "events.launchdarkly.com"].some(
  (t) => e.toLocaleLowerCase().includes(t)
), B_ = (e) => j_(e), F_ = (e, t) => t.some(
  (r) => e.toLocaleLowerCase().includes(r)
), V_ = (e, t, r) => !F_(e, t) && !B_(e) && !$_(e), G_ = (e, t, r) => {
  var n;
  if (r.some(
    (a) => e.toLowerCase().includes(a)
  ))
    return !1;
  let i = [];
  t === !0 ? (i = ["localhost", /^\//], (n = window?.location) != null && n.host && i.push(window.location.host)) : t instanceof Array && (i = t);
  let o = !1;
  return i.forEach((a) => {
    e.match(a) && (o = !0);
  }), o;
}, ua = 64 * 1024, H_ = {
  "application/json": 64 * 1024 * 1024,
  // MB
  "text/plain": 64 * 1024 * 1024
  // MB
}, Eu = (e, t, r, n) => {
  var i, o, a;
  let u = ua;
  if (n) {
    let c = "";
    typeof n.get == "function" ? c = (i = n.get("content-type")) != null ? i : "" : c = (o = n["content-type"]) != null ? o : "";
    try {
      c = c.split(";")[0];
    } catch {
    }
    u = (a = H_[c]) != null ? a : ua;
  }
  if (e) {
    if (t)
      try {
        const c = JSON.parse(e);
        Array.isArray(c) ? c.forEach((s) => {
          Object.keys(s).forEach((l) => {
            t.includes(
              l.toLocaleLowerCase()
            ) && (s[l] = "[REDACTED]");
          });
        }) : Object.keys(c).forEach((s) => {
          t.includes(s.toLocaleLowerCase()) && (c[s] = "[REDACTED]");
        }), e = JSON.stringify(c);
      } catch {
      }
    if (r)
      try {
        const c = JSON.parse(e);
        Object.keys(c).forEach((s) => {
          r.includes(s.toLocaleLowerCase()) || (c[s] = "[REDACTED]");
        }), e = JSON.stringify(c);
      } catch {
      }
  }
  try {
    e = e.slice(0, u);
  } catch {
  }
  return e;
}, z_ = (e, t, r) => se(void 0, null, function* () {
  let n;
  try {
    const i = e.clone().body;
    if (i) {
      let o = i.getReader(), a = new TextDecoder(), u, c = "";
      for (; !(u = yield o.read()).done; ) {
        let s = u.value;
        c += a.decode(s);
      }
      n = c, n = Eu(
        n,
        r,
        t,
        e.headers
      );
    } else
      n = "";
  } catch (i) {
    n = `Unable to clone response: ${i}`;
  }
  return n;
});
var Tu = (
  /** @class */
  function() {
    function e(t) {
      this._delegate = t;
    }
    return e.prototype.export = function(t, r) {
      this._delegate.export(t, r);
    }, e.prototype.forceFlush = function() {
      return this._delegate.forceFlush();
    }, e.prototype.shutdown = function() {
      return this._delegate.shutdown();
    }, e;
  }()
), X_ = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ca = (
  /** @class */
  function(e) {
    X_(t, e);
    function t(r, n, i) {
      var o = e.call(this, r) || this;
      return o.name = "OTLPExporterError", o.data = i, o.code = n, o;
    }
    return t;
  }(Error)
);
function q_(e) {
  if (!Number.isNaN(e) && Number.isFinite(e) && e > 0)
    return e;
  throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + e + "')");
}
function K_(e) {
  if (e != null)
    return function() {
      return e;
    };
}
function W_(e, t, r) {
  var n, i, o, a, u, c;
  return {
    timeoutMillis: q_((i = (n = e.timeoutMillis) !== null && n !== void 0 ? n : t.timeoutMillis) !== null && i !== void 0 ? i : r.timeoutMillis),
    concurrencyLimit: (a = (o = e.concurrencyLimit) !== null && o !== void 0 ? o : t.concurrencyLimit) !== null && a !== void 0 ? a : r.concurrencyLimit,
    compression: (c = (u = e.compression) !== null && u !== void 0 ? u : t.compression) !== null && c !== void 0 ? c : r.compression
  };
}
function Y_() {
  return {
    timeoutMillis: 1e4,
    concurrencyLimit: 30,
    compression: "none"
  };
}
var J_ = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (p) {
        a(p);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (p) {
        a(p);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, [])).next());
  });
}, Q_ = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Z_ = (
  /** @class */
  function() {
    function e(t) {
      this._sendingPromises = [], this._concurrencyLimit = t;
    }
    return e.prototype.pushPromise = function(t) {
      var r = this;
      if (this.hasReachedLimit())
        throw new Error("Concurrency Limit reached");
      this._sendingPromises.push(t);
      var n = function() {
        var i = r._sendingPromises.indexOf(t);
        r._sendingPromises.splice(i, 1);
      };
      t.then(n, n);
    }, e.prototype.hasReachedLimit = function() {
      return this._sendingPromises.length >= this._concurrencyLimit;
    }, e.prototype.awaitAll = function() {
      return J_(this, void 0, void 0, function() {
        return Q_(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, Promise.all(this._sendingPromises)];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function tg(e) {
  return new Z_(e.concurrencyLimit);
}
function eg(e) {
  return Object.prototype.hasOwnProperty.call(e, "partialSuccess");
}
function rg() {
  return {
    handleResponse: function(e) {
      e == null || !eg(e) || e.partialSuccess == null || Object.keys(e.partialSuccess).length === 0 || T.warn("Received Partial Success response:", JSON.stringify(e.partialSuccess));
    }
  };
}
var ng = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (p) {
        a(p);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (p) {
        a(p);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, [])).next());
  });
}, ig = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, og = (
  /** @class */
  function() {
    function e(t, r, n, i, o) {
      this._transport = t, this._serializer = r, this._responseHandler = n, this._promiseQueue = i, this._timeout = o, this._diagLogger = T.createComponentLogger({
        namespace: "OTLPExportDelegate"
      });
    }
    return e.prototype.export = function(t, r) {
      var n = this;
      if (this._diagLogger.debug("items to be sent", t), this._promiseQueue.hasReachedLimit()) {
        r({
          code: J.FAILED,
          error: new Error("Concurrent export limit reached")
        });
        return;
      }
      var i = this._serializer.serializeRequest(t);
      if (i == null) {
        r({
          code: J.FAILED,
          error: new Error("Nothing to send")
        });
        return;
      }
      this._promiseQueue.pushPromise(this._transport.send(i, this._timeout).then(function(o) {
        if (o.status === "success") {
          if (o.data != null)
            try {
              n._responseHandler.handleResponse(n._serializer.deserializeResponse(o.data));
            } catch (a) {
              n._diagLogger.warn("Export succeeded but could not deserialize response - is the response specification compliant?", a, o.data);
            }
          r({
            code: J.SUCCESS
          });
          return;
        } else if (o.status === "failure" && o.error) {
          r({
            code: J.FAILED,
            error: o.error
          });
          return;
        } else o.status === "retryable" ? r({
          code: J.FAILED,
          error: new ca("Export failed with retryable status")
        }) : r({
          code: J.FAILED,
          error: new ca("Export failed with unknown error")
        });
      }, function(o) {
        return r({
          code: J.FAILED,
          error: o
        });
      }));
    }, e.prototype.forceFlush = function() {
      return this._promiseQueue.awaitAll();
    }, e.prototype.shutdown = function() {
      return ng(this, void 0, void 0, function() {
        return ig(this, function(t) {
          switch (t.label) {
            case 0:
              return this._diagLogger.debug("shutdown started"), [4, this.forceFlush()];
            case 1:
              return t.sent(), this._transport.shutdown(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function ag(e, t) {
  return new og(e.transport, e.serializer, rg(), e.promiseHandler, t.timeout);
}
function bu(e, t, r) {
  return ag({
    transport: r,
    serializer: t,
    promiseHandler: tg(e)
  }, { timeout: e.timeoutMillis });
}
function la(e) {
  return e >= 48 && e <= 57 ? e - 48 : e >= 97 && e <= 102 ? e - 87 : e - 55;
}
function to(e) {
  for (var t = new Uint8Array(e.length / 2), r = 0, n = 0; n < e.length; n += 2) {
    var i = la(e.charCodeAt(n)), o = la(e.charCodeAt(n + 1));
    t[r++] = i << 4 | o;
  }
  return t;
}
var sg = 9, ug = Math.pow(10, sg);
function cg(e) {
  return e[0] * ug + e[1];
}
function Ou(e) {
  var t = BigInt(1e9);
  return BigInt(e[0]) * t + BigInt(e[1]);
}
function lg(e) {
  var t = Number(BigInt.asUintN(32, e)), r = Number(BigInt.asUintN(32, e >> BigInt(32)));
  return { low: t, high: r };
}
function Su(e) {
  var t = Ou(e);
  return lg(t);
}
function pg(e) {
  var t = Ou(e);
  return t.toString();
}
var fg = typeof BigInt < "u" ? pg : cg;
function pa(e) {
  return e;
}
function wu(e) {
  if (e !== void 0)
    return to(e);
}
var hg = {
  encodeHrTime: Su,
  encodeSpanContext: to,
  encodeOptionalSpanContext: wu
};
function Au(e) {
  var t, r;
  if (e === void 0)
    return hg;
  var n = (t = e.useLongBits) !== null && t !== void 0 ? t : !0, i = (r = e.useHex) !== null && r !== void 0 ? r : !1;
  return {
    encodeHrTime: n ? Su : fg,
    encodeSpanContext: i ? pa : to,
    encodeOptionalSpanContext: i ? pa : wu
  };
}
var dg = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Lu(e) {
  return {
    attributes: Ht(e.attributes),
    droppedAttributesCount: 0
  };
}
function Ru(e) {
  return {
    name: e.name,
    version: e.version
  };
}
function Ht(e) {
  return Object.keys(e).map(function(t) {
    return Cu(t, e[t]);
  });
}
function Cu(e, t) {
  return {
    key: e,
    value: Nu(t)
  };
}
function Nu(e) {
  var t = typeof e;
  return t === "string" ? { stringValue: e } : t === "number" ? Number.isInteger(e) ? { intValue: e } : { doubleValue: e } : t === "boolean" ? { boolValue: e } : e instanceof Uint8Array ? { bytesValue: e } : Array.isArray(e) ? { arrayValue: { values: e.map(Nu) } } : t === "object" && e != null ? {
    kvlistValue: {
      values: Object.entries(e).map(function(r) {
        var n = dg(r, 2), i = n[0], o = n[1];
        return Cu(i, o);
      })
    }
  } : {};
}
var ut;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE";
})(ut || (ut = {}));
var ft;
(function(e) {
  e[e.HISTOGRAM = 0] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 1] = "EXPONENTIAL_HISTOGRAM", e[e.GAUGE = 2] = "GAUGE", e[e.SUM = 3] = "SUM";
})(ft || (ft = {}));
var vg = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), fa = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (p) {
        a(p);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (p) {
        a(p);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, [])).next());
  });
}, ha = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, mg = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, yg = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, _g = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function gg(e) {
  return e != null;
}
function xu(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "" : (t = t.sort(), JSON.stringify(t.map(function(r) {
    return [r, e[r]];
  })));
}
function Eg(e) {
  var t, r;
  return e.name + ":" + ((t = e.version) !== null && t !== void 0 ? t : "") + ":" + ((r = e.schemaUrl) !== null && r !== void 0 ? r : "");
}
var Pu = (
  /** @class */
  function(e) {
    vg(t, e);
    function t(r) {
      var n = e.call(this, r) || this;
      return Object.setPrototypeOf(n, t.prototype), n;
    }
    return t;
  }(Error)
);
function Ge(e, t) {
  var r, n = new Promise(function(i, o) {
    r = setTimeout(function() {
      o(new Pu("Operation timed out."));
    }, t);
  });
  return Promise.race([e, n]).then(function(i) {
    return clearTimeout(r), i;
  }, function(i) {
    throw clearTimeout(r), i;
  });
}
function Tg(e) {
  return fa(this, void 0, void 0, function() {
    var t = this;
    return ha(this, function(r) {
      return [2, Promise.all(e.map(function(n) {
        return fa(t, void 0, void 0, function() {
          var i, o;
          return ha(this, function(a) {
            switch (a.label) {
              case 0:
                return a.trys.push([0, 2, , 3]), [4, n];
              case 1:
                return i = a.sent(), [2, {
                  status: "fulfilled",
                  value: i
                }];
              case 2:
                return o = a.sent(), [2, {
                  status: "rejected",
                  reason: o
                }];
              case 3:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }))];
    });
  });
}
function bg(e) {
  return e.status === "rejected";
}
function da(e, t) {
  var r = [];
  return e.forEach(function(n) {
    r.push.apply(r, yg([], mg(t(n)), !1));
  }), r;
}
function Og(e, t) {
  var r, n;
  if (e.size !== t.size)
    return !1;
  try {
    for (var i = _g(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (!t.has(a))
        return !1;
    }
  } catch (u) {
    r = { error: u };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (r) throw r.error;
    }
  }
  return !0;
}
function Sg(e, t) {
  for (var r = 0, n = e.length - 1, i = e.length; n >= r; ) {
    var o = r + Math.trunc((n - r) / 2);
    e[o] < t ? r = o + 1 : (i = o, n = o - 1);
  }
  return i;
}
function wg(e, t) {
  return e.toLowerCase() === t.toLowerCase();
}
var Ft;
(function(e) {
  e[e.DROP = 0] = "DROP", e[e.SUM = 1] = "SUM", e[e.LAST_VALUE = 2] = "LAST_VALUE", e[e.HISTOGRAM = 3] = "HISTOGRAM", e[e.EXPONENTIAL_HISTOGRAM = 4] = "EXPONENTIAL_HISTOGRAM";
})(Ft || (Ft = {}));
var Ag = (
  /** @class */
  function() {
    function e() {
      this.kind = Ft.DROP;
    }
    return e.prototype.createAccumulation = function() {
    }, e.prototype.merge = function(t, r) {
    }, e.prototype.diff = function(t, r) {
    }, e.prototype.toMetricData = function(t, r, n, i) {
    }, e;
  }()
), w;
(function(e) {
  e.COUNTER = "COUNTER", e.GAUGE = "GAUGE", e.HISTOGRAM = "HISTOGRAM", e.UP_DOWN_COUNTER = "UP_DOWN_COUNTER", e.OBSERVABLE_COUNTER = "OBSERVABLE_COUNTER", e.OBSERVABLE_GAUGE = "OBSERVABLE_GAUGE", e.OBSERVABLE_UP_DOWN_COUNTER = "OBSERVABLE_UP_DOWN_COUNTER";
})(w || (w = {}));
function Tt(e, t, r) {
  var n, i, o, a;
  return Ng(e) || T.warn('Invalid metric name: "' + e + '". The metric name should be a ASCII string with a length no greater than 255 characters.'), {
    name: e,
    type: t,
    description: (n = r?.description) !== null && n !== void 0 ? n : "",
    unit: (i = r?.unit) !== null && i !== void 0 ? i : "",
    valueType: (o = r?.valueType) !== null && o !== void 0 ? o : Ct.DOUBLE,
    advice: (a = r?.advice) !== null && a !== void 0 ? a : {}
  };
}
function Lg(e, t) {
  var r, n;
  return {
    name: (r = e.name) !== null && r !== void 0 ? r : t.name,
    description: (n = e.description) !== null && n !== void 0 ? n : t.description,
    type: t.type,
    unit: t.unit,
    valueType: t.valueType,
    advice: t.advice
  };
}
function Rg(e, t) {
  return wg(e.name, t.name) && e.unit === t.unit && e.type === t.type && e.valueType === t.valueType;
}
var Cg = /^[a-z][a-z0-9_.\-/]{0,254}$/i;
function Ng(e) {
  return e.match(Cg) != null;
}
var xg = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Pg(e) {
  var t = e.map(function() {
    return 0;
  });
  return t.push(0), {
    buckets: {
      boundaries: e,
      counts: t
    },
    sum: 0,
    count: 0,
    hasMinMax: !1,
    min: 1 / 0,
    max: -1 / 0
  };
}
var Mn = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      n === void 0 && (n = !0), i === void 0 && (i = Pg(r)), this.startTime = t, this._boundaries = r, this._recordMinMax = n, this._current = i;
    }
    return e.prototype.record = function(t) {
      if (!Number.isNaN(t)) {
        this._current.count += 1, this._current.sum += t, this._recordMinMax && (this._current.min = Math.min(t, this._current.min), this._current.max = Math.max(t, this._current.max), this._current.hasMinMax = !0);
        var r = Sg(this._boundaries, t);
        this._current.buckets.counts[r] += 1;
      }
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), Iu = (
  /** @class */
  function() {
    function e(t, r) {
      this._boundaries = t, this._recordMinMax = r, this.kind = Ft.HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new Mn(t, this._boundaries, this._recordMinMax);
    }, e.prototype.merge = function(t, r) {
      for (var n = t.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = o[c] + a[c];
      var s = 1 / 0, l = -1 / 0;
      return this._recordMinMax && (n.hasMinMax && i.hasMinMax ? (s = Math.min(n.min, i.min), l = Math.max(n.max, i.max)) : n.hasMinMax ? (s = n.min, l = n.max) : i.hasMinMax && (s = i.min, l = i.max)), new Mn(t.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: n.count + i.count,
        sum: n.sum + i.sum,
        hasMinMax: this._recordMinMax && (n.hasMinMax || i.hasMinMax),
        min: s,
        max: l
      });
    }, e.prototype.diff = function(t, r) {
      for (var n = t.toPointValue(), i = r.toPointValue(), o = n.buckets.counts, a = i.buckets.counts, u = new Array(o.length), c = 0; c < o.length; c++)
        u[c] = a[c] - o[c];
      return new Mn(r.startTime, n.buckets.boundaries, this._recordMinMax, {
        buckets: {
          boundaries: n.buckets.boundaries,
          counts: u
        },
        count: i.count - n.count,
        sum: i.sum - n.sum,
        hasMinMax: !1,
        min: 1 / 0,
        max: -1 / 0
      });
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: ft.HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = xg(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = t.type === w.GAUGE || t.type === w.UP_DOWN_COUNTER || t.type === w.OBSERVABLE_GAUGE || t.type === w.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              buckets: s.buckets,
              count: s.count
            }
          };
        })
      };
    }, e;
  }()
), kn = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Dn = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, va = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      t === void 0 && (t = new Ig()), r === void 0 && (r = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), this.backing = t, this.indexBase = r, this.indexStart = n, this.indexEnd = i;
    }
    return Object.defineProperty(e.prototype, "offset", {
      /**
       * Offset is the bucket index of the smallest entry in the counts array
       * @returns {number}
       */
      get: function() {
        return this.indexStart;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "length", {
      /**
       * Buckets is a view into the backing array.
       * @returns {number}
       */
      get: function() {
        return this.backing.length === 0 || this.indexEnd === this.indexStart && this.at(0) === 0 ? 0 : this.indexEnd - this.indexStart + 1;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.counts = function() {
      var t = this;
      return Array.from({ length: this.length }, function(r, n) {
        return t.at(n);
      });
    }, e.prototype.at = function(t) {
      var r = this.indexBase - this.indexStart;
      return t < r && (t += this.backing.length), t -= r, this.backing.countAt(t);
    }, e.prototype.incrementBucket = function(t, r) {
      this.backing.increment(t, r);
    }, e.prototype.decrementBucket = function(t, r) {
      this.backing.decrement(t, r);
    }, e.prototype.trim = function() {
      for (var t = 0; t < this.length; t++)
        if (this.at(t) !== 0) {
          this.indexStart += t;
          break;
        } else if (t === this.length - 1) {
          this.indexStart = this.indexEnd = this.indexBase = 0;
          return;
        }
      for (var t = this.length - 1; t >= 0; t--)
        if (this.at(t) !== 0) {
          this.indexEnd -= this.length - t - 1;
          break;
        }
      this._rotate();
    }, e.prototype.downscale = function(t) {
      this._rotate();
      for (var r = 1 + this.indexEnd - this.indexStart, n = 1 << t, i = 0, o = 0, a = this.indexStart; a <= this.indexEnd; ) {
        var u = a % n;
        u < 0 && (u += n);
        for (var c = u; c < n && i < r; c++)
          this._relocateBucket(o, i), i++, a++;
        o++;
      }
      this.indexStart >>= t, this.indexEnd >>= t, this.indexBase = this.indexStart;
    }, e.prototype.clone = function() {
      return new e(this.backing.clone(), this.indexBase, this.indexStart, this.indexEnd);
    }, e.prototype._rotate = function() {
      var t = this.indexBase - this.indexStart;
      t !== 0 && (t > 0 ? (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, t), this.backing.reverse(t, this.backing.length)) : (this.backing.reverse(0, this.backing.length), this.backing.reverse(0, this.backing.length + t)), this.indexBase = this.indexStart);
    }, e.prototype._relocateBucket = function(t, r) {
      t !== r && this.incrementBucket(t, this.backing.emptyBucket(r));
    }, e;
  }()
), Ig = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = [0]), this._counts = t;
    }
    return Object.defineProperty(e.prototype, "length", {
      /**
       * length returns the physical size of the backing array, which
       * is >= buckets.length()
       */
      get: function() {
        return this._counts.length;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.countAt = function(t) {
      return this._counts[t];
    }, e.prototype.growTo = function(t, r, n) {
      var i = new Array(t).fill(0);
      i.splice.apply(i, Dn([
        n,
        this._counts.length - r
      ], kn(this._counts.slice(r)), !1)), i.splice.apply(i, Dn([0, r], kn(this._counts.slice(0, r)), !1)), this._counts = i;
    }, e.prototype.reverse = function(t, r) {
      for (var n = Math.floor((t + r) / 2) - t, i = 0; i < n; i++) {
        var o = this._counts[t + i];
        this._counts[t + i] = this._counts[r - i - 1], this._counts[r - i - 1] = o;
      }
    }, e.prototype.emptyBucket = function(t) {
      var r = this._counts[t];
      return this._counts[t] = 0, r;
    }, e.prototype.increment = function(t, r) {
      this._counts[t] += r;
    }, e.prototype.decrement = function(t, r) {
      this._counts[t] >= r ? this._counts[t] -= r : this._counts[t] = 0;
    }, e.prototype.clone = function() {
      return new e(Dn([], kn(this._counts), !1));
    }, e;
  }()
), Mg = 52, kg = 2146435072, Dg = 1048575, eo = 1023, Mu = -eo + 1, ku = eo, Ni = Math.pow(2, -1022);
function Du(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var r = t.getUint32(0), n = (r & kg) >> 20;
  return n - eo;
}
function Uu(e) {
  var t = new DataView(new ArrayBuffer(8));
  t.setFloat64(0, e);
  var r = t.getUint32(0), n = t.getUint32(4), i = (r & Dg) * Math.pow(2, 32);
  return i + n;
}
function xi(e, t) {
  return e === 0 || e === Number.POSITIVE_INFINITY || e === Number.NEGATIVE_INFINITY || Number.isNaN(e) ? e : e * Math.pow(2, t);
}
function Ug(e) {
  return e--, e |= e >> 1, e |= e >> 2, e |= e >> 4, e |= e >> 8, e |= e >> 16, e++, e;
}
var jg = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), He = (
  /** @class */
  function(e) {
    jg(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Error)
), $g = (
  /** @class */
  function() {
    function e(t) {
      this._shift = -t;
    }
    return e.prototype.mapToIndex = function(t) {
      if (t < Ni)
        return this._minNormalLowerBoundaryIndex();
      var r = Du(t), n = this._rightShift(Uu(t) - 1, Mg);
      return r + n >> this._shift;
    }, e.prototype.lowerBoundary = function(t) {
      var r = this._minNormalLowerBoundaryIndex();
      if (t < r)
        throw new He("underflow: " + t + " is < minimum lower boundary: " + r);
      var n = this._maxNormalLowerBoundaryIndex();
      if (t > n)
        throw new He("overflow: " + t + " is > maximum lower boundary: " + n);
      return xi(1, t << this._shift);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._shift === 0 ? 0 : -this._shift;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      var t = Mu >> this._shift;
      return this._shift < 2 && t--, t;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return ku >> this._shift;
    }, e.prototype._rightShift = function(t, r) {
      return Math.floor(t * Math.pow(2, -r));
    }, e;
  }()
), Bg = (
  /** @class */
  function() {
    function e(t) {
      this._scale = t, this._scaleFactor = xi(Math.LOG2E, t), this._inverseFactor = xi(Math.LN2, -t);
    }
    return e.prototype.mapToIndex = function(t) {
      if (t <= Ni)
        return this._minNormalLowerBoundaryIndex() - 1;
      if (Uu(t) === 0) {
        var r = Du(t);
        return (r << this._scale) - 1;
      }
      var n = Math.floor(Math.log(t) * this._scaleFactor), i = this._maxNormalLowerBoundaryIndex();
      return n >= i ? i : n;
    }, e.prototype.lowerBoundary = function(t) {
      var r = this._maxNormalLowerBoundaryIndex();
      if (t >= r) {
        if (t === r)
          return 2 * Math.exp((t - (1 << this._scale)) / this._scaleFactor);
        throw new He("overflow: " + t + " is > maximum lower boundary: " + r);
      }
      var n = this._minNormalLowerBoundaryIndex();
      if (t <= n) {
        if (t === n)
          return Ni;
        if (t === n - 1)
          return Math.exp((t + (1 << this._scale)) / this._scaleFactor) / 2;
        throw new He("overflow: " + t + " is < minimum lower boundary: " + n);
      }
      return Math.exp(t * this._inverseFactor);
    }, Object.defineProperty(e.prototype, "scale", {
      /**
       * The scale used by this mapping
       * @returns {number}
       */
      get: function() {
        return this._scale;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype._minNormalLowerBoundaryIndex = function() {
      return Mu << this._scale;
    }, e.prototype._maxNormalLowerBoundaryIndex = function() {
      return (ku + 1 << this._scale) - 1;
    }, e;
  }()
), ma = -10, ya = 20, Fg = Array.from({ length: 31 }, function(e, t) {
  return t > 10 ? new Bg(t - 10) : new $g(t - 10);
});
function _a(e) {
  if (e > ya || e < ma)
    throw new He("expected scale >= " + ma + " && <= " + ya + ", got: " + e);
  return Fg[e + 10];
}
var Vg = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, ir = (
  /** @class */
  function() {
    function e(t, r) {
      this.low = t, this.high = r;
    }
    return e.combine = function(t, r) {
      return new e(Math.min(t.low, r.low), Math.max(t.high, r.high));
    }, e;
  }()
), Gg = 20, Hg = 160, Un = 2, zg = (
  /** @class */
  function() {
    function e(t, r, n, i, o, a, u, c, s, l, p) {
      t === void 0 && (t = t), r === void 0 && (r = Hg), n === void 0 && (n = !0), i === void 0 && (i = 0), o === void 0 && (o = 0), a === void 0 && (a = 0), u === void 0 && (u = Number.POSITIVE_INFINITY), c === void 0 && (c = Number.NEGATIVE_INFINITY), s === void 0 && (s = new va()), l === void 0 && (l = new va()), p === void 0 && (p = _a(Gg)), this.startTime = t, this._maxSize = r, this._recordMinMax = n, this._sum = i, this._count = o, this._zeroCount = a, this._min = u, this._max = c, this._positive = s, this._negative = l, this._mapping = p, this._maxSize < Un && (T.warn("Exponential Histogram Max Size set to " + this._maxSize + ",                 changing to the minimum size of: " + Un), this._maxSize = Un);
    }
    return e.prototype.record = function(t) {
      this.updateByIncrement(t, 1);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return {
        hasMinMax: this._recordMinMax,
        min: this.min,
        max: this.max,
        sum: this.sum,
        positive: {
          offset: this.positive.offset,
          bucketCounts: this.positive.counts()
        },
        negative: {
          offset: this.negative.offset,
          bucketCounts: this.negative.counts()
        },
        count: this.count,
        scale: this.scale,
        zeroCount: this.zeroCount
      };
    }, Object.defineProperty(e.prototype, "sum", {
      /**
       * @returns {Number} The sum of values recorded by this accumulation
       */
      get: function() {
        return this._sum;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "min", {
      /**
       * @returns {Number} The minimum value recorded by this accumulation
       */
      get: function() {
        return this._min;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "max", {
      /**
       * @returns {Number} The maximum value recorded by this accumulation
       */
      get: function() {
        return this._max;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "count", {
      /**
       * @returns {Number} The count of values recorded by this accumulation
       */
      get: function() {
        return this._count;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "zeroCount", {
      /**
       * @returns {Number} The number of 0 values recorded by this accumulation
       */
      get: function() {
        return this._zeroCount;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "scale", {
      /**
       * @returns {Number} The scale used by this accumulation
       */
      get: function() {
        return this._count === this._zeroCount ? 0 : this._mapping.scale;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "positive", {
      /**
       * positive holds the positive values
       * @returns {Buckets}
       */
      get: function() {
        return this._positive;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "negative", {
      /**
       * negative holds the negative values by their absolute value
       * @returns {Buckets}
       */
      get: function() {
        return this._negative;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.updateByIncrement = function(t, r) {
      if (!Number.isNaN(t)) {
        if (t > this._max && (this._max = t), t < this._min && (this._min = t), this._count += r, t === 0) {
          this._zeroCount += r;
          return;
        }
        this._sum += t * r, t > 0 ? this._updateBuckets(this._positive, t, r) : this._updateBuckets(this._negative, -t, r);
      }
    }, e.prototype.merge = function(t) {
      this._count === 0 ? (this._min = t.min, this._max = t.max) : t.count !== 0 && (t.min < this.min && (this._min = t.min), t.max > this.max && (this._max = t.max)), this.startTime = t.startTime, this._sum += t.sum, this._count += t.count, this._zeroCount += t.zeroCount;
      var r = this._minScale(t);
      this._downscale(this.scale - r), this._mergeBuckets(this.positive, t, t.positive, r), this._mergeBuckets(this.negative, t, t.negative, r);
    }, e.prototype.diff = function(t) {
      this._min = 1 / 0, this._max = -1 / 0, this._sum -= t.sum, this._count -= t.count, this._zeroCount -= t.zeroCount;
      var r = this._minScale(t);
      this._downscale(this.scale - r), this._diffBuckets(this.positive, t, t.positive, r), this._diffBuckets(this.negative, t, t.negative, r);
    }, e.prototype.clone = function() {
      return new e(this.startTime, this._maxSize, this._recordMinMax, this._sum, this._count, this._zeroCount, this._min, this._max, this.positive.clone(), this.negative.clone(), this._mapping);
    }, e.prototype._updateBuckets = function(t, r, n) {
      var i = this._mapping.mapToIndex(r), o = !1, a = 0, u = 0;
      if (t.length === 0 ? (t.indexStart = i, t.indexEnd = t.indexStart, t.indexBase = t.indexStart) : i < t.indexStart && t.indexEnd - i >= this._maxSize ? (o = !0, u = i, a = t.indexEnd) : i > t.indexEnd && i - t.indexStart >= this._maxSize && (o = !0, u = t.indexStart, a = i), o) {
        var c = this._changeScale(a, u);
        this._downscale(c), i = this._mapping.mapToIndex(r);
      }
      this._incrementIndexBy(t, i, n);
    }, e.prototype._incrementIndexBy = function(t, r, n) {
      if (n !== 0) {
        if (t.length === 0 && (t.indexStart = t.indexEnd = t.indexBase = r), r < t.indexStart) {
          var i = t.indexEnd - r;
          i >= t.backing.length && this._grow(t, i + 1), t.indexStart = r;
        } else if (r > t.indexEnd) {
          var i = r - t.indexStart;
          i >= t.backing.length && this._grow(t, i + 1), t.indexEnd = r;
        }
        var o = r - t.indexBase;
        o < 0 && (o += t.backing.length), t.incrementBucket(o, n);
      }
    }, e.prototype._grow = function(t, r) {
      var n = t.backing.length, i = t.indexBase - t.indexStart, o = n - i, a = Ug(r);
      a > this._maxSize && (a = this._maxSize);
      var u = a - i;
      t.backing.growTo(a, o, u);
    }, e.prototype._changeScale = function(t, r) {
      for (var n = 0; t - r >= this._maxSize; )
        t >>= 1, r >>= 1, n++;
      return n;
    }, e.prototype._downscale = function(t) {
      if (t !== 0) {
        if (t < 0)
          throw new Error("impossible change of scale: " + this.scale);
        var r = this._mapping.scale - t;
        this._positive.downscale(t), this._negative.downscale(t), this._mapping = _a(r);
      }
    }, e.prototype._minScale = function(t) {
      var r = Math.min(this.scale, t.scale), n = ir.combine(this._highLowAtScale(this.positive, this.scale, r), this._highLowAtScale(t.positive, t.scale, r)), i = ir.combine(this._highLowAtScale(this.negative, this.scale, r), this._highLowAtScale(t.negative, t.scale, r));
      return Math.min(r - this._changeScale(n.high, n.low), r - this._changeScale(i.high, i.low));
    }, e.prototype._highLowAtScale = function(t, r, n) {
      if (t.length === 0)
        return new ir(0, -1);
      var i = r - n;
      return new ir(t.indexStart >> i, t.indexEnd >> i);
    }, e.prototype._mergeBuckets = function(t, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++)
        this._incrementIndexBy(t, o + u >> a, n.at(u));
    }, e.prototype._diffBuckets = function(t, r, n, i) {
      for (var o = n.offset, a = r.scale - i, u = 0; u < n.length; u++) {
        var c = o + u >> a, s = c - t.indexBase;
        s < 0 && (s += t.backing.length), t.decrementBucket(s, n.at(u));
      }
      t.trim();
    }, e;
  }()
), Xg = (
  /** @class */
  function() {
    function e(t, r) {
      this._maxSize = t, this._recordMinMax = r, this.kind = Ft.EXPONENTIAL_HISTOGRAM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new zg(t, this._maxSize, this._recordMinMax);
    }, e.prototype.merge = function(t, r) {
      var n = r.clone();
      return n.merge(t), n;
    }, e.prototype.diff = function(t, r) {
      var n = r.clone();
      return n.diff(t), n;
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: ft.EXPONENTIAL_HISTOGRAM,
        dataPoints: n.map(function(o) {
          var a = Vg(o, 2), u = a[0], c = a[1], s = c.toPointValue(), l = t.type === w.GAUGE || t.type === w.UP_DOWN_COUNTER || t.type === w.OBSERVABLE_GAUGE || t.type === w.OBSERVABLE_UP_DOWN_COUNTER;
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: {
              min: s.hasMinMax ? s.min : void 0,
              max: s.hasMinMax ? s.max : void 0,
              sum: l ? void 0 : s.sum,
              positive: {
                offset: s.positive.offset,
                bucketCounts: s.positive.bucketCounts
              },
              negative: {
                offset: s.negative.offset,
                bucketCounts: s.negative.bucketCounts
              },
              count: s.count,
              scale: s.scale,
              zeroCount: s.zeroCount
            }
          };
        })
      };
    }, e;
  }()
), qg = qe("OpenTelemetry SDK Context Key SUPPRESS_TRACING");
function Kg(e) {
  return e.setValue(qg, !0);
}
function Wg() {
  return function(e) {
    T.error(Yg(e));
  };
}
function Yg(e) {
  return typeof e == "string" ? e : JSON.stringify(Jg(e));
}
function Jg(e) {
  for (var t = {}, r = e; r !== null; )
    Object.getOwnPropertyNames(r).forEach(function(n) {
      if (!t[n]) {
        var i = r[n];
        i && (t[n] = String(i));
      }
    }), r = Object.getPrototypeOf(r);
  return t;
}
var Qg = Wg();
function ga(e) {
  try {
    Qg(e);
  } catch {
  }
}
var Zg = 6, tE = Math.pow(10, Zg);
function ro(e) {
  var t = e / 1e3, r = Math.trunc(t), n = Math.round(e % 1e3 * tE);
  return [r, n];
}
function or(e) {
  return e[0] * 1e6 + e[1] / 1e3;
}
var Pi;
(function(e) {
  e[e.SUCCESS = 0] = "SUCCESS", e[e.FAILED = 1] = "FAILED";
})(Pi || (Pi = {}));
function eE(e, t) {
  return new Promise(function(r) {
    C.with(Kg(C.active()), function() {
      e.export(t, function(n) {
        r(n);
      });
    });
  });
}
var rE = {
  _export: eE
}, nE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, jn = (
  /** @class */
  function() {
    function e(t, r, n) {
      r === void 0 && (r = 0), n === void 0 && (n = [0, 0]), this.startTime = t, this._current = r, this.sampleTime = n;
    }
    return e.prototype.record = function(t) {
      this._current = t, this.sampleTime = ro(Date.now());
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), iE = (
  /** @class */
  function() {
    function e() {
      this.kind = Ft.LAST_VALUE;
    }
    return e.prototype.createAccumulation = function(t) {
      return new jn(t);
    }, e.prototype.merge = function(t, r) {
      var n = or(r.sampleTime) >= or(t.sampleTime) ? r : t;
      return new jn(t.startTime, n.toPointValue(), n.sampleTime);
    }, e.prototype.diff = function(t, r) {
      var n = or(r.sampleTime) >= or(t.sampleTime) ? r : t;
      return new jn(r.startTime, n.toPointValue(), n.sampleTime);
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: ft.GAUGE,
        dataPoints: n.map(function(o) {
          var a = nE(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        })
      };
    }, e;
  }()
), oE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, we = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      n === void 0 && (n = 0), i === void 0 && (i = !1), this.startTime = t, this.monotonic = r, this._current = n, this.reset = i;
    }
    return e.prototype.record = function(t) {
      this.monotonic && t < 0 || (this._current += t);
    }, e.prototype.setStartTime = function(t) {
      this.startTime = t;
    }, e.prototype.toPointValue = function() {
      return this._current;
    }, e;
  }()
), Ea = (
  /** @class */
  function() {
    function e(t) {
      this.monotonic = t, this.kind = Ft.SUM;
    }
    return e.prototype.createAccumulation = function(t) {
      return new we(t, this.monotonic);
    }, e.prototype.merge = function(t, r) {
      var n = t.toPointValue(), i = r.toPointValue();
      return r.reset ? new we(r.startTime, this.monotonic, i, r.reset) : new we(t.startTime, this.monotonic, n + i);
    }, e.prototype.diff = function(t, r) {
      var n = t.toPointValue(), i = r.toPointValue();
      return this.monotonic && n > i ? new we(r.startTime, this.monotonic, i, !0) : new we(r.startTime, this.monotonic, i - n);
    }, e.prototype.toMetricData = function(t, r, n, i) {
      return {
        descriptor: t,
        aggregationTemporality: r,
        dataPointType: ft.SUM,
        dataPoints: n.map(function(o) {
          var a = oE(o, 2), u = a[0], c = a[1];
          return {
            attributes: u,
            startTime: c.startTime,
            endTime: i,
            value: c.toPointValue()
          };
        }),
        isMonotonic: this.monotonic
      };
    }, e;
  }()
), zt = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Et = (
  /** @class */
  function() {
    function e() {
    }
    return e.Drop = function() {
      return ju;
    }, e.Sum = function() {
      return $u;
    }, e.LastValue = function() {
      return Bu;
    }, e.Histogram = function() {
      return Fu;
    }, e.ExponentialHistogram = function() {
      return hE;
    }, e.Default = function() {
      return dE;
    }, e;
  }()
), aE = (
  /** @class */
  function(e) {
    zt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new Ag(), t;
  }(Et)
), sE = (
  /** @class */
  function(e) {
    zt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      switch (r.type) {
        case w.COUNTER:
        case w.OBSERVABLE_COUNTER:
        case w.HISTOGRAM:
          return t.MONOTONIC_INSTANCE;
        default:
          return t.NON_MONOTONIC_INSTANCE;
      }
    }, t.MONOTONIC_INSTANCE = new Ea(!0), t.NON_MONOTONIC_INSTANCE = new Ea(!1), t;
  }(Et)
), uE = (
  /** @class */
  function(e) {
    zt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new iE(), t;
  }(Et)
), cE = (
  /** @class */
  function(e) {
    zt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.createAggregator = function(r) {
      return t.DEFAULT_INSTANCE;
    }, t.DEFAULT_INSTANCE = new Iu([0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4], !0), t;
  }(Et)
), lE = (
  /** @class */
  function(e) {
    zt(t, e);
    function t(r, n) {
      n === void 0 && (n = !0);
      var i = e.call(this) || this;
      if (i._recordMinMax = n, r == null)
        throw new Error("ExplicitBucketHistogramAggregation should be created with explicit boundaries, if a single bucket histogram is required, please pass an empty array");
      r = r.concat(), r = r.sort(function(u, c) {
        return u - c;
      });
      var o = r.lastIndexOf(-1 / 0), a = r.indexOf(1 / 0);
      return a === -1 && (a = void 0), i._boundaries = r.slice(o + 1, a), i;
    }
    return t.prototype.createAggregator = function(r) {
      return new Iu(this._boundaries, this._recordMinMax);
    }, t;
  }(Et)
), pE = (
  /** @class */
  function(e) {
    zt(t, e);
    function t(r, n) {
      r === void 0 && (r = 160), n === void 0 && (n = !0);
      var i = e.call(this) || this;
      return i._maxSize = r, i._recordMinMax = n, i;
    }
    return t.prototype.createAggregator = function(r) {
      return new Xg(this._maxSize, this._recordMinMax);
    }, t;
  }(Et)
), fE = (
  /** @class */
  function(e) {
    zt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype._resolve = function(r) {
      switch (r.type) {
        case w.COUNTER:
        case w.UP_DOWN_COUNTER:
        case w.OBSERVABLE_COUNTER:
        case w.OBSERVABLE_UP_DOWN_COUNTER:
          return $u;
        case w.GAUGE:
        case w.OBSERVABLE_GAUGE:
          return Bu;
        case w.HISTOGRAM:
          return r.advice.explicitBucketBoundaries ? new lE(r.advice.explicitBucketBoundaries) : Fu;
      }
      return T.warn("Unable to recognize instrument type: " + r.type), ju;
    }, t.prototype.createAggregator = function(r) {
      return this._resolve(r).createAggregator(r);
    }, t;
  }(Et)
), ju = new aE(), $u = new sE(), Bu = new uE(), Fu = new cE(), hE = new pE(), dE = new fE(), vE = function(e) {
  return Et.Default();
}, mE = function(e) {
  return ut.CUMULATIVE;
}, $n = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (p) {
        a(p);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (p) {
        a(p);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, [])).next());
  });
}, Bn = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Ta = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, yE = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, _E = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i;
      this._shutdown = !1, this._aggregationSelector = (r = t?.aggregationSelector) !== null && r !== void 0 ? r : vE, this._aggregationTemporalitySelector = (n = t?.aggregationTemporalitySelector) !== null && n !== void 0 ? n : mE, this._metricProducers = (i = t?.metricProducers) !== null && i !== void 0 ? i : [], this._cardinalitySelector = t?.cardinalitySelector;
    }
    return e.prototype.setMetricProducer = function(t) {
      if (this._sdkMetricProducer)
        throw new Error("MetricReader can not be bound to a MeterProvider again.");
      this._sdkMetricProducer = t, this.onInitialized();
    }, e.prototype.selectAggregation = function(t) {
      return this._aggregationSelector(t);
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._aggregationTemporalitySelector(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      return this._cardinalitySelector ? this._cardinalitySelector(t) : 2e3;
    }, e.prototype.onInitialized = function() {
    }, e.prototype.collect = function(t) {
      return $n(this, void 0, void 0, function() {
        var r, n, i, o, a, u;
        return Bn(this, function(c) {
          switch (c.label) {
            case 0:
              if (this._sdkMetricProducer === void 0)
                throw new Error("MetricReader is not bound to a MetricProducer");
              if (this._shutdown)
                throw new Error("MetricReader is shutdown");
              return [4, Promise.all(yE([
                this._sdkMetricProducer.collect({
                  timeoutMillis: t?.timeoutMillis
                })
              ], Ta(this._metricProducers.map(function(s) {
                return s.collect({
                  timeoutMillis: t?.timeoutMillis
                });
              })), !1))];
            case 1:
              return r = Ta.apply(void 0, [c.sent()]), n = r[0], i = r.slice(1), o = n.errors.concat(da(i, function(s) {
                return s.errors;
              })), a = n.resourceMetrics.resource, u = n.resourceMetrics.scopeMetrics.concat(da(i, function(s) {
                return s.resourceMetrics.scopeMetrics;
              })), [2, {
                resourceMetrics: {
                  resource: a,
                  scopeMetrics: u
                },
                errors: o
              }];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return $n(this, void 0, void 0, function() {
        return Bn(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (T.error("Cannot call shutdown twice."), [
                2
                /*return*/
              ]) : t?.timeoutMillis != null ? [3, 2] : [4, this.onShutdown()];
            case 1:
              return r.sent(), [3, 4];
            case 2:
              return [4, Ge(this.onShutdown(), t.timeoutMillis)];
            case 3:
              r.sent(), r.label = 4;
            case 4:
              return this._shutdown = !0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return $n(this, void 0, void 0, function() {
        return Bn(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (T.warn("Cannot forceFlush on already shutdown MetricReader."), [
                2
                /*return*/
              ]) : t?.timeoutMillis != null ? [3, 2] : [4, this.onForceFlush()];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
            case 2:
              return [4, Ge(this.onForceFlush(), t.timeoutMillis)];
            case 3:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
), gE = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ar = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (p) {
        a(p);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (p) {
        a(p);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, [])).next());
  });
}, sr = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, EE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, TE = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, bE = (
  /** @class */
  function(e) {
    gE(t, e);
    function t(r) {
      var n, i, o, a, u = e.call(this, {
        aggregationSelector: (n = r.exporter.selectAggregation) === null || n === void 0 ? void 0 : n.bind(r.exporter),
        aggregationTemporalitySelector: (i = r.exporter.selectAggregationTemporality) === null || i === void 0 ? void 0 : i.bind(r.exporter),
        metricProducers: r.metricProducers
      }) || this;
      if (r.exportIntervalMillis !== void 0 && r.exportIntervalMillis <= 0)
        throw Error("exportIntervalMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportTimeoutMillis <= 0)
        throw Error("exportTimeoutMillis must be greater than 0");
      if (r.exportTimeoutMillis !== void 0 && r.exportIntervalMillis !== void 0 && r.exportIntervalMillis < r.exportTimeoutMillis)
        throw Error("exportIntervalMillis must be greater than or equal to exportTimeoutMillis");
      return u._exportInterval = (o = r.exportIntervalMillis) !== null && o !== void 0 ? o : 6e4, u._exportTimeout = (a = r.exportTimeoutMillis) !== null && a !== void 0 ? a : 3e4, u._exporter = r.exporter, u;
    }
    return t.prototype._runOnce = function() {
      return ar(this, void 0, void 0, function() {
        var r;
        return sr(this, function(n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2, , 3]), [4, Ge(this._doRun(), this._exportTimeout)];
            case 1:
              return n.sent(), [3, 3];
            case 2:
              return r = n.sent(), r instanceof Pu ? (T.error("Export took longer than %s milliseconds and timed out.", this._exportTimeout), [
                2
                /*return*/
              ]) : (ga(r), [3, 3]);
            case 3:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype._doRun = function() {
      var r, n;
      return ar(this, void 0, void 0, function() {
        var i, o, a, u, c, s;
        return sr(this, function(l) {
          switch (l.label) {
            case 0:
              return [4, this.collect({
                timeoutMillis: this._exportTimeout
              })];
            case 1:
              if (i = l.sent(), o = i.resourceMetrics, a = i.errors, a.length > 0 && (s = T).error.apply(s, TE(["PeriodicExportingMetricReader: metrics collection errors"], EE(a), !1)), !o.resource.asyncAttributesPending) return [3, 5];
              l.label = 2;
            case 2:
              return l.trys.push([2, 4, , 5]), [4, (n = (r = o.resource).waitForAsyncAttributes) === null || n === void 0 ? void 0 : n.call(r)];
            case 3:
              return l.sent(), [3, 5];
            case 4:
              return u = l.sent(), T.debug("Error while resolving async portion of resource: ", u), ga(u), [3, 5];
            case 5:
              return o.scopeMetrics.length === 0 ? [
                2
                /*return*/
              ] : [4, rE._export(this._exporter, o)];
            case 6:
              if (c = l.sent(), c.code !== Pi.SUCCESS)
                throw new Error("PeriodicExportingMetricReader: metrics export failed (error " + c.error + ")");
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onInitialized = function() {
      var r = this;
      this._interval = setInterval(function() {
        r._runOnce();
      }, this._exportInterval);
    }, t.prototype.onForceFlush = function() {
      return ar(this, void 0, void 0, function() {
        return sr(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._runOnce()];
            case 1:
              return r.sent(), [4, this._exporter.forceFlush()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.onShutdown = function() {
      return ar(this, void 0, void 0, function() {
        return sr(this, function(r) {
          switch (r.label) {
            case 0:
              return this._interval && clearInterval(this._interval), [4, this.onForceFlush()];
            case 1:
              return r.sent(), [4, this._exporter.shutdown()];
            case 2:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }(_E)
), OE = (
  /** @class */
  function() {
    function e() {
      this._registeredViews = [];
    }
    return e.prototype.addView = function(t) {
      this._registeredViews.push(t);
    }, e.prototype.findViews = function(t, r) {
      var n = this, i = this._registeredViews.filter(function(o) {
        return n._matchInstrument(o.instrumentSelector, t) && n._matchMeter(o.meterSelector, r);
      });
      return i;
    }, e.prototype._matchInstrument = function(t, r) {
      return (t.getType() === void 0 || r.type === t.getType()) && t.getNameFilter().match(r.name) && t.getUnitFilter().match(r.unit);
    }, e.prototype._matchMeter = function(t, r) {
      return t.getNameFilter().match(r.name) && (r.version === void 0 || t.getVersionFilter().match(r.version)) && (r.schemaUrl === void 0 || t.getSchemaUrlFilter().match(r.schemaUrl));
    }, e;
  }()
), Xt = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), qr = (
  /** @class */
  function() {
    function e(t, r) {
      this._writableMetricStorage = t, this._descriptor = r;
    }
    return e.prototype._record = function(t, r, n) {
      if (r === void 0 && (r = {}), n === void 0 && (n = C.active()), typeof t != "number") {
        T.warn("non-number value provided to metric " + this._descriptor.name + ": " + t);
        return;
      }
      this._descriptor.valueType === Ct.INT && !Number.isInteger(t) && (T.warn("INT value type cannot accept a floating-point value for " + this._descriptor.name + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._writableMetricStorage.record(t, r, n, ro(Date.now()));
    }, e;
  }()
), SE = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n, i) {
      this._record(r, n, i);
    }, t;
  }(qr)
), wE = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.add = function(r, n, i) {
      if (r < 0) {
        T.warn("negative value provided to counter " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, t;
  }(qr)
), AE = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n, i) {
      this._record(r, n, i);
    }, t;
  }(qr)
), LE = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.record = function(r, n, i) {
      if (r < 0) {
        T.warn("negative value provided to histogram " + this._descriptor.name + ": " + r);
        return;
      }
      this._record(r, n, i);
    }, t;
  }(qr)
), Kr = (
  /** @class */
  function() {
    function e(t, r, n) {
      this._observableRegistry = n, this._descriptor = t, this._metricStorages = r;
    }
    return e.prototype.addCallback = function(t) {
      this._observableRegistry.addCallback(t, this);
    }, e.prototype.removeCallback = function(t) {
      this._observableRegistry.removeCallback(t, this);
    }, e;
  }()
), RE = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Kr)
), CE = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Kr)
), NE = (
  /** @class */
  function(e) {
    Xt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(Kr)
);
function Ii(e) {
  return e instanceof Kr;
}
var xE = (
  /** @class */
  function() {
    function e(t) {
      this._meterSharedState = t;
    }
    return e.prototype.createGauge = function(t, r) {
      var n = Tt(t, w.GAUGE, r), i = this._meterSharedState.registerMetricStorage(n);
      return new AE(i, n);
    }, e.prototype.createHistogram = function(t, r) {
      var n = Tt(t, w.HISTOGRAM, r), i = this._meterSharedState.registerMetricStorage(n);
      return new LE(i, n);
    }, e.prototype.createCounter = function(t, r) {
      var n = Tt(t, w.COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new wE(i, n);
    }, e.prototype.createUpDownCounter = function(t, r) {
      var n = Tt(t, w.UP_DOWN_COUNTER, r), i = this._meterSharedState.registerMetricStorage(n);
      return new SE(i, n);
    }, e.prototype.createObservableGauge = function(t, r) {
      var n = Tt(t, w.OBSERVABLE_GAUGE, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new CE(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableCounter = function(t, r) {
      var n = Tt(t, w.OBSERVABLE_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new RE(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.createObservableUpDownCounter = function(t, r) {
      var n = Tt(t, w.OBSERVABLE_UP_DOWN_COUNTER, r), i = this._meterSharedState.registerAsyncMetricStorage(n);
      return new NE(n, i, this._meterSharedState.observableRegistry);
    }, e.prototype.addBatchObservableCallback = function(t, r) {
      this._meterSharedState.observableRegistry.addBatchCallback(t, r);
    }, e.prototype.removeBatchObservableCallback = function(t, r) {
      this._meterSharedState.observableRegistry.removeBatchCallback(t, r);
    }, e;
  }()
), Vu = (
  /** @class */
  function() {
    function e(t) {
      this._instrumentDescriptor = t;
    }
    return e.prototype.getInstrumentDescriptor = function() {
      return this._instrumentDescriptor;
    }, e.prototype.updateDescription = function(t) {
      this._instrumentDescriptor = Tt(this._instrumentDescriptor.name, this._instrumentDescriptor.type, {
        description: t,
        valueType: this._instrumentDescriptor.valueType,
        unit: this._instrumentDescriptor.unit,
        advice: this._instrumentDescriptor.advice
      });
    }, e;
  }()
), PE = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ba = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, IE = (
  /** @class */
  function() {
    function e(t) {
      this._hash = t, this._valueMap = /* @__PURE__ */ new Map(), this._keyMap = /* @__PURE__ */ new Map();
    }
    return e.prototype.get = function(t, r) {
      return r != null || (r = this._hash(t)), this._valueMap.get(r);
    }, e.prototype.getOrDefault = function(t, r) {
      var n = this._hash(t);
      if (this._valueMap.has(n))
        return this._valueMap.get(n);
      var i = r();
      return this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, i), i;
    }, e.prototype.set = function(t, r, n) {
      n != null || (n = this._hash(t)), this._keyMap.has(n) || this._keyMap.set(n, t), this._valueMap.set(n, r);
    }, e.prototype.has = function(t, r) {
      return r != null || (r = this._hash(t)), this._valueMap.has(r);
    }, e.prototype.keys = function() {
      var t, r;
      return ba(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._keyMap.entries(), r = t.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, e.prototype.entries = function() {
      var t, r;
      return ba(this, function(n) {
        switch (n.label) {
          case 0:
            t = this._valueMap.entries(), r = t.next(), n.label = 1;
          case 1:
            return r.done === !0 ? [3, 3] : [4, [this._keyMap.get(r.value[0]), r.value[1], r.value[0]]];
          case 2:
            return n.sent(), r = t.next(), [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    }, Object.defineProperty(e.prototype, "size", {
      get: function() {
        return this._valueMap.size;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  }()
), jt = (
  /** @class */
  function(e) {
    PE(t, e);
    function t() {
      return e.call(this, xu) || this;
    }
    return t;
  }(IE)
), ME = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Gu = (
  /** @class */
  function() {
    function e(t, r) {
      this._aggregator = t, this._activeCollectionStorage = new jt(), this._cumulativeMemoStorage = new jt(), this._overflowAttributes = { "otel.metric.overflow": !0 }, this._cardinalityLimit = (r ?? 2e3) - 1, this._overflowHashCode = xu(this._overflowAttributes);
    }
    return e.prototype.record = function(t, r, n, i) {
      var o = this, a = this._activeCollectionStorage.get(r);
      if (!a) {
        if (this._activeCollectionStorage.size >= this._cardinalityLimit) {
          var u = this._activeCollectionStorage.getOrDefault(this._overflowAttributes, function() {
            return o._aggregator.createAccumulation(i);
          });
          u?.record(t);
          return;
        }
        a = this._aggregator.createAccumulation(i), this._activeCollectionStorage.set(r, a);
      }
      a?.record(t);
    }, e.prototype.batchCumulate = function(t, r) {
      var n = this;
      Array.from(t.entries()).forEach(function(i) {
        var o = ME(i, 3), a = o[0], u = o[1], c = o[2], s = n._aggregator.createAccumulation(r);
        s?.record(u);
        var l = s;
        if (n._cumulativeMemoStorage.has(a, c)) {
          var p = n._cumulativeMemoStorage.get(a, c);
          l = n._aggregator.diff(p, s);
        } else if (n._cumulativeMemoStorage.size >= n._cardinalityLimit && (a = n._overflowAttributes, c = n._overflowHashCode, n._cumulativeMemoStorage.has(a, c))) {
          var p = n._cumulativeMemoStorage.get(a, c);
          l = n._aggregator.diff(p, s);
        }
        if (n._activeCollectionStorage.has(a, c)) {
          var f = n._activeCollectionStorage.get(a, c);
          l = n._aggregator.merge(f, l);
        }
        n._cumulativeMemoStorage.set(a, s, c), n._activeCollectionStorage.set(a, l, c);
      });
    }, e.prototype.collect = function() {
      var t = this._activeCollectionStorage;
      return this._activeCollectionStorage = new jt(), t;
    }, e;
  }()
), Fn = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Oa = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Hu = (
  /** @class */
  function() {
    function e(t, r) {
      var n = this;
      this._aggregator = t, this._unreportedAccumulations = /* @__PURE__ */ new Map(), this._reportHistory = /* @__PURE__ */ new Map(), r.forEach(function(i) {
        n._unreportedAccumulations.set(i, []);
      });
    }
    return e.prototype.buildMetrics = function(t, r, n, i) {
      this._stashAccumulations(n);
      var o = this._getMergedUnreportedAccumulations(t), a = o, u;
      if (this._reportHistory.has(t)) {
        var c = this._reportHistory.get(t), s = c.collectionTime;
        u = c.aggregationTemporality, u === ut.CUMULATIVE ? a = e.merge(c.accumulations, o, this._aggregator) : a = e.calibrateStartTime(c.accumulations, o, s);
      } else
        u = t.selectAggregationTemporality(r.type);
      this._reportHistory.set(t, {
        accumulations: a,
        collectionTime: i,
        aggregationTemporality: u
      });
      var l = kE(a);
      if (l.length !== 0)
        return this._aggregator.toMetricData(
          r,
          u,
          l,
          /* endTime */
          i
        );
    }, e.prototype._stashAccumulations = function(t) {
      var r, n, i = this._unreportedAccumulations.keys();
      try {
        for (var o = Fn(i), a = o.next(); !a.done; a = o.next()) {
          var u = a.value, c = this._unreportedAccumulations.get(u);
          c === void 0 && (c = [], this._unreportedAccumulations.set(u, c)), c.push(t);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
    }, e.prototype._getMergedUnreportedAccumulations = function(t) {
      var r, n, i = new jt(), o = this._unreportedAccumulations.get(t);
      if (this._unreportedAccumulations.set(t, []), o === void 0)
        return i;
      try {
        for (var a = Fn(o), u = a.next(); !u.done; u = a.next()) {
          var c = u.value;
          i = e.merge(i, c, this._aggregator);
        }
      } catch (s) {
        r = { error: s };
      } finally {
        try {
          u && !u.done && (n = a.return) && n.call(a);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, e.merge = function(t, r, n) {
      for (var i = t, o = r.entries(), a = o.next(); a.done !== !0; ) {
        var u = Oa(a.value, 3), c = u[0], s = u[1], l = u[2];
        if (t.has(c, l)) {
          var p = t.get(c, l), f = n.merge(p, s);
          i.set(c, f, l);
        } else
          i.set(c, s, l);
        a = o.next();
      }
      return i;
    }, e.calibrateStartTime = function(t, r, n) {
      var i, o;
      try {
        for (var a = Fn(t.keys()), u = a.next(); !u.done; u = a.next()) {
          var c = Oa(u.value, 2), s = c[0], l = c[1], p = r.get(s, l);
          p?.setStartTime(n);
        }
      } catch (f) {
        i = { error: f };
      } finally {
        try {
          u && !u.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
      return r;
    }, e;
  }()
);
function kE(e) {
  return Array.from(e.entries());
}
var DE = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), UE = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, jE = (
  /** @class */
  function(e) {
    DE(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new Gu(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new Hu(n, o), u;
    }
    return t.prototype.record = function(r, n) {
      var i = this, o = new jt();
      Array.from(r.entries()).forEach(function(a) {
        var u = UE(a, 2), c = u[0], s = u[1];
        o.set(i._attributesProcessor.process(c), s);
      }), this._deltaMetricStorage.batchCumulate(o, n);
    }, t.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, t;
  }(Vu)
);
function Sa(e, t) {
  var r = "";
  return e.unit !== t.unit && (r += "	- Unit '" + e.unit + "' does not match '" + t.unit + `'
`), e.type !== t.type && (r += "	- Type '" + e.type + "' does not match '" + t.type + `'
`), e.valueType !== t.valueType && (r += "	- Value Type '" + e.valueType + "' does not match '" + t.valueType + `'
`), e.description !== t.description && (r += "	- Description '" + e.description + "' does not match '" + t.description + `'
`), r;
}
function $E(e, t) {
  return "	- use valueType '" + e.valueType + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function BE(e, t) {
  return "	- use unit '" + e.unit + "' on instrument creation or use an instrument name other than '" + t.name + "'";
}
function FE(e, t) {
  var r = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + n + "'";
}
function VE(e, t) {
  var r = {
    name: t.name,
    type: t.type,
    unit: t.unit
  }, n = JSON.stringify(r);
  return "	- create a new view with a name other than '" + e.name + "' and InstrumentSelector '" + n + `'
    	- OR - create a new view with the name ` + e.name + " and description '" + e.description + "' and InstrumentSelector " + n + `
    	- OR - create a new view with the name ` + t.name + " and description '" + e.description + "' and InstrumentSelector " + n;
}
function wa(e, t) {
  return e.valueType !== t.valueType ? $E(e, t) : e.unit !== t.unit ? BE(e, t) : e.type !== t.type ? FE(e, t) : e.description !== t.description ? VE(e, t) : "";
}
var Vn = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, GE = (
  /** @class */
  function() {
    function e() {
      this._sharedRegistry = /* @__PURE__ */ new Map(), this._perCollectorRegistry = /* @__PURE__ */ new Map();
    }
    return e.create = function() {
      return new e();
    }, e.prototype.getStorages = function(t) {
      var r, n, i, o, a = [];
      try {
        for (var u = Vn(this._sharedRegistry.values()), c = u.next(); !c.done; c = u.next()) {
          var s = c.value;
          a = a.concat(s);
        }
      } catch (m) {
        r = { error: m };
      } finally {
        try {
          c && !c.done && (n = u.return) && n.call(u);
        } finally {
          if (r) throw r.error;
        }
      }
      var l = this._perCollectorRegistry.get(t);
      if (l != null)
        try {
          for (var p = Vn(l.values()), f = p.next(); !f.done; f = p.next()) {
            var s = f.value;
            a = a.concat(s);
          }
        } catch (m) {
          i = { error: m };
        } finally {
          try {
            f && !f.done && (o = p.return) && o.call(p);
          } finally {
            if (i) throw i.error;
          }
        }
      return a;
    }, e.prototype.register = function(t) {
      this._registerStorage(t, this._sharedRegistry);
    }, e.prototype.registerForCollector = function(t, r) {
      var n = this._perCollectorRegistry.get(t);
      n == null && (n = /* @__PURE__ */ new Map(), this._perCollectorRegistry.set(t, n)), this._registerStorage(r, n);
    }, e.prototype.findOrUpdateCompatibleStorage = function(t) {
      var r = this._sharedRegistry.get(t.name);
      return r === void 0 ? null : this._findOrUpdateCompatibleStorage(t, r);
    }, e.prototype.findOrUpdateCompatibleCollectorStorage = function(t, r) {
      var n = this._perCollectorRegistry.get(t);
      if (n === void 0)
        return null;
      var i = n.get(r.name);
      return i === void 0 ? null : this._findOrUpdateCompatibleStorage(r, i);
    }, e.prototype._registerStorage = function(t, r) {
      var n = t.getInstrumentDescriptor(), i = r.get(n.name);
      if (i === void 0) {
        r.set(n.name, [t]);
        return;
      }
      i.push(t);
    }, e.prototype._findOrUpdateCompatibleStorage = function(t, r) {
      var n, i, o = null;
      try {
        for (var a = Vn(r), u = a.next(); !u.done; u = a.next()) {
          var c = u.value, s = c.getInstrumentDescriptor();
          Rg(s, t) ? (s.description !== t.description && (t.description.length > s.description.length && c.updateDescription(t.description), T.warn("A view or instrument with the name ", t.name, ` has already been registered, but has a different description and is incompatible with another registered view.
`, `Details:
`, Sa(s, t), `The longer description will be used.
To resolve the conflict:`, wa(s, t))), o = c) : T.warn("A view or instrument with the name ", t.name, ` has already been registered and is incompatible with another registered view.
`, `Details:
`, Sa(s, t), `To resolve the conflict:
`, wa(s, t));
        }
      } catch (l) {
        n = { error: l };
      } finally {
        try {
          u && !u.done && (i = a.return) && i.call(a);
        } finally {
          if (n) throw n.error;
        }
      }
      return o;
    }, e;
  }()
), HE = (
  /** @class */
  function() {
    function e(t) {
      this._backingStorages = t;
    }
    return e.prototype.record = function(t, r, n, i) {
      this._backingStorages.forEach(function(o) {
        o.record(t, r, n, i);
      });
    }, e;
  }()
), zE = (
  /** @class */
  function() {
    function e(t, r) {
      this._instrumentName = t, this._valueType = r, this._buffer = new jt();
    }
    return e.prototype.observe = function(t, r) {
      if (r === void 0 && (r = {}), typeof t != "number") {
        T.warn("non-number value provided to metric " + this._instrumentName + ": " + t);
        return;
      }
      this._valueType === Ct.INT && !Number.isInteger(t) && (T.warn("INT value type cannot accept a floating-point value for " + this._instrumentName + ", ignoring the fractional digits."), t = Math.trunc(t), !Number.isInteger(t)) || this._buffer.set(r, t);
    }, e;
  }()
), XE = (
  /** @class */
  function() {
    function e() {
      this._buffer = /* @__PURE__ */ new Map();
    }
    return e.prototype.observe = function(t, r, n) {
      if (n === void 0 && (n = {}), !!Ii(t)) {
        var i = this._buffer.get(t);
        if (i == null && (i = new jt(), this._buffer.set(t, i)), typeof r != "number") {
          T.warn("non-number value provided to metric " + t._descriptor.name + ": " + r);
          return;
        }
        t._descriptor.valueType === Ct.INT && !Number.isInteger(r) && (T.warn("INT value type cannot accept a floating-point value for " + t._descriptor.name + ", ignoring the fractional digits."), r = Math.trunc(r), !Number.isInteger(r)) || i.set(n, r);
      }
    }, e;
  }()
), Gn = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (p) {
        a(p);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (p) {
        a(p);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, [])).next());
  });
}, Hn = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Aa = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, La = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, qE = (
  /** @class */
  function() {
    function e() {
      this._callbacks = [], this._batchCallbacks = [];
    }
    return e.prototype.addCallback = function(t, r) {
      var n = this._findCallback(t, r);
      n >= 0 || this._callbacks.push({ callback: t, instrument: r });
    }, e.prototype.removeCallback = function(t, r) {
      var n = this._findCallback(t, r);
      n < 0 || this._callbacks.splice(n, 1);
    }, e.prototype.addBatchCallback = function(t, r) {
      var n = new Set(r.filter(Ii));
      if (n.size === 0) {
        T.error("BatchObservableCallback is not associated with valid instruments", r);
        return;
      }
      var i = this._findBatchCallback(t, n);
      i >= 0 || this._batchCallbacks.push({ callback: t, instruments: n });
    }, e.prototype.removeBatchCallback = function(t, r) {
      var n = new Set(r.filter(Ii)), i = this._findBatchCallback(t, n);
      i < 0 || this._batchCallbacks.splice(i, 1);
    }, e.prototype.observe = function(t, r) {
      return Gn(this, void 0, void 0, function() {
        var n, i, o, a;
        return Hn(this, function(u) {
          switch (u.label) {
            case 0:
              return n = this._observeCallbacks(t, r), i = this._observeBatchCallbacks(t, r), [4, Tg(La(La([], Aa(n), !1), Aa(i), !1))];
            case 1:
              return o = u.sent(), a = o.filter(bg).map(function(c) {
                return c.reason;
              }), [2, a];
          }
        });
      });
    }, e.prototype._observeCallbacks = function(t, r) {
      var n = this;
      return this._callbacks.map(function(i) {
        var o = i.callback, a = i.instrument;
        return Gn(n, void 0, void 0, function() {
          var u, c;
          return Hn(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new zE(a._descriptor.name, a._descriptor.valueType), c = Promise.resolve(o(u)), r != null && (c = Ge(c, r)), [4, c];
              case 1:
                return s.sent(), a._metricStorages.forEach(function(l) {
                  l.record(u._buffer, t);
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._observeBatchCallbacks = function(t, r) {
      var n = this;
      return this._batchCallbacks.map(function(i) {
        var o = i.callback, a = i.instruments;
        return Gn(n, void 0, void 0, function() {
          var u, c;
          return Hn(this, function(s) {
            switch (s.label) {
              case 0:
                return u = new XE(), c = Promise.resolve(o(u)), r != null && (c = Ge(c, r)), [4, c];
              case 1:
                return s.sent(), a.forEach(function(l) {
                  var p = u._buffer.get(l);
                  p != null && l._metricStorages.forEach(function(f) {
                    f.record(p, t);
                  });
                }), [
                  2
                  /*return*/
                ];
            }
          });
        });
      });
    }, e.prototype._findCallback = function(t, r) {
      return this._callbacks.findIndex(function(n) {
        return n.callback === t && n.instrument === r;
      });
    }, e.prototype._findBatchCallback = function(t, r) {
      return this._batchCallbacks.findIndex(function(n) {
        return n.callback === t && Og(n.instruments, r);
      });
    }, e;
  }()
), KE = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), WE = (
  /** @class */
  function(e) {
    KE(t, e);
    function t(r, n, i, o, a) {
      var u = e.call(this, r) || this;
      return u._attributesProcessor = i, u._aggregationCardinalityLimit = a, u._deltaMetricStorage = new Gu(n, u._aggregationCardinalityLimit), u._temporalMetricStorage = new Hu(n, o), u;
    }
    return t.prototype.record = function(r, n, i, o) {
      n = this._attributesProcessor.process(n, i), this._deltaMetricStorage.record(r, n, i, o);
    }, t.prototype.collect = function(r, n) {
      var i = this._deltaMetricStorage.collect();
      return this._temporalMetricStorage.buildMetrics(r, this._instrumentDescriptor, i, n);
    }, t;
  }(Vu)
), zu = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), no = (
  /** @class */
  function() {
    function e() {
    }
    return e.Noop = function() {
      return JE;
    }, e;
  }()
), YE = (
  /** @class */
  function(e) {
    zu(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.process = function(r, n) {
      return r;
    }, t;
  }(no)
);
(function(e) {
  zu(t, e);
  function t(r) {
    var n = e.call(this) || this;
    return n._allowedAttributeNames = r, n;
  }
  return t.prototype.process = function(r, n) {
    var i = this, o = {};
    return Object.keys(r).filter(function(a) {
      return i._allowedAttributeNames.includes(a);
    }).forEach(function(a) {
      return o[a] = r[a];
    }), o;
  }, t;
})(no);
var JE = new YE(), QE = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (p) {
        a(p);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (p) {
        a(p);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, [])).next());
  });
}, ZE = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, tT = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, eT = (
  /** @class */
  function() {
    function e(t, r) {
      this._meterProviderSharedState = t, this._instrumentationScope = r, this.metricStorageRegistry = new GE(), this.observableRegistry = new qE(), this.meter = new xE(this);
    }
    return e.prototype.registerMetricStorage = function(t) {
      var r = this._registerMetricStorage(t, WE);
      return r.length === 1 ? r[0] : new HE(r);
    }, e.prototype.registerAsyncMetricStorage = function(t) {
      var r = this._registerMetricStorage(t, jE);
      return r;
    }, e.prototype.collect = function(t, r, n) {
      return QE(this, void 0, void 0, function() {
        var i, o, a;
        return ZE(this, function(u) {
          switch (u.label) {
            case 0:
              return [4, this.observableRegistry.observe(r, n?.timeoutMillis)];
            case 1:
              return i = u.sent(), o = this.metricStorageRegistry.getStorages(t), o.length === 0 ? [2, null] : (a = o.map(function(c) {
                return c.collect(t, r);
              }).filter(gg), a.length === 0 ? [2, { errors: i }] : [2, {
                scopeMetrics: {
                  scope: this._instrumentationScope,
                  metrics: a
                },
                errors: i
              }]);
          }
        });
      });
    }, e.prototype._registerMetricStorage = function(t, r) {
      var n = this, i = this._meterProviderSharedState.viewRegistry.findViews(t, this._instrumentationScope), o = i.map(function(c) {
        var s = Lg(c, t), l = n.metricStorageRegistry.findOrUpdateCompatibleStorage(s);
        if (l != null)
          return l;
        var p = c.aggregation.createAggregator(s), f = new r(s, p, c.attributesProcessor, n._meterProviderSharedState.metricCollectors, c.aggregationCardinalityLimit);
        return n.metricStorageRegistry.register(f), f;
      });
      if (o.length === 0) {
        var a = this._meterProviderSharedState.selectAggregations(t.type), u = a.map(function(c) {
          var s = tT(c, 2), l = s[0], p = s[1], f = n.metricStorageRegistry.findOrUpdateCompatibleCollectorStorage(l, t);
          if (f != null)
            return f;
          var m = p.createAggregator(t), v = l.selectCardinalityLimit(t.type), y = new r(t, m, no.Noop(), [l], v);
          return n.metricStorageRegistry.registerForCollector(l, y), y;
        });
        o = o.concat(u);
      }
      return o;
    }, e;
  }()
), rT = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, nT = (
  /** @class */
  function() {
    function e(t) {
      this.resource = t, this.viewRegistry = new OE(), this.metricCollectors = [], this.meterSharedStates = /* @__PURE__ */ new Map();
    }
    return e.prototype.getMeterSharedState = function(t) {
      var r = Eg(t), n = this.meterSharedStates.get(r);
      return n == null && (n = new eT(this, t), this.meterSharedStates.set(r, n)), n;
    }, e.prototype.selectAggregations = function(t) {
      var r, n, i = [];
      try {
        for (var o = rT(this.metricCollectors), a = o.next(); !a.done; a = o.next()) {
          var u = a.value;
          i.push([u, u.selectAggregation(t)]);
        }
      } catch (c) {
        r = { error: c };
      } finally {
        try {
          a && !a.done && (n = o.return) && n.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
      return i;
    }, e;
  }()
), ur = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (p) {
        a(p);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (p) {
        a(p);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, [])).next());
  });
}, cr = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, iT = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, oT = function(e, t, r) {
  if (arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, aT = (
  /** @class */
  function() {
    function e(t, r) {
      this._sharedState = t, this._metricReader = r;
    }
    return e.prototype.collect = function(t) {
      return ur(this, void 0, void 0, function() {
        var r, n, i, o, a = this;
        return cr(this, function(u) {
          switch (u.label) {
            case 0:
              return r = ro(Date.now()), n = [], i = [], o = Array.from(this._sharedState.meterSharedStates.values()).map(function(c) {
                return ur(a, void 0, void 0, function() {
                  var s;
                  return cr(this, function(l) {
                    switch (l.label) {
                      case 0:
                        return [4, c.collect(this, r, t)];
                      case 1:
                        return s = l.sent(), s?.scopeMetrics != null && n.push(s.scopeMetrics), s?.errors != null && i.push.apply(i, oT([], iT(s.errors), !1)), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              }), [4, Promise.all(o)];
            case 1:
              return u.sent(), [2, {
                resourceMetrics: {
                  resource: this._sharedState.resource,
                  scopeMetrics: n
                },
                errors: i
              }];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return ur(this, void 0, void 0, function() {
        return cr(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.forceFlush(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.shutdown = function(t) {
      return ur(this, void 0, void 0, function() {
        return cr(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this._metricReader.shutdown(t)];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.selectAggregationTemporality = function(t) {
      return this._metricReader.selectAggregationTemporality(t);
    }, e.prototype.selectAggregation = function(t) {
      return this._metricReader.selectAggregation(t);
    }, e.prototype.selectCardinalityLimit = function(t) {
      var r, n, i;
      return (i = (n = (r = this._metricReader).selectCardinalityLimit) === null || n === void 0 ? void 0 : n.call(r, t)) !== null && i !== void 0 ? i : 2e3;
    }, e;
  }()
), Ra = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (p) {
        a(p);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (p) {
        a(p);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, [])).next());
  });
}, Ca = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, Na = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function sT(e, t) {
  var r = t ?? Fe.empty();
  return e ? Fe.default().merge(r) : r;
}
var uT = (
  /** @class */
  function() {
    function e(t) {
      var r, n, i, o, a;
      if (this._shutdown = !1, this._sharedState = new nT(sT((a = t?.mergeResourceWithDefaults) !== null && a !== void 0 ? a : !0, t?.resource)), t?.views != null && t.views.length > 0)
        try {
          for (var u = Na(t.views), c = u.next(); !c.done; c = u.next()) {
            var s = c.value;
            this._sharedState.viewRegistry.addView(s);
          }
        } catch (m) {
          r = { error: m };
        } finally {
          try {
            c && !c.done && (n = u.return) && n.call(u);
          } finally {
            if (r) throw r.error;
          }
        }
      if (t?.readers != null && t.readers.length > 0)
        try {
          for (var l = Na(t.readers), p = l.next(); !p.done; p = l.next()) {
            var f = p.value;
            this.addMetricReader(f);
          }
        } catch (m) {
          i = { error: m };
        } finally {
          try {
            p && !p.done && (o = l.return) && o.call(l);
          } finally {
            if (i) throw i.error;
          }
        }
    }
    return e.prototype.getMeter = function(t, r, n) {
      return r === void 0 && (r = ""), n === void 0 && (n = {}), this._shutdown ? (T.warn("A shutdown MeterProvider cannot provide a Meter"), Mf()) : this._sharedState.getMeterSharedState({
        name: t,
        version: r,
        schemaUrl: n.schemaUrl
      }).meter;
    }, e.prototype.addMetricReader = function(t) {
      var r = new aT(this._sharedState, t);
      t.setMetricProducer(r), this._sharedState.metricCollectors.push(r);
    }, e.prototype.shutdown = function(t) {
      return Ra(this, void 0, void 0, function() {
        return Ca(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (T.warn("shutdown may only be called once per MeterProvider"), [
                2
                /*return*/
              ]) : (this._shutdown = !0, [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.shutdown(t);
              }))]);
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.forceFlush = function(t) {
      return Ra(this, void 0, void 0, function() {
        return Ca(this, function(r) {
          switch (r.label) {
            case 0:
              return this._shutdown ? (T.warn("invalid attempt to force flush after MeterProvider shutdown"), [
                2
                /*return*/
              ]) : [4, Promise.all(this._sharedState.metricCollectors.map(function(n) {
                return n.forceFlush(t);
              }))];
            case 1:
              return r.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function cT(e, t) {
  var r = Au(t);
  return {
    resource: Lu(e.resource),
    schemaUrl: void 0,
    scopeMetrics: lT(e.scopeMetrics, r)
  };
}
function lT(e, t) {
  return Array.from(e.map(function(r) {
    return {
      scope: Ru(r.scope),
      metrics: r.metrics.map(function(n) {
        return pT(n, t);
      }),
      schemaUrl: r.scope.schemaUrl
    };
  }));
}
function pT(e, t) {
  var r = {
    name: e.descriptor.name,
    description: e.descriptor.description,
    unit: e.descriptor.unit
  }, n = vT(e.aggregationTemporality);
  switch (e.dataPointType) {
    case ft.SUM:
      r.sum = {
        aggregationTemporality: n,
        isMonotonic: e.isMonotonic,
        dataPoints: xa(e, t)
      };
      break;
    case ft.GAUGE:
      r.gauge = {
        dataPoints: xa(e, t)
      };
      break;
    case ft.HISTOGRAM:
      r.histogram = {
        aggregationTemporality: n,
        dataPoints: hT(e, t)
      };
      break;
    case ft.EXPONENTIAL_HISTOGRAM:
      r.exponentialHistogram = {
        aggregationTemporality: n,
        dataPoints: dT(e, t)
      };
      break;
  }
  return r;
}
function fT(e, t, r) {
  var n = {
    attributes: Ht(e.attributes),
    startTimeUnixNano: r.encodeHrTime(e.startTime),
    timeUnixNano: r.encodeHrTime(e.endTime)
  };
  switch (t) {
    case Ct.INT:
      n.asInt = e.value;
      break;
    case Ct.DOUBLE:
      n.asDouble = e.value;
      break;
  }
  return n;
}
function xa(e, t) {
  return e.dataPoints.map(function(r) {
    return fT(r, e.descriptor.valueType, t);
  });
}
function hT(e, t) {
  return e.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: Ht(r.attributes),
      bucketCounts: n.buckets.counts,
      explicitBounds: n.buckets.boundaries,
      count: n.count,
      sum: n.sum,
      min: n.min,
      max: n.max,
      startTimeUnixNano: t.encodeHrTime(r.startTime),
      timeUnixNano: t.encodeHrTime(r.endTime)
    };
  });
}
function dT(e, t) {
  return e.dataPoints.map(function(r) {
    var n = r.value;
    return {
      attributes: Ht(r.attributes),
      count: n.count,
      min: n.min,
      max: n.max,
      sum: n.sum,
      positive: {
        offset: n.positive.offset,
        bucketCounts: n.positive.bucketCounts
      },
      negative: {
        offset: n.negative.offset,
        bucketCounts: n.negative.bucketCounts
      },
      scale: n.scale,
      zeroCount: n.zeroCount,
      startTimeUnixNano: t.encodeHrTime(r.startTime),
      timeUnixNano: t.encodeHrTime(r.endTime)
    };
  });
}
function vT(e) {
  switch (e) {
    case ut.DELTA:
      return 1;
    case ut.CUMULATIVE:
      return 2;
  }
}
function mT(e, t) {
  return {
    resourceMetrics: e.map(function(r) {
      return cT(r, t);
    })
  };
}
var yT = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, _T = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function gT(e, t) {
  var r, n = e.spanContext(), i = e.status;
  return {
    traceId: t.encodeSpanContext(n.traceId),
    spanId: t.encodeSpanContext(n.spanId),
    parentSpanId: t.encodeOptionalSpanContext(e.parentSpanId),
    traceState: (r = n.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    name: e.name,
    // Span kind is offset by 1 because the API does not define a value for unset
    kind: e.kind == null ? 0 : e.kind + 1,
    startTimeUnixNano: t.encodeHrTime(e.startTime),
    endTimeUnixNano: t.encodeHrTime(e.endTime),
    attributes: Ht(e.attributes),
    droppedAttributesCount: e.droppedAttributesCount,
    events: e.events.map(function(o) {
      return TT(o, t);
    }),
    droppedEventsCount: e.droppedEventsCount,
    status: {
      // API and proto enums share the same values
      code: i.code,
      message: i.message
    },
    links: e.links.map(function(o) {
      return ET(o, t);
    }),
    droppedLinksCount: e.droppedLinksCount
  };
}
function ET(e, t) {
  var r;
  return {
    attributes: e.attributes ? Ht(e.attributes) : [],
    spanId: t.encodeSpanContext(e.context.spanId),
    traceId: t.encodeSpanContext(e.context.traceId),
    traceState: (r = e.context.traceState) === null || r === void 0 ? void 0 : r.serialize(),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function TT(e, t) {
  return {
    attributes: e.attributes ? Ht(e.attributes) : [],
    name: e.name,
    timeUnixNano: t.encodeHrTime(e.time),
    droppedAttributesCount: e.droppedAttributesCount || 0
  };
}
function bT(e, t) {
  var r = Au(t);
  return {
    resourceSpans: ST(e, r)
  };
}
function OT(e) {
  var t, r, n = /* @__PURE__ */ new Map();
  try {
    for (var i = yT(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value, u = n.get(a.resource);
      u || (u = /* @__PURE__ */ new Map(), n.set(a.resource, u));
      var c = a.instrumentationLibrary.name + "@" + (a.instrumentationLibrary.version || "") + ":" + (a.instrumentationLibrary.schemaUrl || ""), s = u.get(c);
      s || (s = [], u.set(c, s)), s.push(a);
    }
  } catch (l) {
    t = { error: l };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function ST(e, t) {
  for (var r = OT(e), n = [], i = r.entries(), o = i.next(); !o.done; ) {
    for (var a = _T(o.value, 2), u = a[0], c = a[1], s = [], l = c.values(), p = l.next(); !p.done; ) {
      var f = p.value;
      if (f.length > 0) {
        var m = f.map(function(y) {
          return gT(y, t);
        });
        s.push({
          scope: Ru(f[0].instrumentationLibrary),
          spans: m,
          schemaUrl: f[0].instrumentationLibrary.schemaUrl
        });
      }
      p = l.next();
    }
    var v = {
      resource: Lu(u),
      scopeSpans: s,
      schemaUrl: void 0
    };
    n.push(v), o = i.next();
  }
  return n;
}
var wT = {
  serializeRequest: function(e) {
    var t = mT([e], {
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, AT = {
  serializeRequest: function(e) {
    var t = bT(e, {
      useHex: !0,
      useLongBits: !1
    }), r = new TextEncoder();
    return r.encode(JSON.stringify(t));
  },
  deserializeResponse: function(e) {
    var t = new TextDecoder();
    return JSON.parse(t.decode(e));
  }
}, LT = function(e, t, r, n) {
  function i(o) {
    return o instanceof r ? o : new r(function(a) {
      a(o);
    });
  }
  return new (r || (r = Promise))(function(o, a) {
    function u(l) {
      try {
        s(n.next(l));
      } catch (p) {
        a(p);
      }
    }
    function c(l) {
      try {
        s(n.throw(l));
      } catch (p) {
        a(p);
      }
    }
    function s(l) {
      l.done ? o(l.value) : i(l.value).then(u, c);
    }
    s((n = n.apply(e, [])).next());
  });
}, RT = function(e, t) {
  var r = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, n, i, o, a;
  return a = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function u(s) {
    return function(l) {
      return c([s, l]);
    };
  }
  function c(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, i && (o = s[0] & 2 ? i.return : s[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, s[1])).done) return o;
      switch (i = 0, o && (s = [s[0] & 2, o.value]), s[0]) {
        case 0:
        case 1:
          o = s;
          break;
        case 4:
          return r.label++, { value: s[1], done: !1 };
        case 5:
          r.label++, i = s[1], s = [0];
          continue;
        case 7:
          s = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            r = 0;
            continue;
          }
          if (s[0] === 3 && (!o || s[1] > o[0] && s[1] < o[3])) {
            r.label = s[1];
            break;
          }
          if (s[0] === 6 && r.label < o[1]) {
            r.label = o[1], o = s;
            break;
          }
          if (o && r.label < o[2]) {
            r.label = o[2], r.ops.push(s);
            break;
          }
          o[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      s = t.call(e, r);
    } catch (l) {
      s = [6, l], i = 0;
    } finally {
      n = o = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, CT = 5, NT = 1e3, xT = 5e3, PT = 1.5, Pa = 0.2;
function IT() {
  return Math.random() * (2 * Pa) - Pa;
}
var MT = (
  /** @class */
  function() {
    function e(t) {
      this._transport = t;
    }
    return e.prototype.retry = function(t, r, n) {
      var i = this;
      return new Promise(function(o, a) {
        setTimeout(function() {
          i._transport.send(t, r).then(o, a);
        }, n);
      });
    }, e.prototype.send = function(t, r) {
      var n;
      return LT(this, void 0, void 0, function() {
        var i, o, a, u, c, s, l;
        return RT(this, function(p) {
          switch (p.label) {
            case 0:
              return i = Date.now() + r, [4, this._transport.send(t, r)];
            case 1:
              o = p.sent(), a = CT, u = NT, p.label = 2;
            case 2:
              return o.status === "retryable" && a > 0 ? (a--, c = Math.max(Math.min(u, xT) + IT(), 0), u = u * PT, s = (n = o.retryInMillis) !== null && n !== void 0 ? n : c, l = i - Date.now(), s > l ? [2, o] : [4, this.retry(t, l, s)]) : [3, 4];
            case 3:
              return o = p.sent(), [3, 2];
            case 4:
              return [2, o];
          }
        });
      });
    }, e.prototype.shutdown = function() {
      return this._transport.shutdown();
    }, e;
  }()
);
function Xu(e) {
  return new MT(e.transport);
}
function kT(e) {
  var t = [429, 502, 503, 504];
  return t.includes(e);
}
function DT(e) {
  if (e != null) {
    var t = Number.parseInt(e, 10);
    if (Number.isInteger(t))
      return t > 0 ? t * 1e3 : -1;
    var r = new Date(e).getTime() - Date.now();
    return r >= 0 ? r : 0;
  }
}
var UT = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, jT = (
  /** @class */
  function() {
    function e(t) {
      this._parameters = t;
    }
    return e.prototype.send = function(t, r) {
      var n = this;
      return new Promise(function(i) {
        var o = new XMLHttpRequest();
        o.timeout = r, o.open("POST", n._parameters.url);
        var a = n._parameters.headers();
        Object.entries(a).forEach(function(u) {
          var c = UT(u, 2), s = c[0], l = c[1];
          o.setRequestHeader(s, l);
        }), o.ontimeout = function(u) {
          i({
            status: "failure",
            error: new Error("XHR request timed out")
          });
        }, o.onreadystatechange = function() {
          o.status >= 200 && o.status <= 299 ? (T.debug("XHR success"), i({
            status: "success"
          })) : o.status && kT(o.status) ? i({
            status: "retryable",
            retryInMillis: DT(o.getResponseHeader("Retry-After"))
          }) : o.status !== 0 && i({
            status: "failure",
            error: new Error("XHR request failed with non-retryable status")
          });
        }, o.onabort = function() {
          i({
            status: "failure",
            error: new Error("XHR request aborted")
          });
        }, o.onerror = function() {
          i({
            status: "failure",
            error: new Error("XHR request errored")
          });
        }, o.send(t);
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function $T(e) {
  return new jT(e);
}
var BT = (
  /** @class */
  function() {
    function e(t) {
      this._params = t;
    }
    return e.prototype.send = function(t) {
      var r = this;
      return new Promise(function(n) {
        navigator.sendBeacon(r._params.url, new Blob([t], { type: r._params.blobType })) ? (T.debug("SendBeacon success"), n({
          status: "success"
        })) : n({
          status: "failure",
          error: new Error("SendBeacon failed")
        });
      });
    }, e.prototype.shutdown = function() {
    }, e;
  }()
);
function FT(e) {
  return new BT(e);
}
function VT(e, t) {
  return bu(e, t, Xu({
    transport: $T(e)
  }));
}
function GT(e, t) {
  return bu(e, t, Xu({
    transport: FT({
      url: e.url,
      blobType: e.headers()["Content-Type"]
    })
  }));
}
var HT = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function zT(e) {
  return function() {
    var t, r = {};
    return Object.entries((t = e?.()) !== null && t !== void 0 ? t : {}).forEach(function(n) {
      var i = HT(n, 2), o = i[0], a = i[1];
      typeof a < "u" ? r[o] = String(a) : T.warn('Header "' + o + '" has invalid value (' + a + ") and will be ignored");
    }), r;
  };
}
var Vt = function() {
  return Vt = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Vt.apply(this, arguments);
};
function XT(e, t, r) {
  var n = Vt({}, r()), i = {};
  return function() {
    return t != null && Object.assign(i, t()), e != null && Object.assign(i, e()), Object.assign(i, n);
  };
}
function qT(e) {
  if (e != null)
    try {
      return new URL(e), e;
    } catch {
      throw new Error("Configuration: Could not parse user-provided export URL: '" + e + "'");
    }
}
function KT(e, t, r) {
  var n, i, o, a;
  return Vt(Vt({}, W_(e, t, r)), { headers: XT(zT(e.headers), t.headers, r.headers), url: (i = (n = qT(e.url)) !== null && n !== void 0 ? n : t.url) !== null && i !== void 0 ? i : r.url, agentOptions: (a = (o = e.agentOptions) !== null && o !== void 0 ? o : t.agentOptions) !== null && a !== void 0 ? a : r.agentOptions });
}
function WT(e, t) {
  return Vt(Vt({}, Y_()), { headers: function() {
    return e;
  }, url: "http://localhost:4318/" + t, agentOptions: { keepAlive: !0 } });
}
function YT(e, t, r) {
  return KT(
    {
      url: e.url,
      timeoutMillis: e.timeoutMillis,
      headers: K_(e.headers),
      concurrencyLimit: e.concurrencyLimit
    },
    {},
    // no fallback for browser case
    WT(r, t)
  );
}
function qu(e, t, r, n) {
  var i = !!e.headers || typeof navigator.sendBeacon != "function", o = YT(e, r, n);
  return i ? VT(o, t) : GT(o, t);
}
var JT = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), QT = (
  /** @class */
  function(e) {
    JT(t, e);
    function t(r) {
      return r === void 0 && (r = {}), e.call(this, qu(r, AT, "v1/traces", { "Content-Type": "application/json" })) || this;
    }
    return t;
  }(Tu)
), Dr;
(function(e) {
  e[e.DELTA = 0] = "DELTA", e[e.CUMULATIVE = 1] = "CUMULATIVE", e[e.LOWMEMORY = 2] = "LOWMEMORY";
})(Dr || (Dr = {}));
var ZT = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), Mi = function() {
  return ut.CUMULATIVE;
}, Ku = function(e) {
  switch (e) {
    case w.COUNTER:
    case w.OBSERVABLE_COUNTER:
    case w.GAUGE:
    case w.HISTOGRAM:
    case w.OBSERVABLE_GAUGE:
      return ut.DELTA;
    case w.UP_DOWN_COUNTER:
    case w.OBSERVABLE_UP_DOWN_COUNTER:
      return ut.CUMULATIVE;
  }
}, Wu = function(e) {
  switch (e) {
    case w.COUNTER:
    case w.HISTOGRAM:
      return ut.DELTA;
    case w.GAUGE:
    case w.UP_DOWN_COUNTER:
    case w.OBSERVABLE_UP_DOWN_COUNTER:
    case w.OBSERVABLE_COUNTER:
    case w.OBSERVABLE_GAUGE:
      return ut.CUMULATIVE;
  }
};
function tb() {
  var e = Uh(), t = e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE.trim().toLowerCase();
  return t === "cumulative" ? Mi : t === "delta" ? Ku : t === "lowmemory" ? Wu : (T.warn("OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE is set to '" + e.OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE + "', but only 'cumulative' and 'delta' are allowed. Using default ('cumulative') instead."), Mi);
}
function eb(e) {
  return e != null ? e === Dr.DELTA ? Ku : e === Dr.LOWMEMORY ? Wu : Mi : tb();
}
function rb(e) {
  return e != null && e.aggregationPreference ? e.aggregationPreference : function(t) {
    return Et.Default();
  };
}
var nb = (
  /** @class */
  function(e) {
    ZT(t, e);
    function t(r, n) {
      var i = e.call(this, r) || this;
      return i._aggregationSelector = rb(n), i._aggregationTemporalitySelector = eb(n?.temporalityPreference), i;
    }
    return t.prototype.selectAggregation = function(r) {
      return this._aggregationSelector(r);
    }, t.prototype.selectAggregationTemporality = function(r) {
      return this._aggregationTemporalitySelector(r);
    }, t;
  }(Tu)
), ib = /* @__PURE__ */ function() {
  var e = function(t, r) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, e(t, r);
  };
  return function(t, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    e(t, r);
    function n() {
      this.constructor = t;
    }
    t.prototype = r === null ? Object.create(r) : (n.prototype = r.prototype, new n());
  };
}(), ob = (
  /** @class */
  function(e) {
    ib(t, e);
    function t(r) {
      return e.call(this, qu(r ?? {}, wT, "v1/metrics", { "Content-Type": "application/json" }), r) || this;
    }
    return t;
  }(nb)
);
function ab(e, t) {
  const r = e.spanContext();
  return {
    name: e.name,
    kind: e.kind,
    spanContext: () => r,
    parentSpanId: e.parentSpanId,
    startTime: e.startTime,
    endTime: e.endTime,
    status: e.status,
    attributes: Td(e.attributes, t),
    links: e.links,
    events: e.events,
    duration: e.duration,
    ended: e.ended,
    resource: e.resource,
    instrumentationLibrary: e.instrumentationLibrary,
    droppedAttributesCount: e.droppedAttributesCount,
    droppedEventsCount: e.droppedEventsCount,
    droppedLinksCount: e.droppedLinksCount
  };
}
function sb(e, t) {
  if (!t.isSamplingEnabled())
    return e;
  const r = [], n = {}, i = {};
  for (const o of e) {
    o.parentSpanId && (i[o.parentSpanId] = i[o.parentSpanId] || [], i[o.parentSpanId].push(
      o.spanContext().spanId
    ));
    const a = t.shouldSample(o);
    a.sample ? a.attributes ? n[o.spanContext().spanId] = ab(
      o,
      a.attributes
    ) : n[o.spanContext().spanId] = o : r.push(o.spanContext().spanId);
  }
  for (; r.length > 0; ) {
    const o = r.shift(), a = i[o];
    if (a)
      for (const u of a)
        delete n[u], r.push(u);
  }
  return Object.values(n);
}
class ub extends QT {
  constructor(t, r) {
    super(et(M({}, t), {
      headers: {}
      // a truthy value enables sending with XHR instead of beacon
    })), this.sampler = r;
  }
  export(t, r) {
    const n = sb(t, this.sampler);
    if (n.length === 0)
      return;
    let i = 0;
    const o = (a) => {
      if (a.code === J.SUCCESS)
        return r({
          code: J.SUCCESS
        });
      if (i++, i > Gi)
        return r({
          code: J.FAILED,
          error: a.error
        });
      new Promise(
        (u) => setTimeout(
          u,
          Hi + zi * Math.pow(2, i)
        )
      ).then(() => {
        super.export(n, o);
      });
    };
    super.export(n, o);
  }
}
class cb extends ob {
  constructor(t) {
    super(et(M({}, t), {
      headers: {}
    }));
  }
  export(t, r) {
    let n = 0;
    const i = (o) => {
      var a;
      if (o.code === J.SUCCESS)
        return r({
          code: J.SUCCESS
        });
      if (n++, n > Gi)
        return console.error(
          `[@launchdarkly/observability] failed to export OTeL metrics: ${(a = o.error) == null ? void 0 : a.message}`,
          o.error
        ), r({
          code: J.FAILED,
          error: o.error
        });
      new Promise(
        (u) => setTimeout(
          u,
          Hi + zi * Math.pow(2, n)
        )
      ).then(() => {
        var u;
        console.warn(
          `[@launchdarkly/observability] retry ${n}, failed to export OTeL metrics: ${(u = o.error) == null ? void 0 : u.message}`,
          o.error
        ), super.export(t, i);
      });
    };
    super.export(t, i);
  }
}
const lb = "OT_ZONE_CONTEXT", pb = "Navigation:", fb = ["click", "input", "submit"];
function hb() {
  return !1;
}
const ki = class Pt extends Dd {
  constructor(t = {}) {
    var r;
    super(
      Pt.moduleName,
      Pt.version,
      t
    ), k(this, "_spansData", /* @__PURE__ */ new WeakMap()), k(this, "_zonePatched"), k(this, "_wrappedListeners", /* @__PURE__ */ new WeakMap()), k(this, "_eventsSpanMap", /* @__PURE__ */ new WeakMap()), k(this, "_eventNames"), k(this, "_shouldPreventSpanCreation"), this._eventNames = new Set(
      (r = t?.eventNames) != null ? r : fb
    ), this._shouldPreventSpanCreation = typeof t?.shouldPreventSpanCreation == "function" ? t.shouldPreventSpanCreation : hb;
  }
  init() {
  }
  /**
   * This will check if last task was timeout and will save the time to
   * fix the user interaction when nothing happens
   * This timeout comes from xhr plugin which is needed to collect information
   * about last xhr main request from observer
   * @param task
   * @param span
   */
  _checkForTimeout(t, r) {
    const n = this._spansData.get(r);
    n && (t.source === "setTimeout" ? n.hrTimeLastTimeout = Vh() : t.source !== "Promise.then" && t.source !== "setTimeout" && (n.hrTimeLastTimeout = void 0));
  }
  /**
   * Controls whether or not to create a span, based on the event type.
   */
  _allowEventName(t) {
    return this._eventNames.has(t);
  }
  /**
   * Creates a new span
   * @param event
   * @param parentSpan
   */
  _createSpan(t, r) {
    var n;
    const i = t?.target, o = t?.type;
    if (!(i instanceof HTMLElement) || !i.getAttribute || i.hasAttribute("disabled") || !this._allowEventName(o))
      return;
    const a = yu(i, !0);
    try {
      const u = this.tracer.startSpan(
        o,
        {
          attributes: {
            "event.type": o,
            "event.tag": i.tagName,
            "event.xpath": a,
            "event.id": i.id,
            "event.classname": i.className,
            "event.text": (n = i.textContent) != null ? n : "",
            "event.url": window.location.href,
            "viewport.width": window.innerWidth,
            "viewport.height": window.innerHeight
          }
        },
        r ? x.setSpan(C.active(), r) : void 0
      );
      return t instanceof MouseEvent && (u.setAttribute("event.x", t.clientX), u.setAttribute("event.y", t.clientY), u.setAttribute(
        "event.relativeX",
        t.clientX / window.innerWidth
      ), u.setAttribute(
        "event.relativeY",
        t.clientY / window.innerHeight
      ), o === "scroll" && (u.setAttribute("event.scrollX", window.scrollX), u.setAttribute("event.scrollY", window.scrollY))), this._shouldPreventSpanCreation(o, i, u) === !0 ? void 0 : (this._spansData.set(u, {
        taskCount: 0
      }), u);
    } catch (u) {
      this._diag.error(
        "failed to start create new user interaction span",
        u
      );
    }
  }
  /**
   * Decrement number of tasks that left in zone,
   * This is needed to be able to end span when no more tasks left
   * @param span
   */
  _decrementTask(t) {
    const r = this._spansData.get(t);
    r && (r.taskCount--, r.taskCount === 0 && this._tryToEndSpan(t, r.hrTimeLastTimeout));
  }
  /**
   * Return the current span
   * @param zone
   * @private
   */
  _getCurrentSpan(t) {
    const r = t.get(lb);
    return r && x.getSpan(r);
  }
  /**
   * Increment number of tasks that are run within the same zone.
   *     This is needed to be able to end span when no more tasks left
   * @param span
   */
  _incrementTask(t) {
    const r = this._spansData.get(t);
    r && r.taskCount++;
  }
  /**
   * Returns true iff we should use the patched callback; false if it's already been patched
   */
  addPatchedListener(t, r, n, i) {
    let o = this._wrappedListeners.get(n);
    o || (o = /* @__PURE__ */ new Map(), this._wrappedListeners.set(n, o));
    let a = o.get(r);
    return a || (a = /* @__PURE__ */ new Map(), o.set(r, a)), a.has(t) ? !1 : (a.set(t, i), !0);
  }
  /**
   * Returns the patched version of the callback (or undefined)
   */
  removePatchedListener(t, r, n) {
    const i = this._wrappedListeners.get(n);
    if (!i)
      return;
    const o = i.get(r);
    if (!o)
      return;
    const a = o.get(t);
    return a && (o.delete(t), o.size === 0 && (i.delete(r), i.size === 0 && this._wrappedListeners.delete(n))), a;
  }
  // utility method to deal with the Function|EventListener nature of addEventListener
  _invokeListener(t, r, n) {
    return typeof t == "function" ? t.apply(r, n) : t.handleEvent(n[0]);
  }
  /**
   * This patches the addEventListener of HTMLElement to be able to
   * auto instrument the click events
   * This is done when zone is not available
   */
  _patchAddEventListener() {
    const t = this;
    let r = /* @__PURE__ */ new Map();
    return (n) => function(i, o, a) {
      if (!o)
        return n.call(this, i, o, a);
      const u = a && typeof a == "object" && a.once, c = function(...s) {
        var l;
        let p;
        const f = s[0];
        if (!(f != null && f.type))
          return t._invokeListener(o, this, s);
        if (Date.now() - ((l = r.get(f.type)) != null ? l : 0) < 1e3 / 60)
          return t._invokeListener(o, this, s);
        r.set(f.type, Date.now()), f && (p = t._eventsSpanMap.get(f)), u && t.removePatchedListener(this, i, o);
        const m = t._createSpan(f, p);
        return m ? (f && t._eventsSpanMap.set(f, m), C.with(
          x.setSpan(C.active(), m),
          () => {
            const v = t._invokeListener(
              o,
              this,
              s
            );
            return m.end(), v;
          }
        )) : t._invokeListener(o, this, s);
      };
      if (t.addPatchedListener(
        this,
        i,
        o,
        c
      ))
        return n.call(
          this,
          i,
          c,
          a
        );
    };
  }
  /**
   * This patches the removeEventListener of HTMLElement to handle the fact that
   * we patched the original callbacks
   * This is done when zone is not available
   */
  _patchRemoveEventListener() {
    const t = this;
    return (r) => function(n, i, o) {
      const a = t.removePatchedListener(
        this,
        n,
        i
      );
      return a ? r.call(
        this,
        n,
        a,
        o
      ) : r.call(this, n, i, o);
    };
  }
  /**
   * Most browser provide event listener api via EventTarget in prototype chain.
   * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
   *
   * * - has addEventListener in IE
   * ** - has addEventListener in all other browsers
   * ! - missing in IE
   *
   * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
   * Document -> Node * -> EventTarget **! -> Object
   * Window * -> WindowProperties ! -> EventTarget **! -> Object
   */
  _getPatchableEventTargets() {
    return window.EventTarget ? [EventTarget.prototype] : [Node.prototype, Window.prototype];
  }
  /**
   * Patches the history api
   */
  _patchHistoryApi() {
    this._unpatchHistoryApi(), this._wrap(history, "replaceState", this._patchHistoryMethod()), this._wrap(history, "pushState", this._patchHistoryMethod()), this._wrap(history, "back", this._patchHistoryMethod()), this._wrap(history, "forward", this._patchHistoryMethod()), this._wrap(history, "go", this._patchHistoryMethod());
  }
  /**
   * Patches the certain history api method
   */
  _patchHistoryMethod() {
    const t = this;
    return (r) => function(...n) {
      const i = `${location.pathname}${location.hash}${location.search}`, o = r.apply(this, n), a = `${location.pathname}${location.hash}${location.search}`;
      return i !== a && t._updateInteractionName(a), o;
    };
  }
  /**
   * unpatch the history api methods
   */
  _unpatchHistoryApi() {
    W(history.replaceState) && this._unwrap(history, "replaceState"), W(history.pushState) && this._unwrap(history, "pushState"), W(history.back) && this._unwrap(history, "back"), W(history.forward) && this._unwrap(history, "forward"), W(history.go) && this._unwrap(history, "go");
  }
  /**
   * Updates interaction span name
   * @param url
   */
  _updateInteractionName(t) {
    const r = x.getSpan(
      C.active()
    );
    r && typeof r.updateName == "function" && r.updateName(`${pb} ${t}`);
  }
  /**
   * Patches zone cancel task - this is done to be able to correctly
   * decrement the number of remaining tasks
   */
  _patchZoneCancelTask() {
    const t = this;
    return (r) => function(n) {
      const i = Zone.current, o = t._getCurrentSpan(i);
      return o && t._shouldCountTask(n, i) && t._decrementTask(o), r.call(this, n);
    };
  }
  /**
   * Patches zone schedule task - this is done to be able to correctly
   * increment the number of tasks running within current zone but also to
   * save time in case of timeout running from xhr plugin when waiting for
   * main request from PerformanceResourceTiming
   */
  _patchZoneScheduleTask() {
    const t = this;
    return (r) => function(n) {
      const i = Zone.current, o = t._getCurrentSpan(i);
      return o && t._shouldCountTask(n, i) && (t._incrementTask(o), t._checkForTimeout(n, o)), r.call(this, n);
    };
  }
  /**
   * Patches zone run task - this is done to be able to create a span when
   * user interaction starts
   * @private
   */
  _patchZoneRunTask() {
    const t = this;
    return (r) => function(n, i, o) {
      const a = Array.isArray(o) && o[0] instanceof Event ? o[0] : void 0, u = a?.target;
      let c;
      const s = this;
      if (u) {
        if (c = t._createSpan(a), c)
          return t._incrementTask(c), s.run(() => {
            try {
              return C.with(
                x.setSpan(
                  C.active(),
                  c
                ),
                () => {
                  const l = Zone.current;
                  return n._zone = l, r.call(
                    l,
                    n,
                    i,
                    o
                  );
                }
              );
            } finally {
              t._decrementTask(c);
            }
          });
      } else
        c = t._getCurrentSpan(s);
      try {
        return r.call(s, n, i, o);
      } finally {
        c && t._shouldCountTask(n, s) && t._decrementTask(c);
      }
    };
  }
  /**
   * Decides if task should be counted.
   * @param task
   * @param currentZone
   * @private
   */
  _shouldCountTask(t, r) {
    if (t._zone && (r = t._zone), !r || !t.data || t.data.isPeriodic)
      return !1;
    const n = this._getCurrentSpan(r);
    return !n || !this._spansData.get(n) ? !1 : t.type === "macroTask" || t.type === "microTask";
  }
  /**
   * Will try to end span when such span still exists.
   * @param span
   * @param endTime
   * @private
   */
  _tryToEndSpan(t, r) {
    t && this._spansData.get(t) && (t.end(r), this._spansData.delete(t));
  }
  /**
   * implements enable function
   */
  enable() {
    const t = this._getZoneWithPrototype();
    this._diag.debug(
      "applying patch to",
      Pt.moduleName,
      Pt.version,
      "zone:",
      !!t
    ), t ? (W(t.prototype.runTask) && (this._unwrap(t.prototype, "runTask"), this._diag.debug("removing previous patch from method runTask")), W(t.prototype.scheduleTask) && (this._unwrap(t.prototype, "scheduleTask"), this._diag.debug(
      "removing previous patch from method scheduleTask"
    )), W(t.prototype.cancelTask) && (this._unwrap(t.prototype, "cancelTask"), this._diag.debug(
      "removing previous patch from method cancelTask"
    )), this._zonePatched = !0, this._wrap(
      t.prototype,
      "runTask",
      this._patchZoneRunTask()
    ), this._wrap(
      t.prototype,
      "scheduleTask",
      this._patchZoneScheduleTask()
    ), this._wrap(
      t.prototype,
      "cancelTask",
      this._patchZoneCancelTask()
    )) : (this._zonePatched = !1, this._getPatchableEventTargets().forEach((r) => {
      W(r.addEventListener) && (this._unwrap(r, "addEventListener"), this._diag.debug(
        "removing previous patch from method addEventListener"
      )), W(r.removeEventListener) && (this._unwrap(r, "removeEventListener"), this._diag.debug(
        "removing previous patch from method removeEventListener"
      )), this._wrap(
        r,
        "addEventListener",
        this._patchAddEventListener()
      ), this._wrap(
        r,
        "removeEventListener",
        this._patchRemoveEventListener()
      );
    })), this._patchHistoryApi();
  }
  /**
   * implements unpatch function
   */
  disable() {
    const t = this._getZoneWithPrototype();
    this._diag.debug(
      "removing patch from",
      Pt.moduleName,
      Pt.version,
      "zone:",
      !!t
    ), t && this._zonePatched ? (W(t.prototype.runTask) && this._unwrap(t.prototype, "runTask"), W(t.prototype.scheduleTask) && this._unwrap(t.prototype, "scheduleTask"), W(t.prototype.cancelTask) && this._unwrap(t.prototype, "cancelTask")) : this._getPatchableEventTargets().forEach((r) => {
      W(r.addEventListener) && this._unwrap(r, "addEventListener"), W(r.removeEventListener) && this._unwrap(r, "removeEventListener");
    }), this._unpatchHistoryApi();
  }
  /**
   * returns Zone
   */
  _getZoneWithPrototype() {
    return window.Zone;
  }
};
k(ki, "version", "0.1.1"), k(ki, "moduleName", "user-interaction");
let db = ki, bt = {}, ee;
const Ur = "highlight.record", vb = "highlight.session_id", Yu = "launchdarkly.js.log", mb = "launchdarkly.exception.id", Ia = "launchdarkly.sampling.ratio", Ju = "log.severity", Qu = "log.message", yb = (e, t) => {
  var r, n, i, o, a, u, c, s, l;
  if (bt.tracerProvider !== void 0) {
    console.warn("OTEL already initialized. Skipping...");
    return;
  }
  ee = e;
  const p = e.backendUrl || void 0 || "https://pub.highlight.io", f = [
    ...(n = (r = e.networkRecordingOptions) == null ? void 0 : r.urlBlocklist) != null ? n : [],
    ...k_
  ], m = (i = e.environment) != null ? i : "production", v = {
    url: e.otlpEndpoint + "/v1/traces",
    concurrencyLimit: 10,
    timeoutMillis: 3e4,
    // Using any because we were getting an error importing CompressionAlgorithm
    // from @opentelemetry/otlp-exporter-base.
    compression: "gzip",
    keepAlive: !0,
    httpAgentOptions: {
      timeout: 6e4,
      keepAlive: !0
    }
  }, y = new ub(
    v,
    t
  ), g = new _b(y, {
    maxExportBatchSize: 1024,
    // Default value from SDK is 512
    maxQueueSize: 2048,
    // Default value from SDK is 2048
    exportTimeoutMillis: v.timeoutMillis,
    // Default value from SDK is 30_000
    scheduledDelayMillis: v.timeoutMillis
    // Default value from SDK is 1000
  }), E = new Fe({
    [Gl]: (o = e.serviceName) != null ? o : "highlight-browser",
    "deployment.environment.name": m,
    "highlight.project_id": e.projectId,
    [Wl]: navigator.userAgent,
    "browser.language": navigator.language,
    "telemetry.distro.name": "@highlight-run/observability",
    "telemetry.distro.version": Ap
  });
  bt.tracerProvider = new Xm({
    resource: E,
    mergeResourceWithDefaults: !0,
    spanProcessors: [g]
  }), x.setGlobalTracerProvider(bt.tracerProvider);
  const N = new cb(et(M({}, v), {
    url: e.otlpEndpoint + "/v1/metrics"
  })), j = new bE({
    exporter: N,
    exportIntervalMillis: v.timeoutMillis,
    exportTimeoutMillis: v.timeoutMillis
  });
  bt.meterProvider = new uT({ resource: E, readers: [j] }), pt.setGlobalMeterProvider(bt.meterProvider);
  let U = [];
  ((a = e.instrumentations) == null ? void 0 : a["@opentelemetry/instrumentation-document-load"]) !== !1 && U.push(
    new ly({
      applyCustomAttributesOnSpan: {
        documentLoad: Ua,
        documentFetch: Ua,
        resourceFetch: Tb
      }
    })
  ), ((u = e.instrumentations) == null ? void 0 : u["@opentelemetry/instrumentation-user-interaction"]) !== !1 && U.push(
    new db({
      eventNames: e.eventNames
    })
  ), (c = e.networkRecordingOptions) != null && c.enabled && (((s = e.instrumentations) == null ? void 0 : s["@opentelemetry/instrumentation-fetch"]) !== !1 && U.push(
    new Jy({
      propagateTraceHeaderCorsUrls: ja(
        e.tracingOrigins
      ),
      applyCustomAttributesOnSpan: (D, H, $) => se(void 0, null, function* () {
        var vt, at, K;
        if (!D.attributes)
          return;
        const Kt = D;
        if (Kt.attributes[Ur] === !1)
          return;
        const ye = Kt.attributes["http.url"], h = (vt = H.method) != null ? vt : "GET";
        if (D.updateName(ka(ye, h, H.body)), !($ instanceof Response)) {
          D.setAttributes({
            "http.response.error": $.message,
            "http.response.status": $.status
          });
          return;
        }
        Da(
          D,
          H.body,
          H.headers,
          e.networkRecordingOptions
        );
        const _ = yield z_(
          $,
          (at = e.networkRecordingOptions) == null ? void 0 : at.bodyKeysToRecord,
          (K = e.networkRecordingOptions) == null ? void 0 : K.networkBodyKeysToRedact
        );
        D.setAttribute("http.response.body", _);
      })
    })
  ), ((l = e.instrumentations) == null ? void 0 : l["@opentelemetry/instrumentation-xml-http-request"]) !== !1 && U.push(
    new P_({
      propagateTraceHeaderCorsUrls: ja(
        e.tracingOrigins
      ),
      applyCustomAttributesOnSpan: (D, H) => {
        var $, vt;
        const at = H;
        if (!D.attributes || D.attributes[Ur] === !1)
          return;
        const K = ka(
          at._url,
          at._method,
          H.responseText
        );
        D.updateName(K), Da(
          D,
          at._body,
          at._requestHeaders,
          e.networkRecordingOptions
        );
        const Kt = Eu(
          at._body,
          ($ = e.networkRecordingOptions) == null ? void 0 : $.networkBodyKeysToRedact,
          (vt = e.networkRecordingOptions) == null ? void 0 : vt.bodyKeysToRecord,
          at._requestHeaders
        );
        D.setAttribute("http.request.body", Kt);
      }
    })
  )), xd({ instrumentations: U });
  const F = new du();
  return F.enable(), bt.tracerProvider.register({
    contextManager: F,
    propagator: new zh({
      propagators: [
        new Eh(),
        new gb({
          backendUrl: p,
          otlpEndpoint: e.otlpEndpoint,
          tracingOrigins: e.tracingOrigins,
          urlBlocklist: f
        })
      ]
    })
  }), bt;
};
class _b extends hu {
  onStart(t, r) {
    t.setAttribute(vb, Ot()), super.onStart(t, r);
  }
  onEnd(t) {
    t.attributes[Ur] !== !1 && super.onEnd(t);
  }
}
class gb extends ud {
  constructor(t) {
    super(), k(this, "highlightEndpoints"), k(this, "tracingOrigins"), k(this, "urlBlocklist"), this.highlightEndpoints = [
      t.backendUrl,
      `${t.otlpEndpoint}/v1/traces`,
      `${t.otlpEndpoint}/v1/logs`,
      `${t.otlpEndpoint}/v1/metrics`
    ], this.tracingOrigins = t.tracingOrigins, this.urlBlocklist = t.urlBlocklist;
  }
  inject(t, r, n) {
    var i;
    const o = x.getSpan(t);
    if (!o || !o.attributes)
      return;
    const a = o.attributes["http.url"];
    typeof a == "string" && (Eb(
      a,
      this.highlightEndpoints,
      this.tracingOrigins,
      this.urlBlocklist
    ) || o.setAttribute(Ur, !1), !G_(
      a,
      (i = this.tracingOrigins) != null ? i : [],
      this.urlBlocklist
    )) || super.inject(t, r, n);
  }
}
const Zu = "highlight-browser", lr = Zu, Ma = () => {
  var e;
  return (e = bt.tracerProvider) == null ? void 0 : e.getTracer(Zu);
}, ka = (e, t, r) => {
  var n, i, o;
  let a;
  const u = new URL(e), c = u.pathname;
  let s = `${t.toUpperCase()} - ${c}`;
  try {
    if (a = typeof r == "string" ? JSON.parse(r) : r, a && a.query) {
      const l = ji(a.query), p = ((n = l.definitions[0]) == null ? void 0 : n.kind) === "OperationDefinition" ? (o = (i = l.definitions[0]) == null ? void 0 : i.name) == null ? void 0 : o.value : void 0;
      p && (s = `${p} (GraphQL: ${u.host + u.pathname})`);
    }
  } catch {
  }
  return s;
}, Da = (e, t, r, n) => {
  var i;
  const o = typeof t == "string" ? t : String(t);
  if (!e.attributes)
    return;
  const a = e.attributes["http.url"], u = new URL(a);
  let c;
  try {
    c = t ? JSON.parse(o) : void 0, c.operationName && e.setAttribute(
      "graphql.operation.name",
      c.operationName
    );
  } catch {
  }
  const s = I_(
    (i = n?.networkHeadersToRedact) != null ? i : [],
    r,
    n?.headerKeysToRecord
  );
  e.setAttributes({
    "highlight.type": "http.request",
    "http.request.headers": JSON.stringify(s),
    "http.request.body": o,
    [Xl]: a,
    [ql]: u.pathname,
    [Kl]: u.search
  }), u.searchParams.size > 0 && e.setAttributes({
    // Custom attribute that displays query string params as an object.
    "url.query_params": JSON.stringify(
      Object.fromEntries(u.searchParams)
    )
  });
}, Eb = (e, t, r, n) => n != null && n.some(
  (i) => e.toLowerCase().includes(i)
) ? !1 : V_(
  e,
  t
), Ua = (e) => {
  var t, r, n;
  if (!e.events)
    return;
  const i = e.events, o = {
    unload: rt("unloadEventStart", "unloadEventEnd", i),
    dom_interactive: rt(
      "fetchStart",
      "domInteractive",
      i
    ),
    dom_content_loaded: rt(
      "domContentLoadedEventStart",
      "domContentLoadedEventEnd",
      i
    ),
    dom_complete: rt("fetchStart", "domComplete", i),
    load_event: rt("loadEventStart", "loadEventEnd", i),
    document_load: rt("fetchStart", "loadEventEnd", i),
    first_paint: rt("fetchStart", "firstPaint", i),
    first_contentful_paint: rt(
      "fetchStart",
      "firstContentfulPaint",
      i
    ),
    domain_lookup: rt(
      "domainLookupStart",
      "domainLookupEnd",
      i
    ),
    connect: rt("connectStart", "connectEnd", i),
    request: rt("requestStart", "requestEnd", i),
    response: rt("responseStart", "responseEnd", i)
  }, a = (r = (t = ee?.getIntegrations) == null ? void 0 : t.call(ee)) != null ? r : [];
  if (o.document_load !== void 0)
    for (const u of a)
      u.recordGauge((n = ee?.sessionSecureId) != null ? n : "", {
        name: Ss,
        value: o.document_load / 1e6
      });
  Object.entries(o).forEach(([u, c]) => {
    c !== void 0 && (e.setAttribute(`timings.${u}.ns`, c), e.setAttribute(
      `timings.${u}.readable`,
      tc(c)
    ));
  });
};
function rt(e, t, r) {
  const n = r.find((a) => a.name === e), i = r.find((a) => a.name === t);
  if (!n || !i)
    return;
  const o = n.time[0] * 1e9 + n.time[1];
  return i.time[0] * 1e9 + i.time[1] - o;
}
const Tb = (e, t) => {
  const r = {
    domain_lookup: (t.domainLookupEnd - t.domainLookupStart) * 1e9,
    connect: (t.connectEnd - t.connectStart) * 1e9,
    request: (t.responseEnd - t.requestStart) * 1e9,
    response: (t.responseEnd - t.responseStart) * 1e9
  };
  Object.entries(r).forEach(([n, i]) => {
    e.setAttribute(`timings.${n}.ns`, i), e.setAttribute(`timings.${n}.readable`, tc(i));
  });
}, tc = (e) => {
  if (e >= 36e11) {
    const t = e / 36e11;
    return `${Number(t.toFixed(1))}h`;
  } else if (e >= 6e10) {
    const t = e / 6e10;
    return `${Number(t.toFixed(1))}m`;
  } else if (e >= 1e9) {
    const t = e / 1e9;
    return `${Number(t.toFixed(1))}s`;
  } else if (e >= 1e6) {
    const t = e / 1e6;
    return `${Number(t.toFixed(1))}ms`;
  } else if (e >= 1e3) {
    const t = e / 1e3;
    return `${Number(t.toFixed(1))}µs`;
  } else
    return `${Number(e.toFixed(1))}ns`;
}, ja = (e) => e === !0 ? [/localhost/, /^\//, new RegExp(window.location.host)] : Array.isArray(e) ? e.map(
  (t) => typeof t == "string" ? new RegExp(t) : t
) : /^$/, bb = 30, Ob = () => new Promise(
  (e) => requestAnimationFrame(
    (t) => requestAnimationFrame((r) => e(r - t))
  )
), Sb = () => se(void 0, null, function* () {
  const e = [];
  for (let t = 0; t < bb; t++)
    e.push(yield Ob());
  return e.reduce((t, r) => t + r, 0) / e.length;
}), wb = (e, t) => {
  let r = {}, n = 16.666666666666668;
  Sb().then((c) => n = c);
  const i = (c) => {
    var s;
    r != null && r.event || (r = {
      event: c,
      location: window.location.href,
      timerStart: (s = window.performance) == null ? void 0 : s.now()
    }, window.requestAnimationFrame(o));
  }, o = () => {
    if (!(r != null && r.timerStart)) return;
    const c = window.performance.now() - r.timerStart - n;
    a(c), r = {};
  }, a = (c) => {
    const s = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: s,
      jankAmount: c,
      querySelector: u(),
      newLocation: window.location.href != r.location ? window.location.href : void 0
    });
  }, u = () => {
    var c;
    return (c = r?.event) != null && c.target ? Lp(r.event.target) : "";
  };
  return window.addEventListener("click", i, !0), window.addEventListener("keydown", i, !0), () => {
    window.removeEventListener("keydown", i, !0), window.removeEventListener("click", i, !0);
  };
}, Ab = typeof window < "u", $a = Ab && "performance" in window && "memory" in performance ? performance : { memory: {} }, Lb = (e, t) => {
  let r = 0, n = 0;
  const i = () => {
    const s = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3, l = $a.memory.jsHeapSizeLimit || 0, p = $a.memory.usedJSHeapSize || 0;
    e({
      jsHeapSizeLimit: l,
      usedJSHeapSize: p,
      relativeTimestamp: s,
      fps: r
    });
  };
  i();
  let o;
  o = setInterval(() => {
    i();
  }, 1e3);
  let a = 0, u = Date.now();
  const c = function() {
    var s = Date.now();
    a++, s > 1e3 + u && (r = Math.round(a * 1e3 / (s - u)), a = 0, u = s), n = requestAnimationFrame(c);
  };
  return c(), () => {
    clearInterval(o), cancelAnimationFrame(n);
  };
};
var wt, Ie, ec, jr, Di, rc = -1, qt = function(e) {
  addEventListener("pageshow", function(t) {
    t.persisted && (rc = t.timeStamp, e(t));
  }, !0);
}, io = function() {
  return window.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
}, Wr = function() {
  var e = io();
  return e && e.activationStart || 0;
}, it = function(e, t) {
  var r = io(), n = "navigate";
  return rc >= 0 ? n = "back-forward-cache" : r && (document.prerendering || Wr() > 0 ? n = "prerender" : document.wasDiscarded ? n = "restore" : r.type && (n = r.type.replace(/_/g, "-"))), { name: e, value: t === void 0 ? -1 : t, rating: "good", delta: 0, entries: [], id: "v3-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: n };
}, me = function(e, t, r) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var n = new PerformanceObserver(function(i) {
        Promise.resolve().then(function() {
          t(i.getEntries());
        });
      });
      return n.observe(Object.assign({ type: e, buffered: !0 }, r || {})), n;
    }
  } catch {
  }
}, ot = function(e, t, r, n) {
  var i, o;
  return function(a) {
    t.value >= 0 && (a || n) && ((o = t.value - (i || 0)) || i === void 0) && (i = t.value, t.delta = o, t.rating = function(u, c) {
      return u > c[1] ? "poor" : u > c[0] ? "needs-improvement" : "good";
    }(t.value, r), e(t));
  };
}, oo = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, Yr = function(e) {
  var t = function(r) {
    r.type !== "pagehide" && document.visibilityState !== "hidden" || e(r);
  };
  addEventListener("visibilitychange", t, !0), addEventListener("pagehide", t, !0);
}, ao = function(e) {
  var t = !1;
  return function(r) {
    t || (e(r), t = !0);
  };
}, ie = -1, Ba = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, $r = function(e) {
  document.visibilityState === "hidden" && ie > -1 && (ie = e.type === "visibilitychange" ? e.timeStamp : 0, Rb());
}, Fa = function() {
  addEventListener("visibilitychange", $r, !0), addEventListener("prerenderingchange", $r, !0);
}, Rb = function() {
  removeEventListener("visibilitychange", $r, !0), removeEventListener("prerenderingchange", $r, !0);
}, so = function() {
  return ie < 0 && (ie = Ba(), Fa(), qt(function() {
    setTimeout(function() {
      ie = Ba(), Fa();
    }, 0);
  })), { get firstHiddenTime() {
    return ie;
  } };
}, Je = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, Va = [1800, 3e3], nc = function(e, t) {
  t = t || {}, Je(function() {
    var r, n = so(), i = it("FCP"), o = me("paint", function(a) {
      a.forEach(function(u) {
        u.name === "first-contentful-paint" && (o.disconnect(), u.startTime < n.firstHiddenTime && (i.value = Math.max(u.startTime - Wr(), 0), i.entries.push(u), r(!0)));
      });
    });
    o && (r = ot(e, i, Va, t.reportAllChanges), qt(function(a) {
      i = it("FCP"), r = ot(e, i, Va, t.reportAllChanges), oo(function() {
        i.value = performance.now() - a.timeStamp, r(!0);
      });
    }));
  });
}, Ga = [0.1, 0.25], Cb = function(e, t) {
  t = t || {}, nc(ao(function() {
    var r, n = it("CLS", 0), i = 0, o = [], a = function(c) {
      c.forEach(function(s) {
        if (!s.hadRecentInput) {
          var l = o[0], p = o[o.length - 1];
          i && s.startTime - p.startTime < 1e3 && s.startTime - l.startTime < 5e3 ? (i += s.value, o.push(s)) : (i = s.value, o = [s]);
        }
      }), i > n.value && (n.value = i, n.entries = o, r());
    }, u = me("layout-shift", a);
    u && (r = ot(e, n, Ga, t.reportAllChanges), Yr(function() {
      a(u.takeRecords()), r(!0);
    }), qt(function() {
      i = 0, n = it("CLS", 0), r = ot(e, n, Ga, t.reportAllChanges), oo(function() {
        return r();
      });
    }), setTimeout(r, 0));
  }));
}, Le = { passive: !0, capture: !0 }, Nb = /* @__PURE__ */ new Date(), Ha = function(e, t) {
  wt || (wt = t, Ie = e, ec = /* @__PURE__ */ new Date(), oc(removeEventListener), ic());
}, ic = function() {
  if (Ie >= 0 && Ie < ec - Nb) {
    var e = { entryType: "first-input", name: wt.type, target: wt.target, cancelable: wt.cancelable, startTime: wt.timeStamp, processingStart: wt.timeStamp + Ie };
    jr.forEach(function(t) {
      t(e);
    }), jr = [];
  }
}, xb = function(e) {
  if (e.cancelable) {
    var t = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(r, n) {
      var i = function() {
        Ha(r, n), a();
      }, o = function() {
        a();
      }, a = function() {
        removeEventListener("pointerup", i, Le), removeEventListener("pointercancel", o, Le);
      };
      addEventListener("pointerup", i, Le), addEventListener("pointercancel", o, Le);
    }(t, e) : Ha(t, e);
  }
}, oc = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(t) {
    return e(t, xb, Le);
  });
}, za = [100, 300], Pb = function(e, t) {
  t = t || {}, Je(function() {
    var r, n = so(), i = it("FID"), o = function(c) {
      c.startTime < n.firstHiddenTime && (i.value = c.processingStart - c.startTime, i.entries.push(c), r(!0));
    }, a = function(c) {
      c.forEach(o);
    }, u = me("first-input", a);
    r = ot(e, i, za, t.reportAllChanges), u && Yr(ao(function() {
      a(u.takeRecords()), u.disconnect();
    })), u && qt(function() {
      var c;
      i = it("FID"), r = ot(e, i, za, t.reportAllChanges), jr = [], Ie = -1, wt = null, oc(addEventListener), c = o, jr.push(c), ic();
    });
  });
}, ac = 0, zn = 1 / 0, pr = 0, Ib = function(e) {
  e.forEach(function(t) {
    t.interactionId && (zn = Math.min(zn, t.interactionId), pr = Math.max(pr, t.interactionId), ac = pr ? (pr - zn) / 7 + 1 : 0);
  });
}, sc = function() {
  return Di ? ac : performance.interactionCount || 0;
}, Mb = function() {
  "interactionCount" in performance || Di || (Di = me("event", Ib, { type: "event", buffered: !0, durationThreshold: 0 }));
}, Xa = [200, 500], uc = 0, qa = function() {
  return sc() - uc;
}, lt = [], Xn = {}, Ka = function(e) {
  var t = lt[lt.length - 1], r = Xn[e.interactionId];
  if (r || lt.length < 10 || e.duration > t.latency) {
    if (r) r.entries.push(e), r.latency = Math.max(r.latency, e.duration);
    else {
      var n = { id: e.interactionId, latency: e.duration, entries: [e] };
      Xn[n.id] = n, lt.push(n);
    }
    lt.sort(function(i, o) {
      return o.latency - i.latency;
    }), lt.splice(10).forEach(function(i) {
      delete Xn[i.id];
    });
  }
}, kb = function(e, t) {
  t = t || {}, Je(function() {
    var r;
    Mb();
    var n, i = it("INP"), o = function(u) {
      u.forEach(function(l) {
        l.interactionId && Ka(l), l.entryType === "first-input" && !lt.some(function(p) {
          return p.entries.some(function(f) {
            return l.duration === f.duration && l.startTime === f.startTime;
          });
        }) && Ka(l);
      });
      var c, s = (c = Math.min(lt.length - 1, Math.floor(qa() / 50)), lt[c]);
      s && s.latency !== i.value && (i.value = s.latency, i.entries = s.entries, n());
    }, a = me("event", o, { durationThreshold: (r = t.durationThreshold) !== null && r !== void 0 ? r : 40 });
    n = ot(e, i, Xa, t.reportAllChanges), a && ("interactionId" in PerformanceEventTiming.prototype && a.observe({ type: "first-input", buffered: !0 }), Yr(function() {
      o(a.takeRecords()), i.value < 0 && qa() > 0 && (i.value = 0, i.entries = []), n(!0);
    }), qt(function() {
      lt = [], uc = sc(), i = it("INP"), n = ot(e, i, Xa, t.reportAllChanges);
    }));
  });
}, Wa = [2500, 4e3], qn = {}, Db = function(e, t) {
  t = t || {}, Je(function() {
    var r, n = so(), i = it("LCP"), o = function(c) {
      var s = c[c.length - 1];
      s && s.startTime < n.firstHiddenTime && (i.value = Math.max(s.startTime - Wr(), 0), i.entries = [s], r());
    }, a = me("largest-contentful-paint", o);
    if (a) {
      r = ot(e, i, Wa, t.reportAllChanges);
      var u = ao(function() {
        qn[i.id] || (o(a.takeRecords()), a.disconnect(), qn[i.id] = !0, r(!0));
      });
      ["keydown", "click"].forEach(function(c) {
        addEventListener(c, function() {
          return setTimeout(u, 0);
        }, !0);
      }), Yr(u), qt(function(c) {
        i = it("LCP"), r = ot(e, i, Wa, t.reportAllChanges), oo(function() {
          i.value = performance.now() - c.timeStamp, qn[i.id] = !0, r(!0);
        });
      });
    }
  });
}, Ya = [800, 1800], Ub = function e(t) {
  document.prerendering ? Je(function() {
    return e(t);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(t);
  }, !0) : setTimeout(t, 0);
}, jb = function(e, t) {
  t = t || {};
  var r = it("TTFB"), n = ot(e, r, Ya, t.reportAllChanges);
  Ub(function() {
    var i = io();
    if (i) {
      var o = i.responseStart;
      if (o <= 0 || o > performance.now()) return;
      r.value = Math.max(o - Wr(), 0), r.entries = [i], n(!0), qt(function() {
        r = it("TTFB", 0), (n = ot(e, r, Ya, t.reportAllChanges))(!0);
      });
    }
  });
};
const $b = (e) => (Cb(e), nc(e), Pb(e), Db(e), jb(e), kb(e), () => {
}), te = typeof navigator < "u" && "connection" in navigator ? navigator.connection : {}, Bb = (e, t) => {
  const r = () => {
    const i = ((/* @__PURE__ */ new Date()).getTime() - t) / 1e3;
    e({
      relativeTimestamp: i,
      downlink: te.downlink,
      downlinkMax: te.downlinkMax,
      effectiveType: te.effectiveType,
      rtt: te.rtt,
      saveData: te.saveData,
      type: te.type
    });
  };
  r();
  let n;
  return n = setInterval(() => {
    r();
  }, 1e3), () => {
    clearInterval(n);
  };
}, Fb = () => {
  if (!("performance" in window && "memory" in performance))
    return {
      getDeviceDetails: void 0,
      getCurrentDeviceDetails: void 0
    };
  const e = window.performance;
  return {
    getDeviceDetails: () => ({
      deviceMemory: Vb(
        navigator.deviceMemory || 0
      )
    }),
    getCurrentDeviceDetails: () => {
      const t = Kn(
        e.memory.jsHeapSizeLimit
      ), r = Kn(
        e.memory.totalJSHeapSize
      ), n = Kn(
        e.memory.usedJSHeapSize
      );
      return {
        jsHeapSizeLimit: t,
        totalJSHeapSize: r,
        usedJSHeapSize: n
      };
    }
  };
}, Kn = (e) => e / Math.pow(1e3, 2), Vb = (e) => 1024 * e;
function Gb(e) {
  return "regexValue" in e;
}
function Hb(e) {
  return "matchValue" in e;
}
function zb(e) {
  const t = Math.trunc(e);
  return t === 1 ? !0 : t === 0 ? !1 : Math.floor(Math.random() * t) === 0;
}
class Xb {
  /**
   * @param config The sampling configuration.
   * @param sampler The sampler to use. This is intended to be used for testing purposes.
   */
  constructor(t = zb) {
    k(this, "regexCache", /* @__PURE__ */ new Map()), k(this, "config"), this.sampler = t;
  }
  setConfig(t) {
    this.config = t;
  }
  isSamplingEnabled() {
    var t, r, n, i;
    return !!((r = (t = this.config) == null ? void 0 : t.logs) != null && r.length || (i = (n = this.config) == null ? void 0 : n.spans) != null && i.length);
  }
  shouldSample(t) {
    var r, n;
    return t.name === Yu ? this.sampleLog((r = this.config) == null ? void 0 : r.logs, t) : this.sampleSpan((n = this.config) == null ? void 0 : n.spans, t);
  }
  /**
   * Check if a value matches a match config.
   */
  matchesValue(t, r) {
    if (!t)
      return !1;
    if (Hb(t))
      return t.matchValue === r;
    if (Gb(t)) {
      const n = t.regexValue;
      if (n === null)
        return !1;
      this.regexCache.has(n) || this.regexCache.set(n, new RegExp(n));
      const i = this.regexCache.get(n);
      if (typeof r == "string")
        return i.test(r);
    }
    return !1;
  }
  /**
   * Check if the attributes match the attribute configs.
   */
  matchesAttributes(t, r) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of Object.keys(r))
          if (this.matchesValue(n.key, o)) {
            const a = r[o];
            if (this.matchesValue(
              n.attribute,
              a
            )) {
              i = !0;
              break;
            }
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  matchEvent(t, r) {
    return !(t.name && !this.matchesValue(t.name, r.name) || t.attributes && (!r.attributes || !this.matchesAttributes(
      t.attributes,
      r.attributes
    )));
  }
  matchesEvents(t, r) {
    if (t)
      for (const n of t) {
        let i = !1;
        for (const o of r)
          if (this.matchEvent(n, o)) {
            i = !0;
            break;
          }
        if (!i)
          return !1;
      }
    return !0;
  }
  /**
   * Attempts to match the span to the config. The span will match only if all defined conditions are met.
   *
   * @param config The config to match against.
   * @param name The name of the span to match.
   * @param attributes The attributes of the span to match.
   * @returns True if the span matches the config, false otherwise.
   */
  matchesSpanConfig(t, r) {
    return !(t.name && !this.matchesValue(t.name, r.name) || !this.matchesAttributes(t.attributes, r.attributes) || !this.matchesEvents(t.events, r.events));
  }
  matchesLogConfig(t, r) {
    if (t.severityText) {
      const n = r[Ju];
      if (!this.matchesValue(t.severityText, n))
        return !1;
    }
    if (t.message) {
      const n = r[Qu];
      if (!this.matchesValue(t.message, n))
        return !1;
    }
    return !!this.matchesAttributes(t.attributes, r);
  }
  /**
   * Sample a span based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param name The name of the span to sample.
   * @param attributes The attributes of the span to sample.
   * @returns The sampling result.
   */
  sampleSpan(t, r) {
    if (t) {
      for (const n of t)
        if (this.matchesSpanConfig(n, r))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [Ia]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
  /**
   * Sample a log based on the sampling configuration.
   *
   * @param configs The sampling configuration.
   * @param attributes The attributes of the log to sample.
   * @returns The sampling result.
   */
  sampleLog(t, r) {
    if (t) {
      for (const n of t)
        if (this.matchesLogConfig(n, r.attributes))
          return {
            sample: this.sampler(n.samplingRatio),
            attributes: {
              [Ia]: n.samplingRatio
            }
          };
    }
    return {
      sample: !0
    };
  }
}
const Ja = () => {
  const e = {
    end: () => {
    },
    spanContext: () => ({
      traceId: "",
      spanId: "",
      traceFlags: 0
    }),
    setAttribute: (t, r) => e,
    setAttributes: (t) => e,
    addEvent: (t, r, n) => e,
    addLinks: (t) => e,
    setStatus: (t) => e,
    recordException: () => {
    },
    addLink: () => e,
    updateName: () => e,
    isRecording: () => !1
  };
  return e;
}, qb = "exception", Kb = function(e, t, r) {
  if (!e)
    return;
  const n = M({}, r);
  typeof t == "string" ? n[rn] = t : t && (t.code ? n[nn] = t.code.toString() : t.name && (n[nn] = t.name), t.message && (n[rn] = t.message), t.stack && (n[Vl] = t.stack)), n[nn] || n[rn] ? e.addEvent(qb, n) : gt(
    "otel",
    "recordException",
    "warn",
    `Failed to record an exception ${t}`
  );
};
class Wb {
  constructor(t) {
    k(this, "organizationID"), k(this, "_options"), k(this, "_integrations", []), k(this, "_gauges", /* @__PURE__ */ new Map()), k(this, "_counters", /* @__PURE__ */ new Map()), k(this, "_histograms", /* @__PURE__ */ new Map()), k(this, "_up_down_counters", /* @__PURE__ */ new Map()), k(this, "sampler", new Xb()), k(this, "_started", !1), k(this, "providers"), k(this, "graphqlSDK"), this._options = t, this.organizationID = t.projectId;
  }
  start() {
    return se(this, null, function* () {
      var t, r, n, i, o, a, u, c, s, l, p, f, m, v, y, g;
      if (this._started)
        return;
      this._started = !0, this.providers = yb(
        {
          backendUrl: (r = (t = this._options) == null ? void 0 : t.backendUrl) != null ? r : "https://pub.observability.app.launchdarkly.com",
          otlpEndpoint: (o = (i = (n = this._options) == null ? void 0 : n.otel) == null ? void 0 : i.otlpEndpoint) != null ? o : "https://otel.observability.app.launchdarkly.com",
          projectId: this._options.projectId,
          sessionSecureId: this._options.sessionSecureId,
          environment: (u = (a = this._options) == null ? void 0 : a.environment) != null ? u : "production",
          networkRecordingOptions: typeof ((c = this._options) == null ? void 0 : c.networkRecording) == "object" ? this._options.networkRecording : void 0,
          tracingOrigins: (s = this._options) == null ? void 0 : s.tracingOrigins,
          serviceName: (p = (l = this._options) == null ? void 0 : l.serviceName) != null ? p : "browser",
          instrumentations: (m = (f = this._options) == null ? void 0 : f.otel) == null ? void 0 : m.instrumentations,
          eventNames: (y = (v = this._options) == null ? void 0 : v.otel) == null ? void 0 : y.eventNames,
          getIntegrations: () => this._integrations
        },
        this.sampler
      );
      const E = new vl(
        (g = this._options.backendUrl) != null ? g : "https://pub.observability.app.launchdarkly.com",
        {
          headers: {}
        }
      );
      this.graphqlSDK = Ul(E, sp()), yield this.configureSampling(), this.setupListeners();
    });
  }
  stop() {
    return se(this, null, function* () {
      var t, r, n, i;
      this._started && (this._started = !1, yield Promise.all([
        (r = (t = this.providers) == null ? void 0 : t.tracerProvider) == null ? void 0 : r.shutdown(),
        (i = (n = this.providers) == null ? void 0 : n.meterProvider) == null ? void 0 : i.shutdown()
      ]));
    });
  }
  configureSampling() {
    return se(this, null, function* () {
      try {
        const t = yield this.graphqlSDK.GetSamplingConfig({
          organization_verbose_id: `${this.organizationID}`
        });
        this.sampler.setConfig(t.sampling);
      } catch (t) {
        Rt(
          "sampling",
          "warn",
          `LaunchDarkly Observability: Failed to configure sampling: ${t}`
        );
      }
    });
  }
  _recordLog(t, r, n, i) {
    this.startSpan(Yu, (o) => {
      const a = typeof t == "string" ? t : Ce(t), u = i ? Ce(i.map((c) => c.toString())) : void 0;
      if (o?.addEvent("log", M({
        [Ju]: r,
        [Qu]: a,
        "code.stacktrace": u
      }, n)), this._options.reportConsoleErrors && r === "error") {
        o?.recordException(new Error(a)), o?.setStatus({
          code: Rr.ERROR,
          message: a
        });
        const c = new Error(a);
        i && (c.stack = u), this.recordError(c);
      }
    });
  }
  _recordErrorMessage(t, r) {
    this.startSpan("highlight.exception", (n) => {
      var i;
      Kb(n, (i = t.error) != null ? i : new Error(t.event), {
        [mb]: t.id
      }), n?.setAttributes(M({
        event: t.event,
        type: t.type,
        url: t.url,
        source: t.source,
        lineNumber: t.lineNumber,
        columnNumber: t.columnNumber
      }, r));
    });
    for (const n of this._integrations)
      n.error(Ot(), t);
  }
  recordError(t, r, n, i, o) {
    var a, u, c, s;
    t = t || new Error("Unknown error"), t instanceof Error && t.cause && (n = et(M({}, n), {
      "exception.cause": JSON.stringify(t.cause)
    }));
    let l = r ? r + ":" + t.message : t.message;
    o === "React.ErrorBoundary" && (l = "ErrorBoundary: " + l);
    const p = Hr(t), f = {
      error: t,
      event: l,
      type: o ?? "custom",
      url: window.location.href,
      source: i ?? "",
      lineNumber: (a = p[0]) != null && a.lineNumber ? (u = p[0]) == null ? void 0 : u.lineNumber : 0,
      columnNumber: (c = p[0]) != null && c.columnNumber ? (s = p[0]) == null ? void 0 : s.columnNumber : 0,
      stackTrace: p,
      timestamp: (/* @__PURE__ */ new Date()).toISOString(),
      id: Rs()
    };
    this._recordErrorMessage(f, n);
  }
  recordCount(t) {
    const r = pt.getMeter(lr);
    let n = this._counters.get(t.name);
    n || (n = r.createCounter(t.name), this._counters.set(t.name, n)), n.add(t.value, et(M({}, t.attributes), {
      "highlight.session_id": Ot()
    }));
  }
  recordGauge(t) {
    var r, n, i;
    const o = pt.getMeter(lr);
    let a = this._gauges.get(t.name);
    a || (a = o.createGauge(t.name), this._gauges.set(t.name, a)), a.record(t.value, et(M({}, t.attributes), {
      "highlight.session_id": Ot()
    }));
    const u = {
      name: t.name,
      value: t.value,
      category: (r = t.attributes) == null ? void 0 : r.category,
      group: (i = (n = t.attributes) == null ? void 0 : n.group) == null ? void 0 : i.toString(),
      tags: t.attributes ? Object.entries(t.attributes).map(([c, s]) => {
        var l;
        return {
          name: c ?? "",
          value: (l = s?.toString()) != null ? l : ""
        };
      }) : []
    };
    for (const c of this._integrations)
      c.recordGauge(
        Ot(),
        u
      );
  }
  recordIncr(t) {
    this.recordCount(et(M({}, t), { value: 1 }));
  }
  recordHistogram(t) {
    const r = pt.getMeter(lr);
    let n = this._histograms.get(t.name);
    n || (n = r.createHistogram(t.name), this._histograms.set(t.name, n)), n.record(t.value, et(M({}, t.attributes), {
      "highlight.session_id": Ot()
    }));
  }
  recordUpDownCounter(t) {
    const r = pt.getMeter(lr);
    let n = this._up_down_counters.get(t.name);
    n || (n = r.createUpDownCounter(t.name), this._up_down_counters.set(t.name, n)), n.add(t.value, et(M({}, t.attributes), {
      "highlight.session_id": Ot()
    }));
  }
  startSpan(t, r, n, i) {
    const o = Ma();
    if (!o) {
      const u = Ja();
      return i === void 0 && n === void 0 ? r(u) : i === void 0 ? n(u) : i(u);
    }
    const a = (u, c) => {
      const s = c(u);
      return s instanceof Promise ? s.finally(() => u.end()) : (u.end(), s);
    };
    return i === void 0 && n === void 0 ? o.startActiveSpan(
      t,
      (u) => a(u, r)
    ) : i === void 0 ? o.startActiveSpan(
      t,
      r,
      (u) => a(u, n)
    ) : o.startActiveSpan(
      t,
      r,
      n,
      (u) => a(u, i)
    );
  }
  startManualSpan(t, r, n, i) {
    const o = Ma();
    if (!o) {
      const a = Ja();
      return i === void 0 && n === void 0 ? r(a) : i === void 0 ? n(a) : i(a);
    }
    return i === void 0 && n === void 0 ? o.startActiveSpan(t, r) : i === void 0 ? o.startActiveSpan(
      t,
      r,
      n
    ) : o.startActiveSpan(
      t,
      r,
      n,
      i
    );
  }
  register(t, r) {
    this._integrations.push(new Op(t, r));
  }
  getHooks(t) {
    return this._integrations.flatMap((r) => {
      var n, i;
      return (i = (n = r.getHooks) == null ? void 0 : n.call(r, t)) != null ? i : [];
    });
  }
  submitViewportMetrics({
    height: t,
    width: r,
    availHeight: n,
    availWidth: i
  }) {
    this.recordGauge({
      name: xt.ViewportHeight,
      value: t,
      attributes: {
        category: nt.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: xt.ViewportWidth,
      value: r,
      attributes: {
        category: nt.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: xt.ScreenHeight,
      value: n,
      attributes: {
        category: nt.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: xt.ScreenWidth,
      value: i,
      attributes: {
        category: nt.Device,
        group: window.location.href
      }
    }), this.recordGauge({
      name: xt.ViewportArea,
      value: t * r,
      attributes: {
        category: nt.Device,
        group: window.location.href
      }
    });
  }
  setupListeners() {
    var t;
    this._options.disableConsoleRecording || Fp(
      (n) => {
        var i;
        this._recordLog(
          (i = n.value) == null ? void 0 : i.join(" "),
          n.type,
          n.attributes ? JSON.parse(n.attributes) : {},
          n.trace
        );
      },
      {
        level: (t = this._options.consoleMethodsToRecord) != null ? t : [
          ...jl
        ],
        logger: "console",
        stringifyOptions: {
          depthOfLimit: 10,
          numOfKeysLimit: 100,
          stringLengthLimit: 1e3
        }
      }
    ), this._options.enablePerformanceRecording !== !1 && (Lb((n) => {
      Object.entries(n).filter(([i]) => i !== "relativeTimestamp").forEach(
        ([i, o]) => o && this.recordGauge({
          name: i,
          value: o,
          attributes: {
            category: nt.Performance,
            group: window.location.href
          }
        })
      );
    }, 0), wb((n) => {
      this.recordGauge({
        name: "Jank",
        value: n.jankAmount,
        attributes: {
          category: nt.WebVital,
          group: n.querySelector
        }
      });
    }, 0)), Yp(
      (n) => {
        var i;
        if (Qp.includes(n.event) || Zp.some(
          (u) => n.event.includes(u)
        ))
          return;
        const o = new Error(n.event);
        o.stack = Ce(n.stackTrace.map((u) => u.toString()));
        let a = {};
        try {
          n.payload && (a = JSON.parse(n.payload));
        } catch {
        }
        this._recordErrorMessage(
          et(M({}, n), { error: (i = n.error) != null ? i : o }),
          a
        );
      },
      { enablePromisePatch: !!this._options.enablePromisePatch }
    ), $b((n) => {
      const { name: i, value: o } = n;
      this.recordGauge({
        name: i,
        value: o,
        attributes: {
          group: window.location.href,
          category: nt.WebVital
        }
      });
    }), Rp((n) => {
      this.submitViewportMetrics(n);
    }), Bb((n) => {
      const i = {
        category: nt.Performance,
        group: window.location.href
      };
      n.saveData !== void 0 && (i.saveData = n.saveData.toString()), n.effectiveType !== void 0 && (i.effectiveType = n.effectiveType.toString()), n.type !== void 0 && (i.type = n.type.toString()), Object.entries(n).filter(([o]) => o !== "relativeTimestamp").forEach(([o, a]) => {
        Fl(a) && this.recordGauge({
          name: o,
          value: a,
          attributes: i
        });
      });
    }, (/* @__PURE__ */ new Date()).getTime());
    const { getDeviceDetails: r } = Fb();
    r && this.recordGauge({
      name: xt.DeviceMemory,
      value: r().deviceMemory,
      attributes: {
        category: nt.Device,
        group: window.location.href
      }
    });
  }
  recordLog(t, r, n) {
    return this._recordLog(t, r, n);
  }
}
class s0 extends Pp {
  constructor(t) {
    super(t), k(this, "observe"), k(this, "options"), this.options = t;
  }
  initialize(t, r) {
    try {
      if (typeof window > "u" || typeof document > "u") {
        console.warn(
          "@launchdarkly/observability is not initializing because it is not supported in this environment."
        );
        return;
      }
      if (!t) {
        console.warn(
          "@launchdarkly/observability is not initializing because the SDK credential is undefined."
        );
        return;
      }
      this.configureSession(t, r), this.observe = new Wb(et(M({}, r), {
        projectId: t,
        sessionSecureId: this.sessionSecureID
      })), r != null && r.manualStart || this.observe.start(), ne.load(this.observe);
    } catch (n) {
      Rt(
        "Error initializing @launchdarkly/observability SDK",
        "error",
        n
      );
    }
  }
  getMetadata() {
    return {
      name: "@launchdarkly/observability"
    };
  }
  register(t, r) {
    var n;
    (n = this.observe) == null || n.register(t, r);
  }
  getHooks(t) {
    var r, n, i, o;
    const a = M(M({
      [Hl]: t.sdk.name,
      [zl]: t.sdk.version,
      [cp]: t.clientSideId,
      [dp]: "LaunchDarkly"
    }, (r = t.application) != null && r.id ? { [mp]: t.application.id } : {}), (n = t.application) != null && n.version ? {
      [yp]: t.application.version
    } : {});
    return this.initialize(
      (o = (i = t.sdkKey) != null ? i : t.mobileKey) != null ? o : t.clientSideId,
      this.options
    ), [
      {
        getMetadata: () => ({
          name: "@launchdarkly/observability/hooks"
        }),
        afterIdentify: (u, c, s) => {
          var l, p, f, m, v, y, g, E;
          for (const N of (f = (p = (l = this.observe) == null ? void 0 : l.getHooks) == null ? void 0 : p.call(l, t)) != null ? f : [])
            (m = N.afterIdentify) == null || m.call(N, u, c, s);
          if (s.status === "completed") {
            const N = et(M({}, To(u.context)), {
              key: (g = (y = (v = this.options) == null ? void 0 : v.contextFriendlyName) == null ? void 0 : y.call(
                v,
                u.context
              )) != null ? g : an(u.context),
              timeout: u.timeout,
              canonicalKey: an(u.context),
              [Tp]: s.status
            });
            (E = this.observe) == null || E.recordLog("LD.identify", "info", M(M({}, a), N));
          }
          return c;
        },
        afterEvaluation: (u, c, s) => {
          var l, p, f, m, v;
          for (const E of (f = (p = (l = this.observe) == null ? void 0 : l.getHooks) == null ? void 0 : p.call(l, t)) != null ? f : [])
            (m = E.afterEvaluation) == null || m.call(E, u, c, s);
          const y = M({
            [lp]: u.flagKey,
            [hp]: JSON.stringify(s.value)
          }, s.variationIndex ? {
            [vp]: s.variationIndex
          } : {});
          if (s.reason)
            for (const E in _o) {
              const N = E, j = s.reason[N];
              j && (y[_o[N]] = j);
            }
          u.context && (y[pp] = JSON.stringify(To(u.context)), y[fp] = an(u.context));
          const g = M(M({}, a), y);
          return (v = this.observe) == null || v.startSpan(up, (E) => {
            E && E.addEvent(Y, g);
          }), c;
        },
        afterTrack: (u) => {
          var c, s, l, p, f;
          for (const m of (l = (s = (c = this.observe) == null ? void 0 : c.getHooks) == null ? void 0 : s.call(c, t)) != null ? l : [])
            (p = m.afterTrack) == null || p.call(m, u);
          (f = this.observe) == null || f.recordLog("LD.track", "info", M(et(M({}, a), {
            key: u.key,
            value: u.metricValue
          }), typeof u.data == "object" ? u.data : {}));
        }
      }
    ];
  }
}
export {
  ne as LDObserve,
  s0 as default
};
//# sourceMappingURL=observability.js.map
